// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: 'https://facts.staging.netpurpose.com' | (string & {});
};

/**
 * AcceptedFact
 */
export type AcceptedFact = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * AcceptedFactChange
 */
export type AcceptedFactChange = {
    /**
     * Accepted Fact Change Id
     */
    accepted_fact_change_id: number;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Field Changed
     */
    field_changed: string;
    /**
     * Value Before
     */
    value_before: unknown;
    /**
     * Value After
     */
    value_after: unknown;
    reason: AcceptedFactChangeReason;
    /**
     * Changed On
     */
    changed_on: string;
    /**
     * Fact Year
     */
    fact_year: number;
};

/**
 * AcceptedFactChangeReason
 */
export const AcceptedFactChangeReason = {
    ERROR_IN_PREVIOUS_VALUE: 'Error in previous value',
    RESTATEMENT: 'Restatement',
    UPDATE_TO_NP_METHODOLOGY: 'Update to NP methodology'
} as const;

/**
 * AcceptedFactChangeReason
 */
export type AcceptedFactChangeReason = typeof AcceptedFactChangeReason[keyof typeof AcceptedFactChangeReason];

/**
 * AcceptedFactValues
 */
export type AcceptedFactValues = {
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Year
     */
    year: number;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Question Id
     */
    question_id: number;
    recorded_value: ValueObject;
    standardized_value: ValueObject;
};

/**
 * AlignmentBreakDown
 */
export type AlignmentBreakDown = {
    1: SdgRevenueContribution;
    2: SdgRevenueContribution;
    3: SdgRevenueContribution;
    4: SdgRevenueContribution;
    5: SdgRevenueContribution;
    6: SdgRevenueContribution;
    7: SdgRevenueContribution;
    8: SdgRevenueContribution;
    9: SdgRevenueContribution;
    10: SdgRevenueContribution;
    11: SdgRevenueContribution;
    12: SdgRevenueContribution;
    13: SdgRevenueContribution;
    14: SdgRevenueContribution;
    15: SdgRevenueContribution;
    16: SdgRevenueContribution;
    17: SdgRevenueContribution;
};

/**
 * AnalystStats
 */
export type AnalystStats = {
    /**
     * Analyst Avg Time Spent
     */
    analyst_avg_time_spent?: number | null;
    /**
     * Analyst Std Dev Time Spent
     */
    analyst_std_dev_time_spent?: number | null;
    /**
     * Analyst Error Rate
     */
    analyst_error_rate?: number | null;
};

/**
 * AsyncResultPromise
 */
export type AsyncResultPromise = {
    /**
     * Result Id
     */
    result_id: string;
};

/**
 * AsyncResultPromiseWithError
 */
export type AsyncResultPromiseWithError = {
    /**
     * Result Id
     */
    result_id: string;
    /**
     * Err
     */
    err?: string | null;
};

/**
 * AumAlignmentBreakDown
 */
export type AumAlignmentBreakDown = {
    1: SdgAumContribution;
    2: SdgAumContribution;
    3: SdgAumContribution;
    4: SdgAumContribution;
    5: SdgAumContribution;
    6: SdgAumContribution;
    7: SdgAumContribution;
    8: SdgAumContribution;
    9: SdgAumContribution;
    10: SdgAumContribution;
    11: SdgAumContribution;
    12: SdgAumContribution;
    13: SdgAumContribution;
    14: SdgAumContribution;
    15: SdgAumContribution;
    16: SdgAumContribution;
    17: SdgAumContribution;
};

/**
 * BaseExportOptions
 */
export type BaseExportOptions = {
    /**
     * Should Send Email
     */
    should_send_email?: boolean;
};

/**
 * BaseReportingStandard
 */
export type BaseReportingStandard = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
    /**
     * Full Code
     */
    full_code?: string | null;
    /**
     * Description
     */
    description?: string | null;
};

/**
 * Body_bulk_accept_from_csv
 */
export type BodyBulkAcceptFromCsv = {
    /**
     * File
     */
    file: Blob | File;
};

/**
 * Body_bulk_delete_facts
 */
export type BodyBulkDeleteFacts = {
    /**
     * File
     */
    file: Blob | File;
};

/**
 * Body_create_entities
 */
export type BodyCreateEntities = {
    /**
     * Entities Csv
     */
    entities_csv: Blob | File;
    /**
     * Cohort
     */
    cohort: number;
    /**
     * Force
     */
    force?: boolean;
};

/**
 * Body_create_ingestion_tasks
 */
export type BodyCreateIngestionTasks = {
    /**
     * Ingestion Tasks Csv
     */
    ingestion_tasks_csv: Blob | File;
    /**
     * Phase
     */
    phase: number;
    /**
     * Priority
     */
    priority: number;
    task_type: TaskType;
};

/**
 * Body_create_new_facts
 */
export type BodyCreateNewFacts = {
    /**
     * New Facts Csv
     */
    new_facts_csv: Blob | File;
};

/**
 * Body_create_source_tasks
 */
export type BodyCreateSourceTasks = {
    /**
     * Source Tasks Csv
     */
    source_tasks_csv: Blob | File;
    /**
     * Phase
     */
    phase: number;
    /**
     * Priority
     */
    priority: number;
    task_type: TaskType;
};

/**
 * Body_lookup_entities
 */
export type BodyLookupEntities = {
    /**
     * Security File
     */
    security_file: Blob | File;
};

/**
 * Body_lookup_sfdr
 */
export type BodyLookupSfdr = {
    /**
     * Identifier Type
     */
    identifier_type?: string | null;
    /**
     * Identifier Col
     */
    identifier_col?: string | null;
    /**
     * Security File
     */
    security_file: Blob | File;
};

/**
 * Body_upload_portfolio
 */
export type BodyUploadPortfolio = {
    /**
     * Portfolio Name
     */
    portfolio_name: string;
    /**
     * Total Value
     */
    total_value: number;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Lcu
     */
    lcu?: string | null;
    portfolio_type?: DirectHoldingsPortfolioUploadTypes;
    /**
     * Identifier Col
     */
    identifier_col?: string;
    /**
     * Weight Col
     */
    weight_col?: string;
    /**
     * Name Col
     */
    name_col?: string;
    /**
     * Portfolio File
     */
    portfolio_file: Blob | File;
};

/**
 * Body_upload_portfolio_with_fund_holdings
 */
export type BodyUploadPortfolioWithFundHoldings = {
    /**
     * Portfolio Name
     */
    portfolio_name: string;
    /**
     * Total Value
     */
    total_value: number;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Lcu
     */
    lcu?: string | null;
    /**
     * Identifier Col
     */
    identifier_col?: string;
    /**
     * Weight Col
     */
    weight_col?: string;
    /**
     * Name Col
     */
    name_col?: string;
    /**
     * Portfolio File
     */
    portfolio_file: Blob | File;
};

/**
 * Body_upload_sector_to_taxonomy
 */
export type BodyUploadSectorToTaxonomy = {
    /**
     * Upload File
     */
    upload_file: Blob | File;
};

/**
 * Body_upload_segment_to_taxonomy
 */
export type BodyUploadSegmentToTaxonomy = {
    /**
     * Upload File
     */
    upload_file: Blob | File;
};

/**
 * Body_upload_source_from_file
 */
export type BodyUploadSourceFromFile = {
    /**
     * File
     */
    file: Blob | File;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Original Url
     */
    original_url?: string | null;
    report_type: ReportTypes;
    /**
     * File Type
     *
     * @deprecated
     */
    file_type?: string;
    /**
     * End
     */
    end: string;
    /**
     * Start
     */
    start?: string | null;
    status?: SourceStatus | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
};

/**
 * Body_upload_taxonomy_alignment
 */
export type BodyUploadTaxonomyAlignment = {
    /**
     * Upload File
     */
    upload_file: Blob | File;
};

/**
 * CalculationTree
 *
 * Children will only be a list with entries if data_origin == "calculated".
 */
export type CalculationTree = {
    value: KpiValue;
    date?: Date | null;
    /**
     * Data Origin
     */
    data_origin?: DataOrigin | DataOriginStr;
    operation?: KpiCalculationOperation | null;
    /**
     * Children
     */
    children?: Array<CalculationTree> | null;
};

/**
 * CompanyCoverage
 */
export type CompanyCoverage = {
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Theme
     */
    theme: string;
    /**
     * Year
     */
    year?: number | null;
    /**
     * Fact Count
     */
    fact_count: number;
    /**
     * Expected Count
     */
    expected_count: number;
};

/**
 * CompareDataExport
 */
export type CompareDataExport = {
    /**
     * Snapshot Ids
     */
    snapshot_ids?: Array<number>;
    /**
     * Entity Ids
     */
    entity_ids?: Array<number>;
    /**
     * Metrics Config Id
     */
    metrics_config_id: string;
};

/**
 * CopyPortfolioRequest
 */
export type CopyPortfolioRequest = {
    /**
     * New Group Ids
     */
    new_group_ids: Array<string>;
};

/**
 * CopyPortfolioResponse
 */
export type CopyPortfolioResponse = {
    /**
     * Msg
     */
    msg: string;
    /**
     * New Portfolio Ids
     */
    new_portfolio_ids: Array<number>;
};

/**
 * CreateEntity
 */
export type CreateEntity = {
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
};

/**
 * CreateFactSet
 */
export type CreateFactSet = {
    /**
     * Theme
     */
    theme: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
};

/**
 * CreateKeyword
 */
export type CreateKeyword = {
    /**
     * Text
     */
    text: string;
};

/**
 * CreateReference
 */
export type CreateReference = {
    /**
     * Source Id
     */
    source_id: number;
    source?: Source | null;
    /**
     * Page Num
     */
    page_num?: number | null;
    /**
     * Highlight Areas
     */
    highlight_areas?: Array<HighlightArea> | null;
};

/**
 * CreateSDGRevenuePipelineApprovalRequest
 */
export type CreateSdgRevenuePipelineApprovalRequest = {
    /**
     * Is Approved
     */
    is_approved: boolean;
    /**
     * Comments
     */
    comments?: string | null;
    /**
     * Date Approved
     *
     *
     * Date of the specific dataset which has been approved to be migrated
     * to the main table. Will default to latest available if not provided.
     *
     */
    date_approved?: string | null;
};

/**
 * CreateSegment
 */
export type CreateSegment = {
    /**
     * Segment Category
     */
    segment_category: string;
    /**
     * Segment Class
     */
    segment_class: string;
    /**
     * Segment Instance
     */
    segment_instance: string;
};

/**
 * CreateSemanticSearchFeedback
 */
export type CreateSemanticSearchFeedback = {
    /**
     * Query
     */
    query: string;
    /**
     * Matched Text
     */
    matched_text: string;
    /**
     * Source Id
     */
    source_id: number;
    /**
     * Page Num
     */
    page_num: number;
    /**
     * Feedback
     */
    feedback: boolean;
};

/**
 * CreateSource
 */
export type CreateSource = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end?: string | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
    /**
     * Original Url
     */
    original_url?: string | null;
    /**
     * Url
     */
    url: string;
    report_type?: ReportTypes | null;
    file_type: SourceType;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Checksum
     */
    checksum?: string | null;
    status?: SourceStatus;
    /**
     * Language
     */
    language?: string | null;
};

/**
 * CreateUnit
 */
export type CreateUnit = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Iso Code
     */
    iso_code?: string | null;
    /**
     * Is Standard
     */
    is_standard?: boolean | null;
    /**
     * Standard Id
     */
    standard_id?: number | null;
    /**
     * Conversion Factor
     */
    conversion_factor?: number | null;
    /**
     * Unit Type
     */
    unit_type?: string | null;
};

/**
 * CreateWatchlist
 */
export type CreateWatchlist = {
    /**
     * Name
     */
    name: string;
    /**
     * Entity Ids
     */
    entity_ids: Array<number>;
    /**
     * Total Value
     */
    total_value?: number;
    /**
     * Valuation Date
     */
    valuation_date?: string;
    type?: PortfolioTypes;
};

/**
 * CurrencyValue
 */
export type CurrencyValue = {
    /**
     * Value
     */
    value: number;
    unit: Unit;
    /**
     * Fx Rate
     */
    fx_rate?: number | null;
};

/**
 * DataDictionaryQuestion
 */
export type DataDictionaryQuestion = {
    /**
     * Question Id
     */
    question_id?: number | null;
    type: QuestionType1;
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Unit Id
     */
    unit_id?: number | null;
    /**
     * Is Reported
     */
    is_reported?: boolean;
    /**
     * Is Estimated
     */
    is_estimated?: boolean;
    impact_level?: ImpactLevel | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Is Sdg Eligible
     */
    is_sdg_eligible?: boolean | null;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    /**
     * Display Themes
     */
    display_themes: Array<DisplayThemeWithSdg>;
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    goal?: Goal | null;
    /**
     * Is Adjusted Sdg Revenue
     */
    is_adjusted_sdg_revenue?: boolean;
    /**
     * Is Unadjusted Sdg Revenue
     */
    is_unadjusted_sdg_revenue?: boolean;
    /**
     * Canonical Id
     */
    canonical_id?: string | null;
};

/**
 * DataOrigin
 */
export type DataOrigin = {
    data_source: DataOriginSource;
    /**
     * Data Source Id
     */
    data_source_id?: number | string | null;
    question?: OriginQuestion | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
};

/**
 * DataOriginSource
 */
export const DataOriginSource = {
    ACCEPTED_FACTS: 'accepted_facts',
    ACCEPTED_SUPPORTING_FACTS: 'accepted_supporting_facts',
    MACRO_FACTORS: 'macro_factors',
    KPI_RESULTS: 'kpi_results',
    SEGMENT_REVENUE: 'segment_revenue',
    AD_HOC: 'ad_hoc'
} as const;

/**
 * DataOriginSource
 */
export type DataOriginSource = typeof DataOriginSource[keyof typeof DataOriginSource];

/**
 * DataOriginStr
 */
export const DataOriginStr = { CALCULATED: 'calculated', LITERAL: 'literal' } as const;

/**
 * DataOriginStr
 */
export type DataOriginStr = typeof DataOriginStr[keyof typeof DataOriginStr];

/**
 * DataType
 */
export const DataType = {
    CALCULATED: 'Calculated',
    ESTIMATED: 'Estimated',
    FUND_ROLLUP: 'Fund Rollup',
    NOT_DISCLOSED: 'Not Disclosed',
    REPORTED: 'Reported',
    REVENUE: 'Revenue',
    REVENUE_FACT_SET: 'Revenue FactSet',
    REVENUE_FUND_ROLLUP: 'Revenue Fund Rollup'
} as const;

/**
 * DataType
 */
export type DataType = typeof DataType[keyof typeof DataType];

/**
 * Date
 */
export type Date = {
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
};

/**
 * Detail
 */
export type Detail = {
    /**
     * Detail
     */
    detail: string;
};

/**
 * DirectHoldingsPortfolioUploadTypes
 */
export const DirectHoldingsPortfolioUploadTypes = {
    BENCHMARK: 'benchmark',
    FUND: 'fund',
    PRIVATE: 'private'
} as const;

/**
 * DirectHoldingsPortfolioUploadTypes
 */
export type DirectHoldingsPortfolioUploadTypes = typeof DirectHoldingsPortfolioUploadTypes[keyof typeof DirectHoldingsPortfolioUploadTypes];

/**
 * DisplayTheme
 *
 *
 * Themes as displayed to clients.
 *
 */
export const DisplayTheme = {
    AFFORDABLE_HOUSING: 'Affordable housing',
    AIR_POLLUTION: 'Air pollution',
    CIRCULAR_ECONOMY: 'Circular economy',
    CLIMATE_CHANGE: 'Climate change',
    DECENT_WORK: 'Decent work',
    DIVERSITY: 'Diversity',
    EDUCATION: 'Education',
    ENERGY: 'Energy',
    FINANCIAL_DATA: 'Financial data',
    FINANCIAL_INCLUSION: 'Financial inclusion',
    GOVERNANCE: 'Governance',
    HEALTH_AND_WELLBEING: 'Health and wellbeing',
    HUMAN_RIGHTS: 'Human rights',
    INDUSTRY_AND_INNOVATION: 'Industry and innovation',
    LAND: 'Land',
    WATER: 'Water'
} as const;

/**
 * DisplayTheme
 *
 *
 * Themes as displayed to clients.
 *
 */
export type DisplayTheme = typeof DisplayTheme[keyof typeof DisplayTheme];

/**
 * DisplayThemeWithSDG
 */
export const DisplayThemeWithSdg = {
    AFFORDABLE_HOUSING: 'Affordable housing',
    AIR_POLLUTION: 'Air pollution',
    CIRCULAR_ECONOMY: 'Circular economy',
    CLIMATE_CHANGE: 'Climate change',
    DECENT_WORK: 'Decent work',
    DIVERSITY: 'Diversity',
    EDUCATION: 'Education',
    ENERGY: 'Energy',
    FINANCIAL_DATA: 'Financial data',
    FINANCIAL_INCLUSION: 'Financial inclusion',
    GOVERNANCE: 'Governance',
    HEALTH_AND_WELLBEING: 'Health and wellbeing',
    HUMAN_RIGHTS: 'Human rights',
    INDUSTRY_AND_INNOVATION: 'Industry and innovation',
    LAND: 'Land',
    SDG: 'SDG',
    WATER: 'Water'
} as const;

/**
 * DisplayThemeWithSDG
 */
export type DisplayThemeWithSdg = typeof DisplayThemeWithSdg[keyof typeof DisplayThemeWithSdg];

/**
 * DocumentLabelsResponse
 */
export type DocumentLabelsResponse = {
    /**
     * Model Id
     */
    model_id: string;
    /**
     * Confidence Per Label
     */
    confidence_per_label: {
        [key: string]: number;
    };
};

/**
 * DownloadableFileRequest
 */
export type DownloadableFileRequest = {
    /**
     * Result Id
     */
    result_id: string;
    /**
     * File Display Name
     */
    file_display_name: string;
};

/**
 * EmbedSources
 */
export type EmbedSources = {
    /**
     * Source Ids
     */
    source_ids: Array<number>;
};

/**
 * Entity
 */
export type Entity = {
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityActivityContribution
 */
export type EntityActivityContribution = {
    /**
     * Entity Sdi Revenue Id
     */
    entity_sdi_revenue_id?: string | null;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Activity Name
     */
    activity_name?: string | null;
    taxon_type?: TaxonType | null;
    contribution_type: SdgAlignmentType;
    /**
     * Revenue Usd
     */
    revenue_usd: number;
    /**
     * Revenue Percentage
     */
    revenue_percentage: number;
    data_origin: SdgDataOrigin;
    /**
     * Primary Sdg Major Code
     */
    primary_sdg_major_code?: number | null;
    /**
     * Additional Sdg Major Codes
     */
    additional_sdg_major_codes?: Array<number> | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Excluded
     */
    excluded?: boolean | null;
};

/**
 * EntityActivityContributionByTaxon
 */
export type EntityActivityContributionByTaxon = {
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Children
     */
    children: Array<EntityActivityContributionChild>;
};

/**
 * EntityActivityContributionChild
 */
export type EntityActivityContributionChild = {
    /**
     * Value
     */
    value: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * End
     */
    end: string;
    /**
     * Taxon Name
     */
    taxon_name: string;
    data_origin: SdgDataOrigin;
    /**
     * Factoid Origin Id
     */
    factoid_origin_id?: number | string | null;
    /**
     * Supporting Origin Id
     */
    supporting_origin_id?: number | null;
    /**
     * Datapoint Id
     */
    datapoint_id?: string | null;
    /**
     * Raw
     */
    raw?: boolean | null;
};

/**
 * EntityActivityContributionSummary
 *
 * The buckets aggregate the activities by contribution type, so the donut and
 * its legend can be drawn without summing the activity rows. Excluded
 * activities are left out of them, matching total_contributing_revenue_usd.
 */
export type EntityActivityContributionSummary = {
    /**
     * Total Contributing Revenue Usd
     */
    total_contributing_revenue_usd: number;
    /**
     * Total Revenue Usd
     */
    total_revenue_usd: number;
    positive: SdgRevenueContribution;
    potential: SdgRevenueContribution;
    negative: SdgRevenueContribution;
    not_covered: SdgRevenueContribution;
    potentially_positive: SdgRevenueContribution;
    potentially_negative: SdgRevenueContribution;
    /**
     * Activities
     */
    activities?: Array<EntityActivityContribution> | null;
};

/**
 * EntityBreakdownByFunds
 */
export type EntityBreakdownByFunds = {
    /**
     * Funds
     */
    funds: Array<EntityBreakdownPerFund>;
    total: EntityWeightAndValue;
};

/**
 * EntityBreakdownPerFund
 */
export type EntityBreakdownPerFund = {
    /**
     * Entity Weight
     */
    entity_weight: number;
    /**
     * Entity Value
     */
    entity_value?: number | null;
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Holding Weight
     */
    holding_weight: number;
};

/**
 * EntityDashboardExport
 */
export type EntityDashboardExport = {
    /**
     * Entity Id
     */
    entity_id: number;
    export_options?: ExportOptions | null;
};

/**
 * EntityEstimationSummary
 */
export type EntityEstimationSummary = {
    /**
     * Has Estimated Data
     */
    has_estimated_data: boolean;
    /**
     * Has Research
     */
    has_research: boolean;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Ids
     */
    technology_ids?: Array<string> | null;
};

/**
 * EntityIdentification
 */
export type EntityIdentification = {
    /**
     * Identifier
     */
    identifier: string;
    /**
     * Matched On
     */
    matched_on: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Is Active
     */
    is_active: boolean;
};

/**
 * EntityIdentifierEntry
 */
export type EntityIdentifierEntry = {
    /**
     * Identifier Type
     */
    identifier_type: string;
    /**
     * Value
     */
    value: string;
};

/**
 * EntityIdentifierSearchData
 */
export type EntityIdentifierSearchData = {
    /**
     * Type
     */
    type: string;
    /**
     * Value
     */
    value: string;
};

/**
 * EntityImpactData
 */
export type EntityImpactData = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Canonical Id
     */
    canonical_id?: string | null;
    /**
     * Display Themes
     */
    display_themes?: Array<DisplayThemeWithSdg> | null;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Year On Year
     */
    year_on_year?: [
        number | null,
        string
    ] | null;
    /**
     * Intensity
     */
    intensity?: [
        number | null,
        string
    ] | null;
    /**
     * Revenue Intensity
     */
    revenue_intensity?: [
        number | null,
        string
    ] | null;
    goal?: Goal | null;
    impact_level?: ImpactLevel | null;
    /**
     * Is Nd
     */
    is_nd?: boolean;
    /**
     * Sdg Goals
     */
    sdg_goals?: Array<ReportingStandardMajorDetails>;
    /**
     * Sdg Targets
     */
    sdg_targets?: Array<BaseReportingStandard>;
    /**
     * Is Contributing
     */
    is_contributing?: boolean | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Sdg Revenue Percentage
     */
    sdg_revenue_percentage?: [
        number | null,
        string
    ] | null;
    /**
     * Kpi Id
     */
    kpi_id?: string | null;
    /**
     * Is Derived
     */
    is_derived?: boolean;
    /**
     * Absolute
     */
    absolute?: [
        number | null,
        string
    ] | null;
    factoid_origin?: FactoidOrigin | null;
};

/**
 * EntityMergeReason
 */
export const EntityMergeReason = {
    MERGER_ABSORPTION: 'Merger - absorption',
    MERGER_AMALGAMATION: 'Merger - amalgamation',
    DUPLICATE_ENTITY: 'Duplicate entity',
    RELISTING_ENTITY: 'Relisting entity'
} as const;

/**
 * EntityMergeReason
 */
export type EntityMergeReason = typeof EntityMergeReason[keyof typeof EntityMergeReason];

/**
 * EntityRevenueAlignment
 */
export type EntityRevenueAlignment = {
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Entity Name
     */
    entity_name: string;
    /**
     * Primary Isin
     */
    primary_isin: string;
    /**
     * Is Covered By Np
     */
    is_covered_by_np: boolean;
    /**
     * Year
     */
    year: number;
    /**
     * Total Revenue Amount Usd
     */
    total_revenue_amount_usd: number;
    positive: SdgRevenueContribution;
    potentially_positive: SdgRevenueContribution;
    negative: SdgRevenueContribution;
    potentially_negative: SdgRevenueContribution;
    potential: SdgRevenueContribution;
    not_covered: SdgRevenueContribution;
    positive_primary_sdg_breakdown: AlignmentBreakDown;
    positive_additional_sdg_breakdown: AlignmentBreakDown;
};

/**
 * EntitySDGContributions
 */
export type EntitySdgContributions = {
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Entity Name
     */
    entity_name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Contributing Sdgs
     */
    contributing_sdgs: Array<Sdg>;
};

/**
 * EntitySDIActivityContribution
 */
export type EntitySdiActivityContribution = {
    /**
     * Entity Sdi Revenue Id
     */
    entity_sdi_revenue_id: string;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Activity Name
     */
    activity_name?: string | null;
    taxon_type?: TaxonType | null;
    contribution_type: SdgAlignmentType;
    /**
     * Revenue Usd
     */
    revenue_usd: number;
    /**
     * Revenue Percentage
     */
    revenue_percentage: number;
    data_origin: SdgDataOrigin;
    /**
     * Primary Sdg Major Code
     */
    primary_sdg_major_code?: number | null;
    /**
     * Additional Sdg Major Codes
     */
    additional_sdg_major_codes?: Array<number> | null;
    /**
     * Reporting End Date
     */
    reporting_end_date?: string | null;
    /**
     * Excluded
     */
    excluded?: boolean | null;
    /**
     * Formula Taxon Name
     */
    formula_taxon_name?: string | null;
    /**
     * Formula Taxon Id
     */
    formula_taxon_id?: number | null;
};

/**
 * EntitySDIActivityExplanation
 */
export type EntitySdiActivityExplanation = {
    /**
     * Entity Sdi Revenue Id
     */
    entity_sdi_revenue_id: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Year
     */
    year: number;
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    /**
     * Activity Name
     */
    activity_name?: string | null;
    contribution_type: SdgAlignmentType;
    /**
     * Revenue Usd
     */
    revenue_usd: number;
    /**
     * Revenue Percentage
     */
    revenue_percentage: number;
    source: SdiRevenueSource;
    /**
     * Evidence
     */
    evidence: Array<SdiActivityEvidence>;
};

/**
 * EntitySDIRevenueContribution
 */
export type EntitySdiRevenueContribution = {
    /**
     * Total Revenue Usd
     */
    total_revenue_usd: number;
    /**
     * Total Contributing Revenue Usd
     */
    total_contributing_revenue_usd: number;
    positive: SdgRevenueContribution;
    potential: SdgRevenueContribution;
    negative: SdgRevenueContribution;
    not_covered: SdgRevenueContribution;
    potentially_positive: SdgRevenueContribution;
    potentially_negative: SdgRevenueContribution;
    /**
     * Activities
     */
    activities?: Array<EntitySdiActivityContribution> | null;
};

/**
 * EntitySdiClassificationType
 */
export const EntitySdiClassificationType = {
    CAR_MANUFACTURERS: 'Car_manufacturers',
    CONTROVERSIAL_WEAPONS: 'Controversial_weapons',
    DEVELOPMENT_BANK: 'Development_bank',
    INDUSTRY_CODE: 'Industry_code',
    MINING: 'Mining',
    NO_SDI_INSIGNIFICANT_REVENUE: 'No_SDI_insignificant_revenue',
    NO_SDI_TOPIC_SCORE: 'No_SDI_topic_score',
    REAL_ESTATE: 'Real_estate',
    RETAIL_BANK: 'Retail_bank',
    REVENUE_SEGMENTATION: 'Revenue_segmentation',
    TELCO_SATELLITE_FORMULA: 'Telco_satellite_formula',
    UTILITIES_FORMULA: 'Utilities_formula',
    UTILITIES_FORMULA_GRID: 'Utilities_formula_grid',
    UTILITIES_MULTI_UTIL: 'Utilities_multi_util'
} as const;

/**
 * EntitySdiClassificationType
 */
export type EntitySdiClassificationType = typeof EntitySdiClassificationType[keyof typeof EntitySdiClassificationType];

/**
 * EntitySearchData
 */
export type EntitySearchData = {
    /**
     * Identifiers
     */
    identifiers: Array<EntityIdentifierSearchData> | null;
    /**
     * Isin
     */
    isin: string | null;
};

/**
 * EntityType
 */
export const EntityType = {
    BOND: 'bond',
    COMPANY: 'company',
    PRIVATE: 'private'
} as const;

/**
 * EntityType
 */
export type EntityType = typeof EntityType[keyof typeof EntityType];

/**
 * EntityValues
 */
export type EntityValues = {
    impact?: ValueObject | null;
    revenue_intensity?: ValueObject | null;
    evic_intensity?: ValueObject | null;
    impact_yoy?: ValueObject | null;
    impact_yoy_delta?: ValueObject | null;
    sdg_revenue_percentage?: ValueObject | null;
};

/**
 * EntityWeightAndValue
 */
export type EntityWeightAndValue = {
    /**
     * Entity Weight
     */
    entity_weight: number;
    /**
     * Entity Value
     */
    entity_value?: number | null;
};

/**
 * EntityWithEstimationAndSDG
 */
export type EntityWithEstimationAndSdg = {
    /**
     * Contributing Revenue Pct
     */
    contributing_revenue_pct?: number | null;
    /**
     * Potential Revenue Pct
     */
    potential_revenue_pct?: number | null;
    /**
     * Negative Revenue Pct
     */
    negative_revenue_pct?: number | null;
    /**
     * Potentially Positive Revenue Pct
     */
    potentially_positive_revenue_pct?: number | null;
    /**
     * Potentially Negative Revenue Pct
     */
    potentially_negative_revenue_pct?: number | null;
    /**
     * Has Estimated Data
     */
    has_estimated_data: boolean;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityWithEstimationSDGAndSdi
 */
export type EntityWithEstimationSdgAndSdi = {
    sdi_classification?: SdiClassificationName | null;
    /**
     * Sdi Classification Confidence
     */
    sdi_classification_confidence?: number | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Contributing Revenue Pct
     */
    contributing_revenue_pct?: number | null;
    /**
     * Potential Revenue Pct
     */
    potential_revenue_pct?: number | null;
    /**
     * Negative Revenue Pct
     */
    negative_revenue_pct?: number | null;
    /**
     * Potentially Positive Revenue Pct
     */
    potentially_positive_revenue_pct?: number | null;
    /**
     * Potentially Negative Revenue Pct
     */
    potentially_negative_revenue_pct?: number | null;
    /**
     * Has Estimated Data
     */
    has_estimated_data: boolean;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityWithEstimationsCoverage
 */
export type EntityWithEstimationsCoverage = {
    /**
     * Has Estimated Data
     */
    has_estimated_data: boolean;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityWithEstimationsCoverageAndSdi
 */
export type EntityWithEstimationsCoverageAndSdi = {
    sdi_classification?: SdiClassificationName | null;
    /**
     * Sdi Classification Confidence
     */
    sdi_classification_confidence?: number | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Has Estimated Data
     */
    has_estimated_data: boolean;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityWithOptionalDetails
 */
export type EntityWithOptionalDetails = {
    sdi_classification?: SdiClassificationName | null;
    /**
     * Sdi Classification Confidence
     */
    sdi_classification_confidence?: number | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Sdi Segments
     */
    sdi_segments?: Array<string> | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Market Cap
     */
    market_cap?: number | null;
    /**
     * Latest Report
     */
    latest_report?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EntityWithOptionalDetailsAndSDGRevenuePct
 */
export type EntityWithOptionalDetailsAndSdgRevenuePct = {
    sdi_classification?: SdiClassificationName | null;
    /**
     * Sdi Classification Confidence
     */
    sdi_classification_confidence?: number | null;
    sdi_classification_type?: EntitySdiClassificationType | null;
    /**
     * Contributing Revenue Pct
     */
    contributing_revenue_pct?: number | null;
    /**
     * Potential Revenue Pct
     */
    potential_revenue_pct?: number | null;
    /**
     * Negative Revenue Pct
     */
    negative_revenue_pct?: number | null;
    /**
     * Potentially Positive Revenue Pct
     */
    potentially_positive_revenue_pct?: number | null;
    /**
     * Potentially Negative Revenue Pct
     */
    potentially_negative_revenue_pct?: number | null;
    /**
     * Market Cap
     */
    market_cap?: number | null;
    /**
     * Latest Report
     */
    latest_report?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Headquarters
     */
    headquarters?: string | null;
    /**
     * Sector
     */
    sector?: string | null;
    /**
     * Industry
     */
    industry?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    type?: EntityType;
    /**
     * Parent Id
     */
    parent_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Data Origin Urls
     */
    data_origin_urls?: Array<string> | null;
    /**
     * Is Covered
     */
    is_covered: boolean;
    /**
     * Active Since
     */
    active_since?: string | null;
    /**
     * Inactive Since
     */
    inactive_since?: string | null;
    /**
     * Reporting Month
     */
    reporting_month?: number | null;
    /**
     * Reporting Day
     */
    reporting_day?: number | null;
    /**
     * Isin
     *
     * @deprecated
     */
    isin?: Array<string> | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
    /**
     * Has Research
     */
    has_research?: boolean | null;
    /**
     * Is Sdi Covered
     */
    is_sdi_covered?: boolean | null;
    /**
     * Is Sdi Universe
     */
    is_sdi_universe?: boolean | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Additional Identifiers
     */
    additional_identifiers?: Array<EntityIdentifierEntry> | null;
};

/**
 * EnumDetail
 */
export type EnumDetail = {
    /**
     * Value
     */
    value: string;
    /**
     * Description
     */
    description: string;
};

/**
 * Error
 */
export type Error = {
    /**
     * Error Id
     */
    error_id?: number | null;
    error_type: Errors;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Json Feedback
     */
    json_feedback?: {
        [key: string]: unknown;
    } | null;
    /**
     * Extraction Step Id
     */
    extraction_step_id?: number | null;
    /**
     * Correct
     */
    correct?: boolean | null;
    /**
     * Severity
     */
    severity?: number | null;
    /**
     * Cf User Id
     */
    cf_user_id?: number | null;
    /**
     * Np User Id
     */
    np_user_id?: string | null;
    /**
     * Auto Qa Id
     */
    auto_qa_id?: string | null;
    /**
     * Self Assessed
     */
    self_assessed?: boolean | null;
};

/**
 * ErrorFeedback
 */
export type ErrorFeedback = {
    /**
     * Error Id
     */
    error_id?: number | null;
    error_type: Errors;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Json Feedback
     */
    json_feedback?: {
        [key: string]: unknown;
    } | null;
};

/**
 * Errors
 */
export const Errors = {
    SDI_REVENUE_SPLIT_DRIFTED_FROM_ENTIS_REFERENCE_DATA: 'SDI revenue split drifted from ENTIS reference data',
    COMPANY_ALWAYS_NEEDS_QA: 'Company always needs QA',
    TOTAL_DOES_NOT_MATCH_FACT_SET_REVENUE: 'Total does not match FactSet revenue',
    DEVIATES_FROM_FACT_SET_VALUE: 'Deviates from FactSet value',
    FLAGGED_FOR_REVIEW_NOT_AN_ANALYST_ERROR: 'Flagged for review (not an analyst error)',
    GREAT_EXTERNAL_COMMENT: 'Great external comment',
    GREAT_MAPPING_CHOICE: 'Great mapping choice',
    GREAT_TICKET_RESOLUTION: 'Great ticket resolution',
    INADEQUATE_TICKET_RESOLUTION: 'Inadequate ticket resolution',
    INAPPROPRIATE_EXTERNAL_COMMENT: 'Inappropriate external comment',
    INDUSTRY_ALWAYS_NEEDS_QA: 'Industry always needs QA',
    LOW_MAPPING_CONFIDENCE: 'Low mapping confidence',
    MISSING_OR_PLACEHOLDER_EXTERNAL_COMMENT: 'Missing or placeholder external comment',
    MISSING_SEGMENTS: 'Missing segments',
    NO_INDEPENDENT_ANCHOR_TO_VERIFY_VALUE: 'No independent anchor to verify value',
    PREMATURE_UPDATE: 'Premature update',
    RESTATEMENT: 'restatement',
    SECTOR_POLARITY_MISMATCH: 'Sector polarity mismatch',
    SHOULD_BE_FOUND: 'Should be found',
    SHOULD_NOT_HAVE_BEEN_FOUND: 'Should not have been found',
    SUSTAINABILITY_CLAIM_NEEDS_QA_TO_CHECK_EVIDENCE: 'Sustainability claim needs QA to check evidence',
    UNNECESSARY_CHANGES: 'Unnecessary changes',
    USEFUL_INTERNAL_COMMENT: 'Useful internal comment',
    WRONG_AGGREGATION: 'Wrong aggregation',
    WRONG_DERIVATION_STATUS: 'Wrong derivation status',
    WRONG_END_TIME: 'Wrong end time',
    WRONG_MAPPING_CONFIDENCE: 'Wrong mapping confidence',
    WRONG_PAGE_SELECTED: 'Wrong page selected',
    WRONG_QUALIFIER_USED: 'Wrong qualifier used',
    WRONG_REASON_FOR_LARGE_YO_Y_CHANGE: 'Wrong reason for large YoY change',
    WRONG_REPORTING_PERIOD: 'Wrong reporting period',
    WRONG_SEGMENTS: 'Wrong segments',
    WRONG_SOURCE_USED: 'Wrong source used',
    WRONG_SOURCE_REFERENCE_FOR_YO_Y_CHANGE: 'Wrong source reference for YoY change',
    WRONG_START_TIME: 'Wrong start time',
    WRONG_TAXONOMY_MAJOR_ISSUE: 'Wrong taxonomy - Major issue',
    WRONG_TAXONOMY_MINOR_ISSUE: 'Wrong taxonomy - Minor issue',
    WRONG_UNITS_FOR_RECORDED_VALUE: 'Wrong units (for recorded value)',
    WRONG_VALUE_FOR_RECORDED_VALUE: 'Wrong value (for recorded value)'
} as const;

/**
 * Errors
 */
export type Errors = typeof Errors[keyof typeof Errors];

/**
 * EstimatedData
 */
export type EstimatedData = {
    /**
     * Value
     */
    value: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * Raw
     */
    raw: boolean;
    /**
     * Technology Id
     */
    technology_id: string;
    /**
     * Technology Name
     */
    technology_name: string;
    /**
     * Reporting End Date
     */
    reporting_end_date: string;
};

/**
 * EstimatedDatapoint
 */
export type EstimatedDatapoint = {
    /**
     * The type of data. Fixed as `Estimated`. Deprecated in favour of `factoid_type`.
     *
     * @deprecated
     */
    data_type?: DataType;
    /**
     * The type of data. Fixed as `ESTIMATIONS`.
     */
    factoid_type?: FactoidType;
    /**
     * Value
     *
     * The value recorded for the datapoint.
     */
    value: number;
    /**
     * Unit
     *
     * Name of unit datapoint is measured in.
     */
    unit: string;
    /**
     * Unit Id
     *
     * Numerical ID of the unit datapoint is measured in.
     */
    unit_id: number;
    /**
     * Question Id
     *
     * Numerical ID for question.
     */
    question_id: number;
    /**
     * Canonical Id
     *
     * String ID for question. Either a kpi_id or metric_id.
     */
    canonical_id: string;
    /**
     * Question Name
     *
     * Name of question for datapoint.
     */
    question_name: string;
    /**
     * Entity Id
     *
     * ID of entity data pertains to.
     */
    entity_id: number;
    /**
     * End
     *
     * End of reporting period for datapoint.
     */
    end: string;
    /**
     * Year
     *
     * Year datapoint is assigned to.
     */
    year: number;
    /**
     * Evic Per Million
     *
     * Intensity per million dollars of EVIC
     */
    evic_per_million: number | null;
    /**
     * Revenue Per Million
     *
     * Intensity per million dollars of revenue
     */
    revenue_per_million: number | null;
};

/**
 * EuSfdrTaxonomy
 */
export type EuSfdrTaxonomy = {
    /**
     * Segment Category
     */
    segment_category: string;
    /**
     * Segment Class
     */
    segment_class: string;
    /**
     * Segment Instance
     */
    segment_instance: string;
    /**
     * Segment Id
     */
    segment_id: number;
    /**
     * Enabling
     */
    enabling: boolean;
    /**
     * Transitional
     */
    transitional: boolean;
    /**
     * Contributing
     */
    contributing: boolean;
};

/**
 * ExportFormats
 */
export const ExportFormats = {
    JSON: 'json',
    CSV: 'csv',
    XLSX: 'xlsx',
    NONE: 'none'
} as const;

/**
 * ExportFormats
 */
export type ExportFormats = typeof ExportFormats[keyof typeof ExportFormats];

/**
 * ExportItem
 */
export type ExportItem = {
    /**
     * Result Id
     */
    result_id: string;
    /**
     * File Display Name
     */
    file_display_name: string;
    status: ResultStatuses;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Completed At
     */
    completed_at?: string | null;
};

/**
 * ExportOptions
 *
 * Object for controlling different export options.
 * This model defines a class variable "ALL_MAJOR_QUESTIONS" which can be
 * used as a magic value for metrics_config_id.
 */
export type ExportOptions = {
    /**
     * Should Send Email
     */
    should_send_email?: boolean;
    /**
     * Metrics Config Id
     */
    metrics_config_id?: string | null;
};

/**
 * ExportType
 */
export const ExportType = {
    DATA_DICTIONARY: 'data_dictionary',
    ENTITY: 'entity',
    ENTITY_DASHBOARD: 'entity_dashboard',
    ENTITY_SDG: 'entity_sdg',
    ENTITY_SDI: 'entity_sdi',
    PORTFOLIO: 'portfolio',
    PORTFOLIO_DASHBOARD: 'portfolio_dashboard',
    PORTFOLIO_DATA: 'portfolio_data',
    PORTFOLIO_PAI: 'portfolio_pai',
    PORTFOLIO_SDG: 'portfolio_sdg',
    PORTFOLIO_SDG_REVENUE: 'portfolio_sdg_revenue',
    HOLDINGS_DATA: 'holdings_data',
    COMPARE_DATA: 'compare_data',
    SECURITY_MAPPING: 'security_mapping',
    SDI_ALL: 'sdi_all'
} as const;

/**
 * ExportType
 */
export type ExportType = typeof ExportType[keyof typeof ExportType];

/**
 * ExtractionSteps
 *
 *
 * There exists steps outside of the data flow ingestion pipeline
 * where for example an NP admin makes a change to a fact through
 * the facts page of the control tool outside of the typical process.
 * These steps need to be captured here but we don't want to interfere with
 * the IngestionTaskStep processes such as next() or when it is used as an iterable
 * so we can't define the extra steps there.
 *
 * Remediation step will be used when a fact has been edited from the facts page
 * of the control tool outside of the ingestion task process.
 *
 */
export const ExtractionSteps = {
    EXTRACT: 'EXTRACT',
    QA: 'QA',
    REEXTRACT: 'REEXTRACT',
    REMEDIATION: 'REMEDIATION',
    VERIFY: 'VERIFY'
} as const;

/**
 * ExtractionSteps
 *
 *
 * There exists steps outside of the data flow ingestion pipeline
 * where for example an NP admin makes a change to a fact through
 * the facts page of the control tool outside of the typical process.
 * These steps need to be captured here but we don't want to interfere with
 * the IngestionTaskStep processes such as next() or when it is used as an iterable
 * so we can't define the extra steps there.
 *
 * Remediation step will be used when a fact has been edited from the facts page
 * of the control tool outside of the ingestion task process.
 *
 */
export type ExtractionSteps = typeof ExtractionSteps[keyof typeof ExtractionSteps];

/**
 * FactAnnotation
 */
export type FactAnnotation = {
    /**
     * Fact Annotation Id
     */
    fact_annotation_id?: number | null;
    annotation_type: FactAnnotationType;
    /**
     * Detail
     */
    detail: string;
    /**
     * Explanation
     */
    explanation?: string | null;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
};

/**
 * FactAnnotationType
 */
export const FactAnnotationType = {
    HIGH_YO_Y_VARIANCE: 'High YoY variance',
    SDI_CLASSIFICATION_CHANGED: 'SDI classification changed',
    'SDI_CONFIDENCE_CHANGED_FROM_LOW_1_3_TO_HIGH_4,5_OR_VICE_VERSA': 'SDI confidence changed from low (1-3) to high (4,5) or vice versa',
    'SDI_PERCENTAGE_CHANGED_ABOVE_THRESHOLD (>5%': 'SDI percentage changed above threshold (>5%)'
} as const;

/**
 * FactAnnotationType
 */
export type FactAnnotationType = typeof FactAnnotationType[keyof typeof FactAnnotationType];

/**
 * FactoidOrigin
 *
 * Type of factoid_id will be:
 * int if data_type=Reported
 * str if data_type=Calculated
 * [str] if data_type=Estimated
 */
export type FactoidOrigin = {
    /**
     * This is being deprecated in favour of factoid_type
     *
     * @deprecated
     */
    data_type: DataType;
    factoid_type: FactoidType;
    /**
     * Year
     */
    year: number;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Factoid Id
     */
    factoid_id?: number | string | Array<string> | null;
};

/**
 * FactoidType
 */
export const FactoidType = {
    ACCEPTED_FACTS: 'ACCEPTED_FACTS',
    ANALYSED_KPIS: 'ANALYSED_KPIS',
    ESTIMATIONS: 'ESTIMATIONS',
    FACTS: 'FACTS',
    FUND_ROLLUPS: 'FUND_ROLLUPS',
    HYBRID: 'HYBRID',
    HYBRID_REVENUE: 'HYBRID_REVENUE',
    KPI_RESULTS: 'KPI_RESULTS',
    REVENUE: 'REVENUE',
    REVENUE_FACTSET: 'REVENUE_FACTSET'
} as const;

/**
 * FactoidType
 */
export type FactoidType = typeof FactoidType[keyof typeof FactoidType];

/**
 * GlobalSearchMatchType
 *
 *
 * Identifier values mirror np.fact_db.enums.EntityIdentifierTypes, minus
 * the FactSet-derived types, which are never searchable —
 * duplicated rather than imported/extended, since np.schema is a
 * lower-level library that np.fact_db itself depends on (importing the
 * other way round would be circular). The `*_name` values are one per
 * matchable arm rather than a single generic `name`, since which field
 * matched (a company's name vs a question's name) is meaningfully
 * different context even though the mechanism (title match) is the same.
 *
 */
export const GlobalSearchMatchType = {
    CUSIP: 'cusip',
    ENTITY_ID: 'entity_id',
    ENTITY_NAME: 'entity_name',
    FIGI: 'figi',
    ISIN: 'isin',
    LEI: 'lei',
    PERM_ID: 'perm_id',
    PORTFOLIO_NAME: 'portfolio_name',
    QUESTION_NAME: 'question_name',
    SEDOL: 'sedol',
    TAXON_NAME: 'taxon_name',
    TICKER: 'ticker'
} as const;

/**
 * GlobalSearchMatchType
 *
 *
 * Identifier values mirror np.fact_db.enums.EntityIdentifierTypes, minus
 * the FactSet-derived types, which are never searchable —
 * duplicated rather than imported/extended, since np.schema is a
 * lower-level library that np.fact_db itself depends on (importing the
 * other way round would be circular). The `*_name` values are one per
 * matchable arm rather than a single generic `name`, since which field
 * matched (a company's name vs a question's name) is meaningfully
 * different context even though the mechanism (title match) is the same.
 *
 */
export type GlobalSearchMatchType = typeof GlobalSearchMatchType[keyof typeof GlobalSearchMatchType];

/**
 * Goal
 */
export const Goal = {
    DECREASE: 'decrease',
    INCREASE: 'increase',
    NEUTRAL: 'neutral'
} as const;

/**
 * Goal
 */
export type Goal = typeof Goal[keyof typeof Goal];

/**
 * HTTPValidationError
 */
export type HttpValidationError = {
    /**
     * Detail
     */
    detail?: Array<ValidationError>;
};

/**
 * HighYoyReason
 */
export type HighYoyReason = {
    /**
     * Detail
     */
    detail: string;
    reference?: Reference | null;
    /**
     * Fact Annotation Id
     */
    fact_annotation_id?: number | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Metric Name
     */
    metric_name?: string | null;
};

/**
 * HighlightArea
 */
export type HighlightArea = {
    /**
     * Height
     */
    height: number;
    /**
     * Left
     */
    left: number;
    /**
     * Page Index
     */
    page_index: number;
    /**
     * Top
     */
    top: number;
    /**
     * Width
     */
    width: number;
};

/**
 * Holding
 */
export type Holding = {
    /**
     * Name
     */
    name: string | null;
    /**
     * Security Identifier
     */
    security_identifier: string;
    /**
     * Identifier Type
     */
    identifier_type: string;
    /**
     * Weight
     */
    weight?: number | null;
    /**
     * Holding Id
     */
    holding_id: number;
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id: number;
    /**
     * Units
     */
    units?: number | null;
};

/**
 * HoldingByCompany
 */
export type HoldingByCompany = {
    /**
     * Name
     */
    name: string | null;
    /**
     * Security Identifier
     */
    security_identifier: string;
    /**
     * Identifier Type
     */
    identifier_type: string;
    /**
     * Weight
     */
    weight?: number | null;
    /**
     * Holdings Count
     */
    holdings_count?: number | null;
};

/**
 * HoldingWithCoverage
 */
export type HoldingWithCoverage = {
    holding: Holding;
    /**
     * Entity
     */
    entity?: EntityWithEstimationsCoverage | EntityWithEstimationAndSdg | null;
    fund?: PortfolioWithCoverageAndSdg | null;
    sdi_classification?: SdiClassificationName | null;
    /**
     * Sdi Classification Confidence
     */
    sdi_classification_confidence?: number | null;
};

/**
 * HoldingWithCoverageByCompany
 */
export type HoldingWithCoverageByCompany = {
    holding: HoldingByCompany;
    /**
     * Entity
     */
    entity?: EntityWithEstimationsCoverageAndSdi | EntityWithEstimationSdgAndSdi | null;
};

/**
 * HoldingsExportRequest
 */
export type HoldingsExportRequest = {
    /**
     * Result Id
     */
    result_id?: string | null;
    /**
     * Feature Toggles
     */
    feature_toggles?: Array<string>;
    export_type?: ExportType;
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * With Np Sdg Revenue
     */
    with_np_sdg_revenue?: boolean;
    /**
     * With Factset Sdg Revenue
     */
    with_factset_sdg_revenue?: boolean;
    /**
     * View Adjusted
     */
    view_adjusted?: boolean;
};

/**
 * HydratedSourceTask
 */
export type HydratedSourceTask = {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Priority
     */
    priority?: number;
    /**
     * Phase
     */
    phase: number;
    /**
     * Years
     */
    years: Array<number>;
    /**
     * User Id
     */
    user_id?: string | null;
    /**
     * Total Time Remaining
     */
    total_time_remaining?: string;
    /**
     * Total Time Spent
     */
    total_time_spent?: string;
    /**
     * Batch Id
     */
    batch_id: string;
    type: TaskType;
    task_workflow?: TaskWorkFlow | null;
    step: SourceTaskStep;
    /**
     * Reports Not Out
     */
    reports_not_out: boolean;
    state: TaskState;
    /**
     * Search Links
     */
    search_links: Array<SearchLink>;
    /**
     * Sources
     */
    sources: Array<Source>;
    /**
     * Message
     */
    message?: string | null;
};

/**
 * ImpactLevel
 */
export const ImpactLevel = {
    OPERATIONS: 'operations',
    PRODUCTS_SERVICES: 'products/services',
    VALUE_CHAIN: 'value chain'
} as const;

/**
 * ImpactLevel
 */
export type ImpactLevel = typeof ImpactLevel[keyof typeof ImpactLevel];

/**
 * InactiveEntity
 */
export type InactiveEntity = {
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * Inactive Since
     */
    inactive_since: string;
    /**
     * Entity Merge Target Id
     */
    entity_merge_target_id?: number | null;
    merge_reason?: EntityMergeReason | null;
};

/**
 * InconsistenciesSummary
 */
export type InconsistenciesSummary = {
    /**
     * Count
     */
    count: number;
    /**
     * Entities Count
     */
    entities_count: number;
    /**
     * Date
     */
    date: string;
    /**
     * Comments
     */
    comments?: string | null;
};

/**
 * IngestionBatch
 */
export type IngestionBatch = {
    /**
     * Batch Id
     */
    batch_id: string;
    /**
     * Phase
     */
    phase: number;
    step: IngestionTaskStep;
    /**
     * Total Tasks
     */
    total_tasks: number;
    /**
     * Completed Tasks
     */
    completed_tasks: number;
    /**
     * Total Time Spent
     */
    total_time_spent: string;
    /**
     * Expected Time Remaining
     */
    expected_time_remaining?: string | null;
    /**
     * Priority
     */
    priority: number;
    /**
     * Theme
     */
    theme: string;
    state: IngestionTaskState;
};

/**
 * IngestionBatchWithTasks
 */
export type IngestionBatchWithTasks = {
    /**
     * Batch Id
     */
    batch_id: string;
    /**
     * Phase
     */
    phase: number;
    step: IngestionTaskStep;
    /**
     * Total Tasks
     */
    total_tasks: number;
    /**
     * Completed Tasks
     */
    completed_tasks: number;
    /**
     * Total Time Spent
     */
    total_time_spent: string;
    /**
     * Expected Time Remaining
     */
    expected_time_remaining?: string | null;
    /**
     * Priority
     */
    priority: number;
    /**
     * Theme
     */
    theme: string;
    state: IngestionTaskState;
    /**
     * Tasks
     */
    tasks: Array<IngestionTask>;
};

/**
 * IngestionTask
 */
export type IngestionTask = {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Priority
     */
    priority?: number;
    /**
     * Phase
     */
    phase: number;
    /**
     * Years
     */
    years: Array<number>;
    /**
     * User Id
     */
    user_id?: string | null;
    /**
     * Total Time Remaining
     */
    total_time_remaining?: string;
    /**
     * Total Time Spent
     */
    total_time_spent?: string;
    /**
     * Batch Id
     */
    batch_id: string;
    type: TaskType;
    task_workflow?: TaskWorkFlow | null;
    /**
     * Theme
     */
    theme: string;
    step: IngestionTaskStep;
    state: IngestionTaskState;
};

/**
 * IngestionTaskState
 */
export const IngestionTaskState = {
    BLOCKED: 'BLOCKED',
    CANNOT_PROGRESS: 'CANNOT_PROGRESS',
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING'
} as const;

/**
 * IngestionTaskState
 */
export type IngestionTaskState = typeof IngestionTaskState[keyof typeof IngestionTaskState];

/**
 * IngestionTaskStep
 */
export const IngestionTaskStep = {
    EXTRACT: 'EXTRACT',
    QA: 'QA',
    VERIFY: 'VERIFY'
} as const;

/**
 * IngestionTaskStep
 */
export type IngestionTaskStep = typeof IngestionTaskStep[keyof typeof IngestionTaskStep];

/**
 * IngestionTaskWithFacts
 */
export type IngestionTaskWithFacts = {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Priority
     */
    priority?: number;
    /**
     * Phase
     */
    phase: number;
    /**
     * Years
     */
    years: Array<number>;
    /**
     * User Id
     */
    user_id?: string | null;
    /**
     * Total Time Remaining
     */
    total_time_remaining?: string;
    /**
     * Total Time Spent
     */
    total_time_spent?: string;
    /**
     * Batch Id
     */
    batch_id: string;
    type: TaskType;
    task_workflow?: TaskWorkFlow | null;
    /**
     * Theme
     */
    theme: string;
    step: IngestionTaskStep;
    state: IngestionTaskState;
    /**
     * Facts
     */
    facts?: Array<ListFactWithExtras> | null;
};

/**
 * InputFact
 */
export type InputFact = {
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year?: number | null;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<InputSupportingFact> | null;
    /**
     * Reason For Change
     */
    reason_for_change?: string;
};

/**
 * InputFactWithExtras
 */
export type InputFactWithExtras = {
    /**
     * Total Time Spent
     */
    total_time_spent?: string | null;
    /**
     * Errors
     */
    errors?: Array<Error> | null;
    /**
     * Annotations
     */
    annotations?: Array<FactAnnotation> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year?: number | null;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<InputSupportingFact> | null;
    /**
     * Reason For Change
     */
    reason_for_change?: string;
};

/**
 * InputSfdrFactWithExtras
 */
export type InputSfdrFactWithExtras = {
    /**
     * Total Time Spent
     */
    total_time_spent?: string | null;
    /**
     * Errors
     */
    errors?: Array<Error> | null;
    /**
     * Annotations
     */
    annotations?: Array<FactAnnotation> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year?: number | null;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts: Array<InputSfdrSupportingFact>;
    /**
     * Reason For Change
     */
    reason_for_change?: string;
};

/**
 * InputSfdrSupportingFact
 */
export type InputSfdrSupportingFact = {
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    mapping_confidence?: SegmentTaxonMappingConfidence | null;
    /**
     * Is Ai Mapped
     */
    is_ai_mapped?: boolean;
    /**
     * Supporting Fact Id
     */
    supporting_fact_id?: number | null;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Standardized Value
     */
    standardized_value: [
        number | null,
        string
    ];
    /**
     * Qualifier
     */
    qualifier?: string;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
    /**
     * Total
     */
    total?: boolean;
    /**
     * Internal Comment
     */
    internal_comment?: string | null;
    /**
     * External Comment
     */
    external_comment?: string | null;
    /**
     * Segment Id
     */
    segment_id?: number | null;
    climate_change_mitigation: SfdrValue;
    climate_change_adaptation: SfdrValue;
    water: SfdrValue;
    pollution: SfdrValue;
    circular_economy: SfdrValue;
    biodiversity: SfdrValue;
    /**
     * Climate Change Mitigation Dnsh
     */
    climate_change_mitigation_dnsh: boolean | null;
    /**
     * Climate Change Adaptation Dnsh
     */
    climate_change_adaptation_dnsh: boolean | null;
    /**
     * Water Dnsh
     */
    water_dnsh: boolean | null;
    /**
     * Pollution Dnsh
     */
    pollution_dnsh: boolean | null;
    /**
     * Circular Economy Dnsh
     */
    circular_economy_dnsh: boolean | null;
    /**
     * Biodiversity Dnsh
     */
    biodiversity_dnsh: boolean | null;
    /**
     * Minimum Safeguards
     */
    minimum_safeguards: boolean | null;
};

/**
 * InputSupportingFact
 */
export type InputSupportingFact = {
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    mapping_confidence?: SegmentTaxonMappingConfidence | null;
    /**
     * Is Ai Mapped
     */
    is_ai_mapped?: boolean;
    /**
     * Supporting Fact Id
     */
    supporting_fact_id?: number | null;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Standardized Value
     */
    standardized_value: [
        number | null,
        string
    ];
    /**
     * Qualifier
     */
    qualifier?: string;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
    /**
     * Total
     */
    total?: boolean;
    /**
     * Internal Comment
     */
    internal_comment?: string | null;
    /**
     * External Comment
     */
    external_comment?: string | null;
    /**
     * Segment Id
     */
    segment_id?: number | null;
};

/**
 * InsightResults
 */
export type InsightResults = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Fund Id
     */
    fund_id?: number | null;
    /**
     * Name
     */
    name: string;
    /**
     * Weight
     */
    weight?: number | null;
    /**
     * Primary Isin
     */
    primary_isin?: string | null;
    /**
     * This is being deprecated in favour of factoid_type
     *
     * @deprecated
     */
    data_type: DataType;
    factoid_type: FactoidType;
    factoid_origin?: FactoidOrigin | null;
    company: EntityValues;
    portfolio?: EntityValues | null;
    /**
     * Is Not Disclosed
     */
    is_not_disclosed: boolean;
    /**
     * Is Derived
     */
    is_derived: boolean;
};

/**
 * InsightTotals
 */
export type InsightTotals = {
    company: Rollup;
    portfolio: Rollup;
};

/**
 * KPI
 */
export type Kpi = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    goal?: Goal | null;
    /**
     * Active Export
     */
    active_export?: boolean;
    /**
     * Display Themes
     */
    display_themes?: Array<DisplayTheme> | null;
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Type
     */
    type?: 'KPI';
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Is Reported
     */
    is_reported?: boolean;
    /**
     * Is Estimated
     */
    is_estimated?: boolean;
    impact_level?: ImpactLevel | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Is Sdg Eligible
     */
    is_sdg_eligible?: boolean | null;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Kpi Id
     */
    kpi_id?: string | null;
    /**
     * Formula
     */
    formula: string;
    /**
     * Formula Description
     */
    formula_description?: string | null;
    /**
     * Theme
     */
    theme?: string | null;
    /**
     * Kpi Type
     */
    kpi_type?: string | null;
    /**
     * Child Questions
     */
    child_questions?: Array<number> | null;
};

/**
 * KPIResult
 */
export type KpiResult = {
    /**
     * Kpi Result Id
     */
    kpi_result_id: string;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Kpi Id
     */
    kpi_id: string;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Value Intensity
     */
    value_intensity?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy Pct
     */
    value_yoy_pct?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy
     */
    value_yoy?: [
        number | null,
        string
    ] | null;
    /**
     * Year
     */
    year: number;
};

/**
 * KPIResultDetail
 */
export type KpiResultDetail = {
    /**
     * Kpi Result Id
     */
    kpi_result_id: string;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Kpi Id
     */
    kpi_id: string;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Value Intensity
     */
    value_intensity?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy Pct
     */
    value_yoy_pct?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy
     */
    value_yoy?: [
        number | null,
        string
    ] | null;
    /**
     * Year
     */
    year: number;
    calculation_tree?: CalculationTree | null;
};

/**
 * Keyword
 */
export type Keyword = {
    /**
     * Text
     */
    text: string;
    /**
     * Keyword Id
     */
    keyword_id: number;
};

/**
 * KpiCalculationOperation
 */
export const KpiCalculationOperation = {
    ADD: 'add',
    ADD_SEGMENTS: 'add_segments',
    AVG: 'avg',
    CLAMP: 'clamp',
    CLAMP_LOWER: 'clamp_lower',
    CLAMP_UPPER: 'clamp_upper',
    COALESCE: 'coalesce',
    COUNT: 'count',
    DIV: 'div',
    MAX: 'max',
    MIN: 'min',
    MUL: 'mul',
    SUB: 'sub',
    SUM: 'sum',
    LIMIT: 'limit'
} as const;

/**
 * KpiCalculationOperation
 */
export type KpiCalculationOperation = typeof KpiCalculationOperation[keyof typeof KpiCalculationOperation];

/**
 * KpiValue
 */
export type KpiValue = {
    /**
     * Value
     */
    value?: number | null;
    /**
     * Unit
     */
    unit: string;
};

/**
 * LabelsDict
 *
 * Schema for JSON returned from Labels Endpoints.
 */
export type LabelsDict = {
    [key: string]: unknown;
};

/**
 * LatestData
 */
export type LatestData = {
    /**
     * Estimated
     */
    estimated?: Array<EstimatedData> | null;
    reported?: ReportedData | null;
};

/**
 * ListAcceptedFact
 */
export type ListAcceptedFact = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<ListAcceptedSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * ListAcceptedSupportingFact
 */
export type ListAcceptedSupportingFact = {
    /**
     * Supporting Fact Id
     */
    supporting_fact_id?: number | null;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Standardized Value
     */
    standardized_value: [
        number | null,
        string
    ];
    /**
     * Qualifier
     */
    qualifier?: string;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
    /**
     * Total
     */
    total?: boolean;
    /**
     * External Comment
     */
    external_comment?: string | null;
    /**
     * Segment Id
     */
    segment_id?: number | null;
};

/**
 * ListFact
 */
export type ListFact = {
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
};

/**
 * ListFactWithExtras
 */
export type ListFactWithExtras = {
    /**
     * Total Time Spent
     */
    total_time_spent?: string | null;
    /**
     * Errors
     */
    errors?: Array<Error> | null;
    /**
     * Annotations
     */
    annotations?: Array<OutputFactAnnotation> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
};

/**
 * MatchedOn
 */
export type MatchedOn = {
    type: GlobalSearchMatchType;
    /**
     * Text
     */
    text: string;
};

/**
 * MergeMultipleRecords
 */
export type MergeMultipleRecords = {
    /**
     * Keep
     */
    keep: number;
    /**
     * Remove
     */
    remove: Array<number>;
};

/**
 * MergeTwoEntities
 */
export type MergeTwoEntities = {
    /**
     * Target Entity Id
     *
     * Entity ID of entity to merge into.
     */
    target_entity_id: number;
    /**
     * Source Entity Id
     *
     * Entity ID of entity to merge
     */
    source_entity_id: number;
    /**
     * Merge Reason
     *
     * What kind of entity merger is it?
     */
    merge_reason?: string;
    /**
     * As Of
     *
     * Date corporate action occurred
     */
    as_of?: string | null;
};

/**
 * MergeTwoRecords
 */
export type MergeTwoRecords = {
    /**
     * Keep
     */
    keep: number;
    /**
     * Remove
     */
    remove: number;
};

/**
 * Message
 */
export type Message = {
    /**
     * Msg
     */
    msg: string;
};

/**
 * Metric
 */
export type Metric = {
    /**
     * Reporting Standards
     */
    reporting_standards?: Array<ReportingStandard> | null;
    goal?: Goal | null;
    /**
     * Active Export
     */
    active_export?: boolean;
    /**
     * Display Themes
     */
    display_themes?: Array<DisplayTheme> | null;
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Type
     */
    type?: 'Metric';
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Unit Id
     */
    unit_id?: number | null;
    /**
     * Is Reported
     */
    is_reported?: boolean;
    /**
     * Is Estimated
     */
    is_estimated?: boolean;
    impact_level?: ImpactLevel | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Is Sdg Eligible
     */
    is_sdg_eligible?: boolean | null;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Metric Id
     */
    metric_id?: string | null;
    /**
     * Instructions
     */
    instructions?: string | null;
    /**
     * Themes
     */
    themes?: Array<string> | null;
    /**
     * Active Extraction
     */
    active_extraction?: boolean;
    /**
     * Extraction Priority
     */
    extraction_priority?: number;
    /**
     * Metric Type
     */
    metric_type?: string | null;
    /**
     * Keywords
     */
    keywords?: Array<Keyword | CreateKeyword> | null;
};

/**
 * OriginQuestion
 */
export type OriginQuestion = {
    /**
     * Question Type Id
     */
    question_type_id: string;
    question_type: NpSchemaKpiDslOriginQuestionQuestionType;
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Question Name
     */
    question_name?: string | null;
    /**
     * Year
     */
    year?: number | null;
    /**
     * Segment
     */
    segment?: Segment | number | null;
};

/**
 * OutputFact
 */
export type OutputFact = {
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * OutputFactAnnotation
 */
export type OutputFactAnnotation = {
    /**
     * Fact Annotation Id
     */
    fact_annotation_id?: number | null;
    /**
     * Annotation Type
     */
    annotation_type: string;
    /**
     * Detail
     */
    detail: string;
    /**
     * Explanation
     */
    explanation?: string | null;
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
};

/**
 * OutputFactWithExtras
 */
export type OutputFactWithExtras = {
    /**
     * Total Time Spent
     */
    total_time_spent?: string | null;
    /**
     * Errors
     */
    errors?: Array<Error> | null;
    /**
     * Annotations
     */
    annotations?: Array<OutputFactAnnotation> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * OutputSfdrFact
 */
export type OutputSfdrFact = {
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSfdrSupportingFact>;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * OutputSfdrFactWithExtras
 */
export type OutputSfdrFactWithExtras = {
    /**
     * Total Time Spent
     */
    total_time_spent?: string | null;
    /**
     * Errors
     */
    errors?: Array<Error> | null;
    /**
     * Annotations
     */
    annotations?: Array<OutputFactAnnotation> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Sources Searched
     */
    sources_searched?: Array<Source | number> | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Feedback
     */
    feedback?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<OutputSfdrSupportingFact>;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * OutputSfdrSupportingFact
 */
export type OutputSfdrSupportingFact = {
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    mapping_confidence?: SegmentTaxonMappingConfidence | null;
    /**
     * Is Ai Mapped
     */
    is_ai_mapped?: boolean;
    /**
     * Supporting Fact Id
     */
    supporting_fact_id: number;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Standardized Value
     */
    standardized_value: [
        number | null,
        string
    ];
    /**
     * Qualifier
     */
    qualifier?: string;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
    /**
     * Total
     */
    total?: boolean;
    /**
     * Internal Comment
     */
    internal_comment?: string | null;
    /**
     * External Comment
     */
    external_comment?: string | null;
    /**
     * Segment Id
     */
    segment_id?: number | null;
    climate_change_mitigation: SfdrValue;
    climate_change_adaptation: SfdrValue;
    water: SfdrValue;
    pollution: SfdrValue;
    circular_economy: SfdrValue;
    biodiversity: SfdrValue;
    /**
     * Climate Change Mitigation Dnsh
     */
    climate_change_mitigation_dnsh: boolean | null;
    /**
     * Climate Change Adaptation Dnsh
     */
    climate_change_adaptation_dnsh: boolean | null;
    /**
     * Water Dnsh
     */
    water_dnsh: boolean | null;
    /**
     * Pollution Dnsh
     */
    pollution_dnsh: boolean | null;
    /**
     * Circular Economy Dnsh
     */
    circular_economy_dnsh: boolean | null;
    /**
     * Biodiversity Dnsh
     */
    biodiversity_dnsh: boolean | null;
    /**
     * Minimum Safeguards
     */
    minimum_safeguards: boolean | null;
};

/**
 * OutputSupportingFact
 */
export type OutputSupportingFact = {
    /**
     * Taxon Id
     */
    taxon_id?: number | null;
    mapping_confidence?: SegmentTaxonMappingConfidence | null;
    /**
     * Is Ai Mapped
     */
    is_ai_mapped?: boolean;
    /**
     * Supporting Fact Id
     */
    supporting_fact_id?: number | null;
    /**
     * Fact Id
     */
    fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Reference
     */
    reference?: Reference | CreateReference | null;
    /**
     * Standardized Value
     */
    standardized_value: [
        number | null,
        string
    ];
    /**
     * Qualifier
     */
    qualifier?: string;
    /**
     * Low Confidence
     */
    low_confidence?: boolean;
    /**
     * Derived
     */
    derived?: boolean;
    /**
     * Total
     */
    total?: boolean;
    /**
     * Internal Comment
     */
    internal_comment?: string | null;
    /**
     * External Comment
     */
    external_comment?: string | null;
    /**
     * Segment Id
     */
    segment_id?: number | null;
};

/**
 * OverallStats
 */
export type OverallStats = {
    /**
     * Overall Avg Time Spent
     */
    overall_avg_time_spent?: number | null;
    /**
     * Overall Std Dev Time Spent
     */
    overall_std_dev_time_spent?: number | null;
    /**
     * Overall Error Rate
     */
    overall_error_rate?: number | null;
};

/**
 * PageClassificationResult
 */
export type PageClassificationResult = {
    /**
     * Page Number
     */
    page_number: number;
    /**
     * Confidence
     */
    confidence: number;
};

/**
 * PaginatedResponseWithTotals[InsightResults, InsightTotals]
 */
export type PaginatedResponseWithTotalsInsightResultsInsightTotals = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<InsightResults>;
    totals: InsightTotals;
};

/**
 * PaginatedResponse[AcceptedFactChange]
 */
export type PaginatedResponseAcceptedFactChange = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<AcceptedFactChange>;
};

/**
 * PaginatedResponse[Annotated[Union[Metric, SimpleMetric], FieldInfo(annotation=NoneType, required=True, discriminator='type')]]
 */
export type PaginatedResponseAnnotatedUnionMetricSimpleMetricFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorType = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Metric | SimpleMetric>;
};

/**
 * PaginatedResponse[CompanyCoverage]
 */
export type PaginatedResponseCompanyCoverage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<CompanyCoverage>;
};

/**
 * PaginatedResponse[DataDictionaryQuestion]
 */
export type PaginatedResponseDataDictionaryQuestion = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<DataDictionaryQuestion>;
};

/**
 * PaginatedResponse[EntityRevenueAlignment]
 */
export type PaginatedResponseEntityRevenueAlignment = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EntityRevenueAlignment>;
};

/**
 * PaginatedResponse[EntitySDGContributions]
 */
export type PaginatedResponseEntitySdgContributions = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EntitySdgContributions>;
};

/**
 * PaginatedResponse[EntityWithOptionalDetailsAndSDGRevenuePct]
 */
export type PaginatedResponseEntityWithOptionalDetailsAndSdgRevenuePct = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EntityWithOptionalDetailsAndSdgRevenuePct>;
};

/**
 * PaginatedResponse[EstimatedDatapoint]
 */
export type PaginatedResponseEstimatedDatapoint = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EstimatedDatapoint>;
};

/**
 * PaginatedResponse[EuSfdrTaxonomy]
 */
export type PaginatedResponseEuSfdrTaxonomy = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<EuSfdrTaxonomy>;
};

/**
 * PaginatedResponse[HoldingWithCoverageByCompany]
 */
export type PaginatedResponseHoldingWithCoverageByCompany = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<HoldingWithCoverageByCompany>;
};

/**
 * PaginatedResponse[HoldingWithCoverage]
 */
export type PaginatedResponseHoldingWithCoverage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<HoldingWithCoverage>;
};

/**
 * PaginatedResponse[InactiveEntity]
 */
export type PaginatedResponseInactiveEntity = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<InactiveEntity>;
};

/**
 * PaginatedResponse[IngestionBatch]
 */
export type PaginatedResponseIngestionBatch = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<IngestionBatch>;
};

/**
 * PaginatedResponse[KPIResult]
 */
export type PaginatedResponseKpiResult = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<KpiResult>;
};

/**
 * PaginatedResponse[KPI]
 */
export type PaginatedResponseKpi = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Kpi>;
};

/**
 * PaginatedResponse[Keyword]
 */
export type PaginatedResponseKeyword = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Keyword>;
};

/**
 * PaginatedResponse[ListAcceptedFact]
 */
export type PaginatedResponseListAcceptedFact = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListAcceptedFact>;
};

/**
 * PaginatedResponse[ListFactWithExtras]
 */
export type PaginatedResponseListFactWithExtras = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListFactWithExtras>;
};

/**
 * PaginatedResponse[ListFact]
 */
export type PaginatedResponseListFact = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ListFact>;
};

/**
 * PaginatedResponse[OutputSfdrFact]
 */
export type PaginatedResponseOutputSfdrFact = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<OutputSfdrFact>;
};

/**
 * PaginatedResponse[PortfolioData]
 */
export type PaginatedResponsePortfolioData = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<PortfolioData>;
};

/**
 * PaginatedResponse[PortfolioWithCoverage]
 */
export type PaginatedResponsePortfolioWithCoverage = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<PortfolioWithCoverage>;
};

/**
 * PaginatedResponse[SearchResult]
 */
export type PaginatedResponseSearchResult = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<SearchResult>;
};

/**
 * PaginatedResponse[Segment]
 */
export type PaginatedResponseSegment = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Segment>;
};

/**
 * PaginatedResponse[SourceBatch]
 */
export type PaginatedResponseSourceBatch = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<SourceBatch>;
};

/**
 * PaginatedResponse[SourceWithLabelPredictions]
 */
export type PaginatedResponseSourceWithLabelPredictions = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<SourceWithLabelPredictions>;
};

/**
 * PaginatedResponse[Source]
 */
export type PaginatedResponseSource = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Source>;
};

/**
 * PaginatedResponse[TimeSeriesRow]
 */
export type PaginatedResponseTimeSeriesRow = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<TimeSeriesRow>;
};

/**
 * PaginatedResponse[Union[ReportingStandard, ReportingStandardMajorDetails]]
 */
export type PaginatedResponseUnionReportingStandardReportingStandardMajorDetails = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<ReportingStandard | ReportingStandardMajorDetails>;
};

/**
 * PaginatedResponse[Unit]
 */
export type PaginatedResponseUnit = {
    /**
     * Total
     */
    total: number;
    /**
     * Page
     */
    page: number | null;
    /**
     * Results Per Page
     */
    results_per_page: number;
    /**
     * Results
     */
    results?: Array<Unit>;
};

/**
 * Portfolio
 */
export type Portfolio = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
};

/**
 * PortfolioData
 */
export type PortfolioData = {
    /**
     *
     * Specifies the returned data type and can be:
     * `ACCEPTED_FACTS` (accepted fact sourced from publicly available documents),
     * `KPI_RESULTS` (standardized result derived from reported data),
     * or `ESTIMATIONS` (datapoint produced from our research
     * on high-impact products and services).
     *
     */
    factoid_type: FactoidType;
    /**
     *
     * Specifies the returned data type with "NOT FOUND" being treated as a separate
     * category.
     * `REPORTED` (Data directly taken from public sources)
     * `CALCULATED` (Standardized result derived from `REPORTED` data)
     * `ESTIMATED` (Data from our research on high-impact products and services)
     * `NOT DISCLOSED` (Data from either the `REPORTED` or `CALCULATED` segments which
     * was not found or not derivable.)
     * Deprecated in favour of `factoid_type` and inspecting the `unit` field.
     *
     *
     * @deprecated
     */
    data_type: DataType;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Value
     */
    value?: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Question Name
     */
    question_name: string;
    /**
     * Canonical Id
     */
    canonical_id: string;
    /**
     * Year
     */
    year: number;
    /**
     * End
     */
    end: string;
};

/**
 * PortfolioDataExport
 */
export type PortfolioDataExport = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * PortfolioExport
 */
export type PortfolioExport = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    export_options?: ExportOptions | null;
};

/**
 * PortfolioImpactData
 */
export type PortfolioImpactData = {
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Canonical Id
     */
    canonical_id?: string | null;
    /**
     * Display Themes
     */
    display_themes?: Array<DisplayThemeWithSdg> | null;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Year On Year
     */
    year_on_year?: [
        number | null,
        string
    ] | null;
    /**
     * Intensity
     */
    intensity?: [
        number | null,
        string
    ] | null;
    /**
     * Revenue Intensity
     */
    revenue_intensity?: [
        number | null,
        string
    ] | null;
    goal?: Goal | null;
    impact_level?: ImpactLevel | null;
    /**
     * Is Nd
     */
    is_nd?: boolean;
    /**
     * Sdg Goals
     */
    sdg_goals?: Array<ReportingStandardMajorDetails>;
    /**
     * Sdg Targets
     */
    sdg_targets?: Array<BaseReportingStandard>;
    /**
     * Is Contributing
     */
    is_contributing?: boolean | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Sdg Revenue Percentage
     */
    sdg_revenue_percentage?: [
        number | null,
        string
    ] | null;
    /**
     * Kpi Id
     */
    kpi_id?: string | null;
    /**
     * Unweighted Portfolio Impact
     */
    unweighted_portfolio_impact?: [
        number | null,
        string
    ] | null;
    /**
     * Weighted Portfolio Impact
     */
    weighted_portfolio_impact?: [
        number | null,
        string
    ] | null;
};

/**
 * PortfolioPAIExport
 */
export type PortfolioPaiExport = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    export_options?: BaseExportOptions | null;
};

/**
 * PortfolioSDGAlignment
 */
export type PortfolioSdgAlignment = {
    total: PortfolioSdgAlignmentTotal;
    breakdown: PortfolioSdgAlignmentBreakdown;
};

/**
 * PortfolioSDGAlignmentBreakdown
 */
export type PortfolioSdgAlignmentBreakdown = {
    [key: string]: number | null;
};

/**
 * PortfolioSDGAlignmentTotal
 */
export type PortfolioSdgAlignmentTotal = {
    /**
     * Aligned
     */
    aligned: number;
    /**
     * Not Aligned
     */
    not_aligned: number;
    /**
     * Not Covered
     */
    not_covered: number;
};

/**
 * PortfolioSDGAumContribution
 */
export type PortfolioSdgAumContribution = {
    /**
     * Total Revenue Usd
     */
    total_revenue_usd: number;
    positive: SdgAumContribution;
    potential: SdgAumContribution;
    negative: SdgAumContribution;
    not_covered: SdgAumContribution;
    potentially_positive: SdgAumContribution;
    potentially_negative: SdgAumContribution;
    positive_sdg_breakdown: AumAlignmentBreakDown;
    potential_sdg_breakdown: AumAlignmentBreakDown;
    negative_sdg_breakdown: AumAlignmentBreakDown;
    potentially_positive_sdg_breakdown: AumAlignmentBreakDown;
    potentially_negative_sdg_breakdown: AumAlignmentBreakDown;
};

/**
 * PortfolioSDGExport
 */
export type PortfolioSdgExport = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    export_options?: PortfolioSdgExportOptions | null;
    /**
     * With Bond Entities
     */
    with_bond_entities?: boolean;
};

/**
 * PortfolioSDGExportOptions
 */
export type PortfolioSdgExportOptions = {
    /**
     * Should Send Email
     */
    should_send_email?: boolean;
    /**
     * With Estimations
     */
    with_estimations?: boolean;
};

/**
 * PortfolioSDGRevenueContribution
 */
export type PortfolioSdgRevenueContribution = {
    /**
     * Total Revenue Usd
     */
    total_revenue_usd: number;
    positive: SdgRevenueContribution;
    potential: SdgRevenueContribution;
    negative: SdgRevenueContribution;
    not_covered: SdgRevenueContribution;
    potentially_positive: SdgRevenueContribution;
    potentially_negative: SdgRevenueContribution;
    positive_sdg_breakdown: AlignmentBreakDown;
    potential_sdg_breakdown: AlignmentBreakDown;
    negative_sdg_breakdown: AlignmentBreakDown;
    potentially_positive_sdg_breakdown: AlignmentBreakDown;
    potentially_negative_sdg_breakdown: AlignmentBreakDown;
};

/**
 * PortfolioSDGRevenueExport
 */
export type PortfolioSdgRevenueExport = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    export_options?: BaseExportOptions | null;
    /**
     * With Bond Entities
     */
    with_bond_entities?: boolean;
};

/**
 * PortfolioSDIAumContribution
 *
 * The AUM weighted counterpart of PortfolioSDIRevenueContribution. Unlike
 * PortfolioSDGAumContribution, the total is AUM rather than revenue, matching
 * the aum_usd figures the buckets report.
 */
export type PortfolioSdiAumContribution = {
    /**
     * Total Aum Usd
     */
    total_aum_usd: number;
    positive: SdgAumContribution;
    potential: SdgAumContribution;
    negative: SdgAumContribution;
    not_covered: SdgAumContribution;
    potentially_positive: SdgAumContribution;
    potentially_negative: SdgAumContribution;
    positive_sdg_breakdown: AumAlignmentBreakDown;
    potential_sdg_breakdown: AumAlignmentBreakDown;
    negative_sdg_breakdown: AumAlignmentBreakDown;
    potentially_positive_sdg_breakdown: AumAlignmentBreakDown;
    potentially_negative_sdg_breakdown: AumAlignmentBreakDown;
};

/**
 * PortfolioSDILabelsAumSummary
 *
 * Categories map onto SdiClassificationValue as described on
 * PortfolioSDILabelsCountSummary. not_covered carries the AUM of everything
 * the labels could not be computed for, holdings with no matched entity
 * included, so the categories total the portfolio value.
 */
export type PortfolioSdiLabelsAumSummary = {
    /**
     * Total Aum Usd
     */
    total_aum_usd: number;
    majority: SdiLabelsAum;
    decisive: SdiLabelsAum;
    potential: SdiLabelsAum;
    decisive_negative: SdiLabelsAum;
    majority_negative: SdiLabelsAum;
    not_covered: SdiLabelsAum;
    majority_sdg_breakdown: SdiLabelsAumBreakDown;
    decisive_sdg_breakdown: SdiLabelsAumBreakDown;
    potential_sdg_breakdown: SdiLabelsAumBreakDown;
    decisive_negative_sdg_breakdown: SdiLabelsAumBreakDown;
    majority_negative_sdg_breakdown: SdiLabelsAumBreakDown;
};

/**
 * PortfolioSDILabelsCountSummary
 *
 * Categories map onto SdiClassificationValue as majority -> MAJORITY_SDI,
 * decisive -> DECISIVE_SDI, potential -> NON_SDI,
 * decisive_negative -> NEGATIVE_DECISIVE_SDI and
 * majority_negative -> NEGATIVE_MAJORITY_SDI. Holdings whose entity has no
 * SDI revenue are counted as not_covered.
 *
 * The top level categories label an entity on its total aligned revenue; the
 * `*_sdg_breakdown` ones re-label it per goal, on the positive revenue
 * attributable to that goal alone. An entity's negative revenue still counts
 * in full against every goal, so more than 10% negatively aligned revenue
 * keeps it out of majority and decisive everywhere, not just in the goals
 * that revenue belongs to. not_covered has no per goal split, being a
 * property of the entity rather than of any one goal.
 */
export type PortfolioSdiLabelsCountSummary = {
    /**
     * Total Entity Count
     */
    total_entity_count: number;
    majority: SdiLabelsEntityCount;
    decisive: SdiLabelsEntityCount;
    potential: SdiLabelsEntityCount;
    decisive_negative: SdiLabelsEntityCount;
    majority_negative: SdiLabelsEntityCount;
    not_covered: SdiLabelsEntityCount;
    majority_sdg_breakdown: SdiLabelsCountBreakDown;
    decisive_sdg_breakdown: SdiLabelsCountBreakDown;
    potential_sdg_breakdown: SdiLabelsCountBreakDown;
    decisive_negative_sdg_breakdown: SdiLabelsCountBreakDown;
    majority_negative_sdg_breakdown: SdiLabelsCountBreakDown;
};

/**
 * PortfolioSDIRevenueContribution
 *
 * Response type for sdi_revenue. Matches PortfolioSDGRevenueContribution.
 */
export type PortfolioSdiRevenueContribution = {
    /**
     * Total Revenue Usd
     */
    total_revenue_usd: number;
    positive: SdgRevenueContribution;
    potential: SdgRevenueContribution;
    negative: SdgRevenueContribution;
    not_covered: SdgRevenueContribution;
    potentially_positive: SdgRevenueContribution;
    potentially_negative: SdgRevenueContribution;
    positive_sdg_breakdown: AlignmentBreakDown;
    potential_sdg_breakdown: AlignmentBreakDown;
    negative_sdg_breakdown: AlignmentBreakDown;
    potentially_positive_sdg_breakdown: AlignmentBreakDown;
    potentially_negative_sdg_breakdown: AlignmentBreakDown;
};

/**
 * PortfolioSnapshot
 */
export type PortfolioSnapshot = {
    /**
     * Snapshot Id
     */
    snapshot_id: number;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Total Value
     */
    total_value: number;
    /**
     * Lcu
     */
    lcu?: string | null;
    /**
     * Lcu Total Value
     */
    lcu_total_value?: number | null;
    /**
     * Created At
     */
    created_at: string;
    /**
     * Created By
     */
    created_by: string | null;
    /**
     * Is Latest
     */
    is_latest: boolean;
    /**
     * Num Holdings
     */
    num_holdings: number;
    /**
     * Total Weight
     */
    total_weight: number;
};

/**
 * PortfolioTypes
 */
export const PortfolioTypes = {
    BENCHMARK: 'benchmark',
    FUND: 'fund',
    FUND_OF_FUNDS: 'fund of funds',
    PRIVATE: 'private',
    WATCHLIST: 'watchlist'
} as const;

/**
 * PortfolioTypes
 */
export type PortfolioTypes = typeof PortfolioTypes[keyof typeof PortfolioTypes];

/**
 * PortfolioUpdate
 */
export type PortfolioUpdate = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date?: string | null;
};

/**
 * PortfolioWithCoverage
 */
export type PortfolioWithCoverage = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * Num Holdings
     */
    num_holdings: number;
    /**
     * Num Holdings Covered
     */
    num_holdings_covered: number;
    /**
     * Val Pct Covered
     */
    val_pct_covered: number;
    /**
     * Num Holdings Researched
     */
    num_holdings_researched: number;
    /**
     * Val Pct Researched
     */
    val_pct_researched: number;
    /**
     * Funds
     */
    funds?: Array<PortfolioWithCoverage> | null;
};

/**
 * PortfolioWithCoverageAndSDG
 */
export type PortfolioWithCoverageAndSdg = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * Num Holdings
     */
    num_holdings: number;
    /**
     * Num Holdings Covered
     */
    num_holdings_covered: number;
    /**
     * Val Pct Covered
     */
    val_pct_covered: number;
    /**
     * Num Holdings Researched
     */
    num_holdings_researched: number;
    /**
     * Val Pct Researched
     */
    val_pct_researched: number;
    /**
     * Funds
     */
    funds?: Array<PortfolioWithCoverage> | null;
    /**
     * Contributing Revenue Pct
     */
    contributing_revenue_pct?: number | null;
    /**
     * Potential Revenue Pct
     */
    potential_revenue_pct?: number | null;
    /**
     * Negative Revenue Pct
     */
    negative_revenue_pct?: number | null;
    /**
     * Aligned Sdgs
     */
    aligned_sdgs?: Array<ReportingStandardMajorDetailsWithOrigin> | null;
};

/**
 * PortfolioWithEntityDetail
 */
export type PortfolioWithEntityDetail = {
    /**
     * Entity Weight
     */
    entity_weight: number;
    /**
     * Entity Value
     */
    entity_value?: number | null;
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
};

/**
 * PortfolioWithNumHoldings
 */
export type PortfolioWithNumHoldings = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * Num Holdings
     */
    num_holdings: number;
};

/**
 * PromotedBranch
 */
export const PromotedBranch = { MAIN: 'main', PREVIEW: 'preview' } as const;

/**
 * PromotedBranch
 */
export type PromotedBranch = typeof PromotedBranch[keyof typeof PromotedBranch];

/**
 * QuestionCoverage
 *
 * For a given question, show:
 *
 * `latest_year`: coverage for each entity's latest year.
 * `absolute_years`: coverage for absolute years, in descending order.
 *
 * The other fields pertain to the question.
 */
export type QuestionCoverage = {
    /**
     * Theme
     */
    theme: string;
    /**
     * Display Themes
     */
    display_themes: Array<DisplayTheme>;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Display Name
     */
    display_name: string;
    /**
     * Unit Id
     */
    unit_id: number;
    /**
     * Is Reported
     */
    is_reported: boolean;
    /**
     * Is Estimated
     */
    is_estimated: boolean;
    /**
     * Absolute Years
     */
    absolute_years: Array<QuestionCoverageAbsoluteYear>;
};

/**
 * QuestionCoverageAbsoluteYear
 *
 * Based on each entity's data for a given year.
 * `total`: counts relevant entities (based on theme) with any result.
 * `disclosed`: counts holdings with valid (not NOT FOUND etc.) results.
 */
export type QuestionCoverageAbsoluteYear = {
    /**
     * Total
     */
    total: number;
    /**
     * Disclosed
     */
    disclosed: number;
    /**
     * Estimated
     */
    estimated?: number | null;
    /**
     * Disclosed Percentage
     */
    disclosed_percentage: number;
    /**
     * Is Complete
     */
    is_complete: boolean;
    /**
     * Year
     */
    year: number;
    /**
     * Disclosed With Estimated
     */
    disclosed_with_estimated: number;
    /**
     * Disclosed Percentage With Estimated
     */
    disclosed_percentage_with_estimated: number;
    /**
     * Portfolio Disclosed Percentage
     */
    portfolio_disclosed_percentage?: number | null;
    /**
     * Portfolio Disclosed Percentage With Estimated
     */
    portfolio_disclosed_percentage_with_estimated?: number | null;
};

/**
 * QuestionDisclosure
 */
export type QuestionDisclosure = {
    /**
     * Question Id
     */
    question_id: number;
    coverage: QuestionDisclosureDetails;
};

/**
 * QuestionDisclosureDetails
 *
 * This schema may be used in the context of a portfolio, which is why some fields are
 * nullable.
 *
 * If an entity has both reported and estimated data, it counts as reported, and not
 * estimated.
 */
export type QuestionDisclosureDetails = {
    /**
     * Applicable
     */
    applicable: number;
    /**
     * Estimated
     */
    estimated: number;
    /**
     * Disclosed
     */
    disclosed: number;
    /**
     * Disclosed With Estimated
     */
    disclosed_with_estimated: number;
    /**
     * Disclosed Percentage
     */
    disclosed_percentage?: number | null;
    /**
     * Disclosed Percentage With Estimated
     */
    disclosed_percentage_with_estimated?: number | null;
};

/**
 * QuestionName
 */
export type QuestionName = {
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Display Name
     */
    display_name: string;
};

/**
 * QuestionSearchData
 */
export type QuestionSearchData = {
    /**
     * Display Themes
     */
    display_themes: Array<string>;
    question_type: QuestionType1;
    /**
     * Is Reported
     */
    is_reported: boolean;
    /**
     * Is Estimated
     */
    is_estimated: boolean;
};

/**
 * QuestionType
 */
export const QuestionType1 = {
    ANALYSED_KPI: 'Analysed KPI',
    KPI: 'KPI',
    METRIC: 'Metric',
    QUESTION: 'Question',
    SIMPLE_METRIC: 'Simple metric'
} as const;

/**
 * QuestionType
 */
export type QuestionType1 = typeof QuestionType1[keyof typeof QuestionType1];

/**
 * Reference
 */
export type Reference = {
    /**
     * Source Id
     */
    source_id: number;
    source?: Source | null;
    /**
     * Page Num
     */
    page_num?: number | null;
    /**
     * Highlight Areas
     */
    highlight_areas?: Array<HighlightArea> | null;
    /**
     * Reference Id
     */
    reference_id: number;
};

/**
 * ReportTypes
 */
export const ReportTypes = {
    ACADEMIC_STUDY: 'Academic Study',
    ANNUAL_REPORT: 'Annual Report',
    BLOG_ARTICLE: 'Blog Article',
    BOND_ALLOCATION_REPORT: 'Bond Allocation Report',
    BOND_FINANCIAL_REPORT: 'Bond Financial Report',
    BOND_FRAMEWORK: 'Bond Framework',
    BOND_IMPACT_REPORT: 'Bond Impact Report',
    CDP_REPORT: 'CDP Report',
    CITIZENSHIP_REPORT: 'Citizenship Report',
    COMPANY_SPONSORED_STUDY: 'Company Sponsored Study',
    COMPANY_WEBSITE: 'Company Website',
    CORPORATE_GOVERNANCE: 'Corporate Governance',
    CR_REPORT: 'CR Report',
    CRSD: 'CRSD',
    CSR_REPORT: 'CSR Report',
    DIVERSITY_REPORT: 'Diversity Report',
    EARNINGS_TRANSCRIPT: 'Earnings Transcript',
    EEO_1_REPORT: 'EEO-1 Report',
    ENVIRONMENT_REPORT: 'Environment Report',
    ESG_REPORT: 'ESG Report',
    ETHICS_COMPLIANCE_DECLARATION: 'Ethics / Compliance Declaration',
    FACTSET: 'factset',
    FACTSHEET: 'Factsheet',
    FINANCIAL_STATEMENT: 'Financial Statement',
    FUND_FACTSHEET: 'Fund Factsheet',
    GENDER_PAY_GAP_REPORT: 'Gender Pay Gap Report',
    GRI_INDEX: 'GRI Index',
    IMPACT_REPORT: 'Impact Report',
    INDUSTRY_REPORT: 'Industry Report',
    INTEGRATED_REPORT: 'Integrated Report',
    INVESTOR_PRESENTATION: 'Investor Presentation',
    INVESTOR_REPORT: 'Investor Report',
    MERCHANT_WEBSITE: 'Merchant Website',
    NEWS_ARTICLE: 'News Article',
    NGO_GOVERNMENT_WEBSITE: 'NGO/Government Website',
    OTHER: 'Other',
    PRESS_RELEASE: 'Press Release',
    PRODUCT_SHEET: 'Product Sheet',
    PRODUCT_SPECIFICATION: 'Product Specification',
    PROSPECTUS: 'Prospectus',
    PROXY_STATEMENT: 'Proxy Statement',
    QUARTERLY_REPORT: 'Quarterly Report',
    REMUNERATION_REPORT: 'Remuneration Report',
    '10_K': '10-K',
    '20_F': '20-F',
    SASB_INDEX: 'SASB Index',
    SCIENTIFIC_JOURNAL: 'Scientific Journal',
    SUSTAINABILITY_REPORT: 'Sustainability Report',
    TCFD: 'TCFD',
    TNFD: 'TNFD',
    UNGC_COMMUNICATION_ON_PROGRESS: 'UNGC Communication on Progress',
    UNGC_LETTER_OF_COMMITMENT: 'UNGC Letter of Commitment',
    VERIFICATION_STATEMENT: 'Verification Statement',
    WEBSITE: 'Website',
    WRITE_UP: 'Write Up'
} as const;

/**
 * ReportTypes
 */
export type ReportTypes = typeof ReportTypes[keyof typeof ReportTypes];

/**
 * ReportedData
 */
export type ReportedData = {
    /**
     * Factoid Id
     */
    factoid_id: string;
    /**
     * Value
     */
    value: number;
    /**
     * Unit
     */
    unit: string;
    /**
     * End
     */
    end: string;
};

/**
 * ReportedDatapoint
 */
export type ReportedDatapoint = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Value
     */
    value?: number | null;
    /**
     * Is Derived
     */
    is_derived?: boolean;
    /**
     * Is Nd
     */
    is_nd?: boolean;
    /**
     * Year
     */
    year: number;
    /**
     * Is Factset
     */
    is_factset?: boolean;
    /**
     * Is Pending
     */
    is_pending?: boolean;
    /**
     * Fact Ids
     */
    fact_ids?: Array<number> | null;
    /**
     * Kpi Result Ids
     */
    kpi_result_ids?: Array<string> | null;
    /**
     * Fact Id
     *
     * This is being deprecated in favour of `fact_ids`
     *
     * @deprecated
     */
    fact_id?: number | null;
    /**
     * Kpi Result Id
     *
     * This is being deprecated in favour of `kpi_result_ids`
     *
     * @deprecated
     */
    kpi_result_id?: string | null;
};

/**
 * ReportingStandard
 */
export type ReportingStandard = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
    /**
     * Full Code
     */
    full_code?: string | null;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Reporting Standard Id
     */
    reporting_standard_id: number;
};

/**
 * ReportingStandardClasses
 */
export const ReportingStandardClasses = {
    EU_SFDR: 'EU SFDR',
    GRI: 'GRI',
    IRIS: 'IRIS+',
    ISSB: 'ISSB',
    SDG: 'SDG',
    SDI: 'SDI'
} as const;

/**
 * ReportingStandardClasses
 */
export type ReportingStandardClasses = typeof ReportingStandardClasses[keyof typeof ReportingStandardClasses];

/**
 * ReportingStandardMajorDetails
 */
export type ReportingStandardMajorDetails = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
};

/**
 * ReportingStandardMajorDetailsWithOrigin
 */
export type ReportingStandardMajorDetailsWithOrigin = {
    standard_class: ReportingStandardClasses;
    /**
     * Major Code
     */
    major_code?: string | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Colour
     */
    colour?: string | null;
    /**
     * Origins
     */
    origins?: Array<SdgOrigin> | null;
};

/**
 * ResultStatuses
 */
export const ResultStatuses = {
    COMPLETE: 'complete',
    FAILED: 'failed',
    PENDING: 'pending',
    STARTED: 'started'
} as const;

/**
 * ResultStatuses
 */
export type ResultStatuses = typeof ResultStatuses[keyof typeof ResultStatuses];

/**
 * ResultTypes
 */
export const ResultTypes = {
    DATA: 'data',
    FILE: 'file',
    PLACEHOLDER: 'placeholder'
} as const;

/**
 * ResultTypes
 */
export type ResultTypes = typeof ResultTypes[keyof typeof ResultTypes];

/**
 * RevenueDataOrigin
 */
export const RevenueDataOrigin = {
    ENTIS: 'entis',
    FACTSET: 'factset',
    PSI: 'psi',
    REPORTED: 'reported'
} as const;

/**
 * RevenueDataOrigin
 */
export type RevenueDataOrigin = typeof RevenueDataOrigin[keyof typeof RevenueDataOrigin];

/**
 * RevenueDeltas
 */
export type RevenueDeltas = {
    /**
     * Year
     */
    year?: number | null;
    origin: RevenueDataOrigin;
    /**
     * Total Recorded Value
     */
    total_recorded_value: [
        number | null,
        string
    ];
    /**
     * Positive Percentage
     */
    positive_percentage: number;
    /**
     * Negative Percentage
     */
    negative_percentage: number;
    sdi_classification: SdiClassificationName;
    /**
     * Positive Confidence
     */
    positive_confidence?: number | null;
    /**
     * Negative Confidence
     */
    negative_confidence?: number | null;
    /**
     * Sdi Rationale
     */
    sdi_rationale?: string | null;
    /**
     * Segments
     */
    segments: Array<RevenueDeltasResponseSegment>;
};

/**
 * RevenueDeltasRequest
 */
export type RevenueDeltasRequest = {
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Year
     */
    year: number;
    /**
     * Segments
     */
    segments: Array<RevenueDeltasRequestSegment>;
};

/**
 * RevenueDeltasRequestSegment
 */
export type RevenueDeltasRequestSegment = {
    /**
     * Supporting Fact Id
     */
    supporting_fact_id: number;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Taxon Id
     */
    taxon_id: number;
    /**
     * Name
     */
    name: string;
    mapping_confidence: SegmentTaxonMappingConfidence;
    /**
     * External Comment
     */
    external_comment: string;
    /**
     * Derived
     */
    derived: boolean;
};

/**
 * RevenueDeltasResponse
 */
export type RevenueDeltasResponse = {
    sdi?: RevenueDeltasWithAnnotations | null;
    current: RevenueDeltas;
};

/**
 * RevenueDeltasResponseSegment
 */
export type RevenueDeltasResponseSegment = {
    /**
     * Name
     */
    name: string;
    /**
     * Recorded Value
     */
    recorded_value: [
        number | null,
        string
    ];
    /**
     * Taxon Name
     */
    taxon_name: string;
    sdg_alignment_type: SdgAlignmentType;
    /**
     * Confidence
     */
    confidence?: number | null;
};

/**
 * RevenueDeltasWithAnnotations
 */
export type RevenueDeltasWithAnnotations = {
    /**
     * Year
     */
    year?: number | null;
    origin: RevenueDataOrigin;
    /**
     * Total Recorded Value
     */
    total_recorded_value: [
        number | null,
        string
    ];
    /**
     * Positive Percentage
     */
    positive_percentage: number;
    /**
     * Negative Percentage
     */
    negative_percentage: number;
    sdi_classification: SdiClassificationName;
    /**
     * Positive Confidence
     */
    positive_confidence?: number | null;
    /**
     * Negative Confidence
     */
    negative_confidence?: number | null;
    /**
     * Sdi Rationale
     */
    sdi_rationale?: string | null;
    /**
     * Segments
     */
    segments: Array<RevenueDeltasResponseSegment>;
    /**
     * Annotations
     */
    annotations: Array<string>;
};

/**
 * Rollup
 */
export type Rollup = {
    impact?: ValueObject | null;
    revenue_intensity?: ValueObject | null;
    evic_intensity?: ValueObject | null;
    impact_yoy?: ValueObject | null;
    impact_yoy_delta?: ValueObject | null;
    sdg_revenue_percentage?: ValueObject | null;
};

/**
 * SDG
 */
export type Sdg = {
    /**
     * Target
     */
    target: string;
    /**
     * Goal
     */
    goal?: string | null;
};

/**
 * SDGAlignmentStatus
 */
export type SdgAlignmentStatus = {
    [key: string]: boolean | null;
};

/**
 * SDGAlignmentType
 */
export const SdgAlignmentType = {
    NEGATIVE: 'negative',
    NOT_COVERED: 'not_covered',
    POSITIVE: 'positive',
    POTENTIAL: 'potential',
    POTENTIALLY_NEGATIVE: 'potentially_negative',
    POTENTIALLY_POSITIVE: 'potentially_positive'
} as const;

/**
 * SDGAlignmentType
 */
export type SdgAlignmentType = typeof SdgAlignmentType[keyof typeof SdgAlignmentType];

/**
 * SDGAumContribution
 */
export type SdgAumContribution = {
    /**
     * Aum Percentage
     */
    aum_percentage?: number | null;
    /**
     * Aum Usd
     */
    aum_usd?: number | null;
};

/**
 * SDGDataOrigin
 */
export const SdgDataOrigin = {
    FACTSET: 'factset',
    PSI: 'psi',
    REPORTED: 'reported'
} as const;

/**
 * SDGDataOrigin
 */
export type SdgDataOrigin = typeof SdgDataOrigin[keyof typeof SdgDataOrigin];

/**
 * SDGOrigin
 */
export const SdgOrigin = { REVENUE: 'revenue', OUTCOMES: 'outcomes' } as const;

/**
 * SDGOrigin
 */
export type SdgOrigin = typeof SdgOrigin[keyof typeof SdgOrigin];

/**
 * SDGRevenueContribution
 */
export type SdgRevenueContribution = {
    /**
     * Revenue Percentage
     */
    revenue_percentage?: number | null;
    /**
     * Revenue Usd
     */
    revenue_usd?: number | null;
};

/**
 * SDGRevenueInconsistenciesSummary
 */
export type SdgRevenueInconsistenciesSummary = {
    approved?: InconsistenciesSummary | null;
    proposed?: InconsistenciesSummary | null;
};

/**
 * SDGRevenuePipelineApproval
 */
export type SdgRevenuePipelineApproval = {
    /**
     * Is Approved
     */
    is_approved: boolean;
    /**
     * Comments
     */
    comments?: string | null;
    /**
     * Date Approved
     *
     *
     * Date of the specific dataset which has been approved
     * to be migrated to the main table.
     *
     */
    date_approved: string;
    /**
     * Id
     */
    id: number;
    /**
     * User Id
     */
    user_id: string;
    /**
     * Created Date
     *
     * Date when the approval was given.
     */
    created_date: string;
};

/**
 * SDGRevenuePipelineChangesRequest
 */
export type SdgRevenuePipelineChangesRequest = {
    /**
     * Check Latest Approved
     */
    check_latest_approved?: boolean;
    /**
     * Date To Validate
     */
    date_to_validate?: string | null;
};

/**
 * SDGRevenuePipelineInconsistenciesSummaryRequest
 */
export type SdgRevenuePipelineInconsistenciesSummaryRequest = {
    /**
     * Date To Validate
     */
    date_to_validate?: string | null;
};

/**
 * SDGRevenueRunDetails
 */
export type SdgRevenueRunDetails = {
    /**
     * Run Id
     */
    run_id: string;
    /**
     * Job Name
     */
    job_name: string;
    /**
     * Status
     */
    status: string;
    /**
     * Start Date
     */
    start_date?: string | null;
    /**
     * End Date
     */
    end_date?: string | null;
    /**
     * Is Finished
     */
    is_finished?: boolean;
};

/**
 * SDIActivityEvidence
 */
export type SdiActivityEvidence = {
    /**
     * Segment Id
     */
    segment_id?: number | null;
    /**
     * Segment Name
     */
    segment_name?: string | null;
    /**
     * Revenue Usd
     */
    revenue_usd: number;
    /**
     * Revenue Percentage
     */
    revenue_percentage: number;
    /**
     * Supporting Fact Id
     */
    supporting_fact_id?: number | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Formula Name
     */
    formula_name?: string | null;
    calculation?: SdiFormulaCalculationTree | null;
};

/**
 * SDIBundleDownload
 *
 * A signed GCS url for the SDI data bundle.
 */
export type SdiBundleDownload = {
    /**
     * Url
     */
    url: string;
};

/**
 * SDIFileExport
 */
export type SdiFileExport = {
    branch?: PromotedBranch;
    /**
     * Include Idm File
     */
    include_idm_file?: boolean;
};

/**
 * SDILabelsAum
 */
export type SdiLabelsAum = {
    /**
     * Aum Usd
     */
    aum_usd: number;
    /**
     * Aum Percentage
     */
    aum_percentage: number;
};

/**
 * SDILabelsAumBreakDown
 */
export type SdiLabelsAumBreakDown = {
    1: SdiLabelsAum;
    2: SdiLabelsAum;
    3: SdiLabelsAum;
    4: SdiLabelsAum;
    5: SdiLabelsAum;
    6: SdiLabelsAum;
    7: SdiLabelsAum;
    8: SdiLabelsAum;
    9: SdiLabelsAum;
    10: SdiLabelsAum;
    11: SdiLabelsAum;
    12: SdiLabelsAum;
    13: SdiLabelsAum;
    14: SdiLabelsAum;
    15: SdiLabelsAum;
    16: SdiLabelsAum;
    17: SdiLabelsAum;
};

/**
 * SDILabelsCountBreakDown
 */
export type SdiLabelsCountBreakDown = {
    1: SdiLabelsEntityCount;
    2: SdiLabelsEntityCount;
    3: SdiLabelsEntityCount;
    4: SdiLabelsEntityCount;
    5: SdiLabelsEntityCount;
    6: SdiLabelsEntityCount;
    7: SdiLabelsEntityCount;
    8: SdiLabelsEntityCount;
    9: SdiLabelsEntityCount;
    10: SdiLabelsEntityCount;
    11: SdiLabelsEntityCount;
    12: SdiLabelsEntityCount;
    13: SdiLabelsEntityCount;
    14: SdiLabelsEntityCount;
    15: SdiLabelsEntityCount;
    16: SdiLabelsEntityCount;
    17: SdiLabelsEntityCount;
};

/**
 * SDILabelsEntityCount
 */
export type SdiLabelsEntityCount = {
    /**
     * Entity Count
     */
    entity_count: number;
    /**
     * Entity Percentage
     */
    entity_percentage: number;
};

/**
 * SdiClassificationName
 */
export const SdiClassificationName = {
    NEGATIVE_MAJORITY_SDI: 'Negative Majority SDI',
    NEGATIVE_DECISIVE_SDI: 'Negative Decisive SDI',
    MAJORITY_SDI: 'Majority SDI',
    DECISIVE_SDI: 'Decisive SDI',
    NON_SDI: 'Non SDI'
} as const;

/**
 * SdiClassificationName
 */
export type SdiClassificationName = typeof SdiClassificationName[keyof typeof SdiClassificationName];

/**
 * SdiFormulaCalculationTree
 */
export type SdiFormulaCalculationTree = {
    value: KpiValue;
    date?: Date | null;
    /**
     * Data Origin
     */
    data_origin?: DataOrigin | DataOriginStr;
    operation?: KpiCalculationOperation | null;
    /**
     * Children
     */
    children?: Array<SdiFormulaCalculationTree> | null;
    /**
     * Commentary
     */
    commentary?: string | null;
    /**
     * Name
     */
    name?: string | null;
};

/**
 * SdiRevenueSource
 *
 *
 * Which table a merged SDI revenue row came from. Formula results win over
 * entity taxonomy revenue for any (entity, year) they cover.
 *
 */
export const SdiRevenueSource = {
    CATEGORICAL_ENTITY: 'categorical_entity',
    ENTITY_TAXONOMY_REVENUE: 'entity_taxonomy_revenue',
    SDI_FORMULA_RESULT: 'sdi_formula_result'
} as const;

/**
 * SdiRevenueSource
 *
 *
 * Which table a merged SDI revenue row came from. Formula results win over
 * entity taxonomy revenue for any (entity, year) they cover.
 *
 */
export type SdiRevenueSource = typeof SdiRevenueSource[keyof typeof SdiRevenueSource];

/**
 * SearchLink
 */
export type SearchLink = {
    /**
     * Url
     */
    url: string;
    /**
     * Entity Name
     */
    entity_name: string;
    /**
     * Year
     */
    year: number;
    report_type: ReportTypes;
};

/**
 * SearchResult
 */
export type SearchResult = {
    /**
     * Type
     */
    type: string;
    /**
     * Key
     */
    key: string;
    /**
     * Title
     */
    title: string;
    /**
     * Text
     */
    text: string;
    question_data?: QuestionSearchData | null;
    entity_data?: EntitySearchData | null;
    /**
     * Link
     */
    link?: string | null;
    /**
     * Relevance Score
     */
    relevance_score?: number | null;
    /**
     * Matched On
     */
    matched_on?: Array<MatchedOn> | null;
};

/**
 * Segment
 */
export type Segment = {
    /**
     * Segment Category
     */
    segment_category: string;
    /**
     * Segment Class
     */
    segment_class: string;
    /**
     * Segment Instance
     */
    segment_instance: string;
    /**
     * Segment Id
     */
    segment_id: number;
};

/**
 * SegmentTaxonMappingConfidence
 */
export const SegmentTaxonMappingConfidence = {
    1: 1,
    2: 2,
    3: 3
} as const;

/**
 * SegmentTaxonMappingConfidence
 */
export type SegmentTaxonMappingConfidence = typeof SegmentTaxonMappingConfidence[keyof typeof SegmentTaxonMappingConfidence];

/**
 * SemanticSearchFeedbackResponse
 */
export type SemanticSearchFeedbackResponse = {
    /**
     * Query
     */
    query: string;
    /**
     * Matched Text
     */
    matched_text: string;
    /**
     * Source Id
     */
    source_id: number;
    /**
     * Page Num
     */
    page_num: number;
    /**
     * Feedback
     */
    feedback: boolean;
    /**
     * Feedback Id
     */
    feedback_id: number;
    /**
     * User Id
     */
    user_id: string;
};

/**
 * SfdrValue
 */
export const SfdrValue = {
    EL: 'EL',
    N: 'N',
    N_EL: 'N/EL',
    Y: 'Y'
} as const;

/**
 * SfdrValue
 */
export type SfdrValue = typeof SfdrValue[keyof typeof SfdrValue];

/**
 * SimpleMetric
 */
export type SimpleMetric = {
    /**
     * Question Id
     */
    question_id?: number | null;
    /**
     * Type
     */
    type?: 'Simple metric';
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Unit Id
     */
    unit_id?: number | null;
    /**
     * Is Reported
     */
    is_reported?: boolean;
    /**
     * Is Estimated
     */
    is_estimated?: boolean;
    impact_level?: ImpactLevel | null;
    /**
     * Display Priority
     */
    display_priority?: number | null;
    /**
     * Is Sdg Eligible
     */
    is_sdg_eligible?: boolean | null;
    /**
     * Display Name
     */
    display_name?: string | null;
    /**
     * Metric Id
     */
    metric_id?: string | null;
};

/**
 * Source
 */
export type Source = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end?: string | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
    /**
     * Original Url
     */
    original_url?: string | null;
    /**
     * Url
     */
    url: string;
    report_type?: ReportTypes | null;
    file_type: SourceType;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Checksum
     */
    checksum?: string | null;
    status?: SourceStatus;
    /**
     * Language
     */
    language?: string | null;
    /**
     * Source Id
     */
    source_id: number;
};

/**
 * SourceBatch
 */
export type SourceBatch = {
    /**
     * Batch Id
     */
    batch_id: string;
    /**
     * Phase
     */
    phase: number;
    step: IngestionTaskStep;
    /**
     * Total Tasks
     */
    total_tasks: number;
    /**
     * Completed Tasks
     */
    completed_tasks: number;
    /**
     * Total Time Spent
     */
    total_time_spent: string;
    /**
     * Expected Time Remaining
     */
    expected_time_remaining?: string | null;
    /**
     * Priority
     */
    priority: number;
    state: TaskState;
};

/**
 * SourceBatchWithTasks
 */
export type SourceBatchWithTasks = {
    /**
     * Batch Id
     */
    batch_id: string;
    /**
     * Phase
     */
    phase: number;
    step: IngestionTaskStep;
    /**
     * Total Tasks
     */
    total_tasks: number;
    /**
     * Completed Tasks
     */
    completed_tasks: number;
    /**
     * Total Time Spent
     */
    total_time_spent: string;
    /**
     * Expected Time Remaining
     */
    expected_time_remaining?: string | null;
    /**
     * Priority
     */
    priority: number;
    state: TaskState;
    /**
     * Tasks
     */
    tasks: Array<SourceTask>;
};

/**
 * SourceEmbeddingRequested
 */
export type SourceEmbeddingRequested = {
    /**
     * Success
     */
    success: Array<number>;
    /**
     * Failed
     */
    failed: Array<number>;
};

/**
 * SourceStatus
 */
export const SourceStatus = {
    CANDIDATE: 'CANDIDATE',
    CHECK_ENTITY: 'CHECK ENTITY',
    EXTRACTED: 'EXTRACTED',
    NEW: 'NEW',
    REJECTED: 'REJECTED',
    VERIFIED: 'VERIFIED'
} as const;

/**
 * SourceStatus
 */
export type SourceStatus = typeof SourceStatus[keyof typeof SourceStatus];

/**
 * SourceTask
 */
export type SourceTask = {
    /**
     * Task Id
     */
    task_id?: number | null;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Priority
     */
    priority?: number;
    /**
     * Phase
     */
    phase: number;
    /**
     * Years
     */
    years: Array<number>;
    /**
     * User Id
     */
    user_id?: string | null;
    /**
     * Total Time Remaining
     */
    total_time_remaining?: string;
    /**
     * Total Time Spent
     */
    total_time_spent?: string;
    /**
     * Batch Id
     */
    batch_id: string;
    type: TaskType;
    task_workflow?: TaskWorkFlow | null;
    step: SourceTaskStep;
    /**
     * Reports Not Out
     */
    reports_not_out: boolean;
    state: TaskState;
};

/**
 * SourceTaskStep
 */
export const SourceTaskStep = { EXTRACT: 'EXTRACT', VERIFY: 'VERIFY' } as const;

/**
 * SourceTaskStep
 */
export type SourceTaskStep = typeof SourceTaskStep[keyof typeof SourceTaskStep];

/**
 * SourceType
 */
export const SourceType = {
    CDP: 'cdp',
    FACTSET: 'factset',
    OTHER: 'other',
    PDF: 'pdf',
    WEBPAGE: 'webpage',
    WEBSITE: 'website',
    XLSX: 'xlsx'
} as const;

/**
 * SourceType
 */
export type SourceType = typeof SourceType[keyof typeof SourceType];

/**
 * SourceWithLabelPredictions
 */
export type SourceWithLabelPredictions = {
    /**
     * Name
     */
    name?: string | null;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end?: string | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
    /**
     * Original Url
     */
    original_url?: string | null;
    /**
     * Url
     */
    url: string;
    report_type?: ReportTypes | null;
    file_type: SourceType;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    /**
     * Checksum
     */
    checksum?: string | null;
    status?: SourceStatus;
    /**
     * Language
     */
    language?: string | null;
    /**
     * Source Id
     */
    source_id: number;
    predictions?: DocumentLabelsResponse | null;
    /**
     * Num Unique Entity Occurrences
     */
    num_unique_entity_occurrences?: number | null;
};

/**
 * StreamAcceptedFact
 */
export type StreamAcceptedFact = {
    /**
     * Is High Yoy
     */
    is_high_yoy?: boolean;
    /**
     * High Yoy Reasons
     */
    high_yoy_reasons?: Array<HighYoyReason> | null;
    /**
     * Fact Id
     */
    fact_id?: number | null;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Aggregation
     */
    aggregation: string;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Year
     */
    year: number;
    /**
     * Status
     */
    status: string;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Metric Id
     */
    metric_id: string;
    /**
     * Supporting Facts
     */
    supporting_facts?: Array<ListAcceptedSupportingFact> | null;
    /**
     * Question Id
     */
    question_id: number;
};

/**
 * StreamKPIResult
 */
export type StreamKpiResult = {
    /**
     * Kpi Result Id
     */
    kpi_result_id: string;
    /**
     * Value
     */
    value: [
        number | null,
        string
    ];
    /**
     * Kpi Id
     */
    kpi_id: string;
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end: string;
    /**
     * Created At
     */
    created_at?: string | null;
    /**
     * Updated At
     */
    updated_at?: string | null;
    /**
     * Value Intensity
     */
    value_intensity?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy Pct
     */
    value_yoy_pct?: [
        number | null,
        string
    ] | null;
    /**
     * Value Yoy
     */
    value_yoy?: [
        number | null,
        string
    ] | null;
    /**
     * Year
     */
    year: number;
};

/**
 * TaskState
 */
export const TaskState = {
    BLOCKED: 'BLOCKED',
    COMPLETE: 'COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING'
} as const;

/**
 * TaskState
 */
export type TaskState = typeof TaskState[keyof typeof TaskState];

/**
 * TaskType
 */
export const TaskType = {
    BACKFILL: 'BACKFILL',
    NEW_ENTITY: 'NEW_ENTITY',
    UPDATE: 'UPDATE'
} as const;

/**
 * TaskType
 */
export type TaskType = typeof TaskType[keyof typeof TaskType];

/**
 * TaskWorkFlow
 */
export const TaskWorkFlow = { SOURCE: 'source', INGESTION: 'ingestion' } as const;

/**
 * TaskWorkFlow
 */
export type TaskWorkFlow = typeof TaskWorkFlow[keyof typeof TaskWorkFlow];

/**
 * TaxonType
 */
export const TaxonType = {
    TECHNOLOGY: 'technology',
    DOMAIN: 'domain',
    SUB_THEME: 'sub_theme',
    THEME: 'theme'
} as const;

/**
 * TaxonType
 */
export type TaxonType = typeof TaxonType[keyof typeof TaxonType];

/**
 * Theme
 *
 *
 * This previously listed all themes, but now only lists themes used for ingestion.
 * See DisplayThemes for themes displayed to clients.
 * Some of the themes here may be redundant, and will need to be removed later.
 *
 */
export const Theme = {
    ACCESS_TO_CLEAN_ENERGY: 'Access to clean energy',
    AFFORDABLE_HOUSING_AND_COMMUNITIES: 'Affordable housing and communities',
    AIR_QUALITY: 'Air quality',
    CLEAN_ENERGY: 'Clean energy',
    CLIMATE_CHANGE: 'Climate change',
    DECENT_WORK: 'Decent work',
    ECONOMIC_IMPACT: 'Economic impact',
    EDUCATION: 'Education',
    ENERGY: 'Energy',
    ACCESS_TO_FINANCIAL_SERVICES: 'Access to financial services',
    ACCESS_TO_FINANCIAL_SERVICES_BANKING: 'Access to financial services (banking)',
    ACCESS_TO_FINANCIAL_SERVICES_INSURANCE: 'Access to financial services (insurance)',
    ACCESS_TO_FINANCIAL_SERVICES_PAYMENT: 'Access to financial services (payment)',
    FUNDAMENTALS: 'Fundamentals',
    GENDER_EQUALITY: 'Gender equality',
    HEALTH_AND_SAFETY: 'Health and Safety',
    ACCESS_TO_HEALTHCARE: 'Access to healthcare',
    INDUSTRY_AND_INNOVATION: 'Industry and innovation',
    JOBS_CREATED: 'Jobs created',
    JUST_REVENUE: 'Just revenue',
    LAND: 'Land',
    PAI_MANDATORY: 'PAI mandatory',
    REVENUE_SEGMENTS: 'Revenue Segments',
    SDI_CLASSIFICATION: 'SDI classification',
    SOLID_WASTE: 'Solid waste',
    SUSTAINABLE_FINANCE: 'Sustainable Finance',
    WAGE_EQUALITY: 'Wage equality',
    WATER_USE: 'Water use'
} as const;

/**
 * Theme
 *
 *
 * This previously listed all themes, but now only lists themes used for ingestion.
 * See DisplayThemes for themes displayed to clients.
 * Some of the themes here may be redundant, and will need to be removed later.
 *
 */
export type Theme = typeof Theme[keyof typeof Theme];

/**
 * ThemeGoal
 */
export type ThemeGoal = {
    /**
     * Question Id
     */
    question_id: number;
    /**
     * Name
     */
    name: string;
    /**
     * Display Themes
     */
    display_themes?: Array<DisplayTheme>;
};

/**
 * TimeSeriesData
 */
export type TimeSeriesData = {
    reported?: ReportedDatapoint | null;
    estimated?: TimeseriesEstimatedDatapoint | null;
};

/**
 * TimeSeriesRow
 */
export type TimeSeriesRow = {
    /**
     * Question Id
     */
    question_id: number | string;
    /**
     * Question Name
     */
    question_name: string;
    /**
     * Question Description
     */
    question_description?: string | null;
    /**
     * Question Unit
     */
    question_unit: string;
    question_type: QuestionType1;
    /**
     * Datapoints
     */
    datapoints: Array<TimeSeriesData>;
    /**
     * Display Themes
     */
    display_themes: Array<DisplayThemeWithSdg>;
    /**
     * Final Year
     */
    final_year: number;
    /**
     * N Years
     */
    n_years: number;
    sdg_goals: TimeSeriesSdgGoals;
};

/**
 * TimeSeriesSDGGoals
 */
export type TimeSeriesSdgGoals = {
    reported?: SdgAlignmentStatus | null;
    estimated?: SdgAlignmentStatus | null;
};

/**
 * TimeseriesEstimatedDatapoint
 *
 * In order to have the required data to power the data -> grid link,
 * we need to have this metadata alongside the value
 */
export type TimeseriesEstimatedDatapoint = {
    /**
     * Value
     */
    value?: number | null;
    /**
     * Is Derived
     */
    is_derived?: boolean;
    /**
     * Is Nd
     */
    is_nd?: boolean;
    /**
     * Year
     */
    year: number;
    /**
     * Entity Id
     */
    entity_id: number;
    /**
     * Technology Ids
     */
    technology_ids: Array<string>;
};

/**
 * TopPagesResponse
 */
export type TopPagesResponse = {
    /**
     * Model Id
     */
    model_id: string;
    /**
     * Top Pages Per Label
     */
    top_pages_per_label: {
        [key: string]: Array<PageClassificationResult>;
    };
};

/**
 * TriggerSDIRevenuePipelineRequest
 */
export type TriggerSdiRevenuePipelineRequest = {
    /**
     * Entity Ids
     */
    entity_ids?: Array<number> | null;
    /**
     * Force Facts Promotion
     */
    force_facts_promotion?: boolean;
};

/**
 * Unit
 */
export type Unit = {
    /**
     * Name
     */
    name: string;
    /**
     * Description
     */
    description?: string | null;
    /**
     * Iso Code
     */
    iso_code?: string | null;
    /**
     * Is Standard
     */
    is_standard?: boolean | null;
    /**
     * Standard Id
     */
    standard_id?: number | null;
    /**
     * Conversion Factor
     */
    conversion_factor?: number | null;
    /**
     * Unit Type
     */
    unit_type?: string | null;
    /**
     * Unit Id
     */
    unit_id: number;
};

/**
 * UpdateElapsedFactTime
 */
export type UpdateElapsedFactTime = {
    /**
     * Task Id
     */
    task_id: number;
    /**
     * Elapsed
     */
    elapsed: string;
};

/**
 * UpdateSegment
 */
export type UpdateSegment = {
    /**
     * Segment Category
     */
    segment_category?: string | null;
    /**
     * Segment Class
     */
    segment_class?: string | null;
    /**
     * Segment Instance
     */
    segment_instance?: string | null;
};

/**
 * UpdateSemanticSearchFeedback
 */
export type UpdateSemanticSearchFeedback = {
    /**
     * Feedback
     */
    feedback: boolean;
};

/**
 * UploadFile
 */
export type UploadFile = {
    /**
     * Name
     */
    name: string;
    /**
     * Start
     */
    start?: string | null;
    /**
     * End
     */
    end?: string | null;
    /**
     * Publishing Date
     */
    publishing_date?: string | null;
    /**
     * Original Url
     */
    original_url?: string | null;
    report_type: ReportTypes;
    file_type: SourceType;
    /**
     * Entity Id
     */
    entity_id?: number | null;
    status?: SourceStatus;
};

/**
 * ValidationError
 */
export type ValidationError = {
    /**
     * Location
     */
    loc: Array<string | number>;
    /**
     * Message
     */
    msg: string;
    /**
     * Error Type
     */
    type: string;
    /**
     * Input
     */
    input?: unknown;
    /**
     * Context
     */
    ctx?: {
        [key: string]: unknown;
    };
};

/**
 * Value
 */
export type Value = {
    /**
     * Value
     */
    value: number;
    unit: Unit;
};

/**
 * ValueObject
 */
export type ValueObject = {
    /**
     * Value
     */
    value: number | null;
    /**
     * Unit
     */
    unit: string;
};

/**
 * WatchlistResponse
 */
export type WatchlistResponse = {
    /**
     * Portfolio Id
     */
    portfolio_id: number;
    /**
     * Name
     */
    name: string;
    type: PortfolioTypes;
    /**
     * Total Value
     */
    total_value?: number | null;
    /**
     * Valuation Date
     */
    valuation_date: string;
    /**
     * Snapshot Id
     */
    snapshot_id?: number | null;
    /**
     * Missing Entity Ids
     */
    missing_entity_ids?: Array<number> | null;
};

/**
 * WorkerResult
 */
export type WorkerResult = {
    /**
     * Uuid
     */
    uuid: string;
    status?: ResultStatuses;
    type?: ResultTypes;
    /**
     * Data
     */
    data?: unknown | null;
    /**
     * File Display Name
     */
    file_display_name?: string | null;
};

/**
 * QuestionType
 */
export const NpSchemaKpiDslOriginQuestionQuestionType = {
    KPI: 'kpi',
    METRIC: 'metric',
    SIMPLE_METRIC: 'simple_metric'
} as const;

/**
 * QuestionType
 */
export type NpSchemaKpiDslOriginQuestionQuestionType = typeof NpSchemaKpiDslOriginQuestionQuestionType[keyof typeof NpSchemaKpiDslOriginQuestionQuestionType];

export type ListAcceptedFactChangesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/accepted_facts/changes';
};

export type ListAcceptedFactChangesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListAcceptedFactChangesError = ListAcceptedFactChangesErrors[keyof ListAcceptedFactChangesErrors];

export type ListAcceptedFactChangesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseAcceptedFactChange;
};

export type ListAcceptedFactChangesResponse = ListAcceptedFactChangesResponses[keyof ListAcceptedFactChangesResponses];

export type ListAcceptedFactsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/accepted_facts';
};

export type ListAcceptedFactsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListAcceptedFactsError = ListAcceptedFactsErrors[keyof ListAcceptedFactsErrors];

export type ListAcceptedFactsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseListAcceptedFact;
};

export type ListAcceptedFactsResponse = ListAcceptedFactsResponses[keyof ListAcceptedFactsResponses];

export type StreamAcceptedFactsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Metric Id
         *
         * Filter for only specific metric_ids
         */
        metric_id?: Array<string> | null;
        /**
         * Entity Id
         *
         * Filter for only specific entity_ids.
         */
        entity_id?: Array<number> | null;
        /**
         * Question Id
         *
         * Filter for specific question_ids.
         */
        question_id?: Array<number> | null;
        /**
         * Batch Size
         *
         * Control the batch_size of the stream. Can tune performance.
         */
        batch_size?: number;
    };
    url: '/api/v1/accepted_facts/stream';
};

export type StreamAcceptedFactsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StreamAcceptedFactsError = StreamAcceptedFactsErrors[keyof StreamAcceptedFactsErrors];

export type StreamAcceptedFactsResponses = {
    /**
     * Response Stream Accepted Facts
     *
     * Successful Response
     */
    200: Array<StreamAcceptedFact>;
};

export type StreamAcceptedFactsResponse = StreamAcceptedFactsResponses[keyof StreamAcceptedFactsResponses];

export type GetAcceptedFactData = {
    body?: never;
    path: {
        /**
         * Accepted Fact Id
         */
        accepted_fact_id: number;
    };
    query?: never;
    url: '/api/v1/accepted_facts/{accepted_fact_id}';
};

export type GetAcceptedFactErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetAcceptedFactError = GetAcceptedFactErrors[keyof GetAcceptedFactErrors];

export type GetAcceptedFactResponses = {
    /**
     * Successful Response
     */
    200: AcceptedFact;
};

export type GetAcceptedFactResponse = GetAcceptedFactResponses[keyof GetAcceptedFactResponses];

export type GetFactChangesData = {
    body?: never;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: never;
    url: '/api/v1/accepted_facts/changes/{fact_id}';
};

export type GetFactChangesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetFactChangesError = GetFactChangesErrors[keyof GetFactChangesErrors];

export type GetFactChangesResponses = {
    /**
     * Response Get Fact Changes
     *
     * Successful Response
     */
    200: Array<AcceptedFactChange>;
};

export type GetFactChangesResponse = GetFactChangesResponses[keyof GetFactChangesResponses];

export type GetAcceptedFactValuesData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Year
         */
        year: number;
        /**
         * Question Id
         */
        question_id: number;
    };
    query?: never;
    url: '/api/v1/accepted_facts/{entity_id}/{year}/{question_id}';
};

export type GetAcceptedFactValuesErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetAcceptedFactValuesError = GetAcceptedFactValuesErrors[keyof GetAcceptedFactValuesErrors];

export type GetAcceptedFactValuesResponses = {
    /**
     * Successful Response
     */
    200: AcceptedFactValues;
};

export type GetAcceptedFactValuesResponse = GetAcceptedFactValuesResponses[keyof GetAcceptedFactValuesResponses];

export type ListIngestionBatchesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/batches/ingestion';
};

export type ListIngestionBatchesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListIngestionBatchesError = ListIngestionBatchesErrors[keyof ListIngestionBatchesErrors];

export type ListIngestionBatchesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseIngestionBatch;
};

export type ListIngestionBatchesResponse = ListIngestionBatchesResponses[keyof ListIngestionBatchesResponses];

export type GetIngestionBatchData = {
    body?: never;
    path: {
        /**
         * Batch Id
         */
        batch_id: string;
    };
    query?: {
        /**
         * Q
         */
        q?: string | null;
    };
    url: '/api/v1/batches/ingestion/{batch_id}';
};

export type GetIngestionBatchErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetIngestionBatchError = GetIngestionBatchErrors[keyof GetIngestionBatchErrors];

export type GetIngestionBatchResponses = {
    /**
     * Successful Response
     */
    200: IngestionBatchWithTasks;
};

export type GetIngestionBatchResponse = GetIngestionBatchResponses[keyof GetIngestionBatchResponses];

export type SetIngestionBatchPriorityData = {
    /**
     * Batch Ids
     */
    body: Array<string>;
    path?: never;
    query?: never;
    url: '/api/v1/batches/ingestion/set-priority';
};

export type SetIngestionBatchPriorityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SetIngestionBatchPriorityError = SetIngestionBatchPriorityErrors[keyof SetIngestionBatchPriorityErrors];

export type SetIngestionBatchPriorityResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListSourceBatchesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/batches/source';
};

export type ListSourceBatchesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSourceBatchesError = ListSourceBatchesErrors[keyof ListSourceBatchesErrors];

export type ListSourceBatchesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseSourceBatch;
};

export type ListSourceBatchesResponse = ListSourceBatchesResponses[keyof ListSourceBatchesResponses];

export type GetSourceBatchData = {
    body?: never;
    path: {
        /**
         * Batch Id
         */
        batch_id: string;
    };
    query?: {
        /**
         * Q
         */
        q?: string | null;
    };
    url: '/api/v1/batches/source/{batch_id}';
};

export type GetSourceBatchErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSourceBatchError = GetSourceBatchErrors[keyof GetSourceBatchErrors];

export type GetSourceBatchResponses = {
    /**
     * Successful Response
     */
    200: SourceBatchWithTasks;
};

export type GetSourceBatchResponse = GetSourceBatchResponses[keyof GetSourceBatchResponses];

export type SetSourceBatchPriorityData = {
    /**
     * Batch Ids
     */
    body: Array<string>;
    path?: never;
    query?: never;
    url: '/api/v1/batches/source/set-priority';
};

export type SetSourceBatchPriorityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SetSourceBatchPriorityError = SetSourceBatchPriorityErrors[keyof SetSourceBatchPriorityErrors];

export type SetSourceBatchPriorityResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetQuestionCoverageDataData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: {
        /**
         * Portfolio Id
         */
        portfolio_id?: number;
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
    };
    url: '/api/v1/coverage';
};

export type GetQuestionCoverageDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetQuestionCoverageDataError = GetQuestionCoverageDataErrors[keyof GetQuestionCoverageDataErrors];

export type GetQuestionCoverageDataResponses = {
    /**
     * Response Get Question Coverage Data
     *
     * Successful Response
     */
    200: Array<QuestionDisclosure>;
};

export type GetQuestionCoverageDataResponse = GetQuestionCoverageDataResponses[keyof GetQuestionCoverageDataResponses];

export type ExportCompareDataData = {
    body: CompareDataExport;
    path?: never;
    query?: never;
    url: '/api/v1/compare/export';
};

export type ExportCompareDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportCompareDataError = ExportCompareDataErrors[keyof ExportCompareDataErrors];

export type ExportCompareDataResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetDataDictionaryData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
        /**
         * Include All Sdg Revenue Questions
         */
        include_all_sdg_revenue_questions?: boolean;
    };
    url: '/api/v1/data_dictionary';
};

export type GetDataDictionaryErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDataDictionaryError = GetDataDictionaryErrors[keyof GetDataDictionaryErrors];

export type GetDataDictionaryResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseDataDictionaryQuestion;
};

export type GetDataDictionaryResponse = GetDataDictionaryResponses[keyof GetDataDictionaryResponses];

export type ExportDataDictionaryData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/data_dictionary/export';
};

export type ExportDataDictionaryErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportDataDictionaryError = ExportDataDictionaryErrors[keyof ExportDataDictionaryErrors];

export type ExportDataDictionaryResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportDataDictionaryResponse = ExportDataDictionaryResponses[keyof ExportDataDictionaryResponses];

export type UploadSectorToTaxonomyData = {
    body: BodyUploadSectorToTaxonomy;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/upload_sector_to_taxonomy';
};

export type UploadSectorToTaxonomyErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UploadSectorToTaxonomyError = UploadSectorToTaxonomyErrors[keyof UploadSectorToTaxonomyErrors];

export type UploadSectorToTaxonomyResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UploadSegmentToTaxonomyData = {
    body: BodyUploadSegmentToTaxonomy;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/upload_segment_to_taxonomy';
};

export type UploadSegmentToTaxonomyErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UploadSegmentToTaxonomyError = UploadSegmentToTaxonomyErrors[keyof UploadSegmentToTaxonomyErrors];

export type UploadSegmentToTaxonomyResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UploadTaxonomyAlignmentData = {
    body: BodyUploadTaxonomyAlignment;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/upload_taxonomy_alignment';
};

export type UploadTaxonomyAlignmentErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UploadTaxonomyAlignmentError = UploadTaxonomyAlignmentErrors[keyof UploadTaxonomyAlignmentErrors];

export type UploadTaxonomyAlignmentResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListSdgRevenueAlignmentData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Year
         */
        year?: number | null;
        /**
         * Page
         */
        page?: number;
        /**
         * Limit
         */
        limit?: number;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/entities/sdg_revenue_alignment';
};

export type ListSdgRevenueAlignmentErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSdgRevenueAlignmentError = ListSdgRevenueAlignmentErrors[keyof ListSdgRevenueAlignmentErrors];

export type ListSdgRevenueAlignmentResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEntityRevenueAlignment;
};

export type ListSdgRevenueAlignmentResponse = ListSdgRevenueAlignmentResponses[keyof ListSdgRevenueAlignmentResponses];

export type GetEntityActivitiesSdgRevenueAlignmentData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities';
};

export type GetEntityActivitiesSdgRevenueAlignmentErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityActivitiesSdgRevenueAlignmentError = GetEntityActivitiesSdgRevenueAlignmentErrors[keyof GetEntityActivitiesSdgRevenueAlignmentErrors];

export type GetEntityActivitiesSdgRevenueAlignmentResponses = {
    /**
     * Successful Response
     */
    200: EntityActivityContributionSummary;
};

export type GetEntityActivitiesSdgRevenueAlignmentResponse = GetEntityActivitiesSdgRevenueAlignmentResponses[keyof GetEntityActivitiesSdgRevenueAlignmentResponses];

export type ExportEntityActivitiesXlsxData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities/export';
};

export type ExportEntityActivitiesXlsxErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportEntityActivitiesXlsxError = ExportEntityActivitiesXlsxErrors[keyof ExportEntityActivitiesXlsxErrors];

export type ExportEntityActivitiesXlsxResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetEntityActivitiesSdgRevenueAlignmentByTaxonData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Taxon Id
         */
        taxon_id: number;
    };
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/{entity_id}/activities/{taxon_id}';
};

export type GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityActivitiesSdgRevenueAlignmentByTaxonError = GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors[keyof GetEntityActivitiesSdgRevenueAlignmentByTaxonErrors];

export type GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses = {
    /**
     * Successful Response
     */
    200: EntityActivityContributionByTaxon;
};

export type GetEntityActivitiesSdgRevenueAlignmentByTaxonResponse = GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses[keyof GetEntityActivitiesSdgRevenueAlignmentByTaxonResponses];

export type AddSdgRevenuePipelineApprovalData = {
    body: CreateSdgRevenuePipelineApprovalRequest;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/approve_sdg_revenue_data';
};

export type AddSdgRevenuePipelineApprovalErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AddSdgRevenuePipelineApprovalError = AddSdgRevenuePipelineApprovalErrors[keyof AddSdgRevenuePipelineApprovalErrors];

export type AddSdgRevenuePipelineApprovalResponses = {
    /**
     * Successful Response
     */
    201: SdgRevenuePipelineApproval;
};

export type AddSdgRevenuePipelineApprovalResponse = AddSdgRevenuePipelineApprovalResponses[keyof AddSdgRevenuePipelineApprovalResponses];

export type TriggerValidationPipelineData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/trigger_validation_pipeline';
};

export type TriggerValidationPipelineResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type CalculateRevenueDeltasData = {
    body: RevenueDeltasRequest;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/deltas';
};

export type CalculateRevenueDeltasErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CalculateRevenueDeltasError = CalculateRevenueDeltasErrors[keyof CalculateRevenueDeltasErrors];

export type CalculateRevenueDeltasResponses = {
    /**
     * Successful Response
     */
    200: RevenueDeltasResponse;
};

export type CalculateRevenueDeltasResponse = CalculateRevenueDeltasResponses[keyof CalculateRevenueDeltasResponses];

export type ExportSdgRevenueDataChangesData = {
    body: SdgRevenuePipelineChangesRequest;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/export_sdg_revenue_data_changes';
};

export type ExportSdgRevenueDataChangesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportSdgRevenueDataChangesError = ExportSdgRevenueDataChangesErrors[keyof ExportSdgRevenueDataChangesErrors];

export type ExportSdgRevenueDataChangesResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetTemporaryTableDatesData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/temporary_table_dates';
};

export type GetTemporaryTableDatesResponses = {
    /**
     * Response Get Temporary Table Dates
     *
     * Successful Response
     */
    200: Array<string>;
};

export type GetTemporaryTableDatesResponse = GetTemporaryTableDatesResponses[keyof GetTemporaryTableDatesResponses];

export type GetInconsistenciesSummaryData = {
    body: SdgRevenuePipelineInconsistenciesSummaryRequest;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/get_inconsistencies_summary';
};

export type GetInconsistenciesSummaryErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetInconsistenciesSummaryError = GetInconsistenciesSummaryErrors[keyof GetInconsistenciesSummaryErrors];

export type GetInconsistenciesSummaryResponses = {
    /**
     * Successful Response
     */
    200: SdgRevenueInconsistenciesSummary;
};

export type GetInconsistenciesSummaryResponse = GetInconsistenciesSummaryResponses[keyof GetInconsistenciesSummaryResponses];

export type GetValidationPipelineStatusData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sdg_revenue_alignment/validation_pipeline_status';
};

export type GetValidationPipelineStatusResponses = {
    /**
     * Successful Response
     */
    200: SdgRevenueRunDetails;
};

export type GetValidationPipelineStatusResponse = GetValidationPipelineStatusResponses[keyof GetValidationPipelineStatusResponses];

export type ListEntitiesData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: {
        /**
         * Q
         *
         * Old style q-encoded query options.
         */
        q?: string;
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'. Default is question_id, entity_id, year DESC
         */
        sort_by?: Array<string> | null;
    };
    url: '/api/v1/entities';
};

export type ListEntitiesErrors = {
    /**
     * Unprocessable Content
     */
    422: Detail;
};

export type ListEntitiesError = ListEntitiesErrors[keyof ListEntitiesErrors];

export type ListEntitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEntityWithOptionalDetailsAndSdgRevenuePct;
};

export type ListEntitiesResponse = ListEntitiesResponses[keyof ListEntitiesResponses];

export type CreateEntityData = {
    body: CreateEntity;
    path?: never;
    query?: never;
    url: '/api/v1/entities';
};

export type CreateEntityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateEntityError = CreateEntityErrors[keyof CreateEntityErrors];

export type CreateEntityResponses = {
    /**
     * Successful Response
     */
    201: Entity;
};

export type CreateEntityResponse = CreateEntityResponses[keyof CreateEntityResponses];

export type IdentifyEntitiesData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Identifier
         *
         * Legacy EntisID, ISIN, PermId, ticker, LEI, CUSIP, SEDOL, FIGI, FactSet id or exact company name.
         */
        identifier: Array<string>;
        /**
         * Q
         *
         * Old style q-encoded query options.
         */
        q?: string;
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'. Default is question_id, entity_id, year DESC
         */
        sort_by?: Array<string> | null;
    };
    url: '/api/v1/entities/identify';
};

export type IdentifyEntitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type IdentifyEntitiesError = IdentifyEntitiesErrors[keyof IdentifyEntitiesErrors];

export type IdentifyEntitiesResponses = {
    /**
     * Response Identify Entities
     *
     * Successful Response
     */
    200: Array<EntityIdentification>;
};

export type IdentifyEntitiesResponse = IdentifyEntitiesResponses[keyof IdentifyEntitiesResponses];

export type ListInactiveEntitiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Entity Id
         */
        entity_id?: Array<number> | null;
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'
         */
        sort_by?: Array<string> | null;
        /**
         * Entity Ids
         *
         * List of entity ids to include in the dataset.If unset all entity ids are returned
         */
        entity_ids?: Array<string> | null;
    };
    url: '/api/v1/entities/inactive';
};

export type ListInactiveEntitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListInactiveEntitiesError = ListInactiveEntitiesErrors[keyof ListInactiveEntitiesErrors];

export type ListInactiveEntitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseInactiveEntity;
};

export type ListInactiveEntitiesResponse = ListInactiveEntitiesResponses[keyof ListInactiveEntitiesResponses];

export type GetInactiveEntityData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: {
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'
         */
        sort_by?: Array<string> | null;
        /**
         * Entity Ids
         *
         * List of entity ids to include in the dataset.If unset all entity ids are returned
         */
        entity_ids?: Array<string> | null;
    };
    url: '/api/v1/entities/inactive/{entity_id}';
};

export type GetInactiveEntityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetInactiveEntityError = GetInactiveEntityErrors[keyof GetInactiveEntityErrors];

export type GetInactiveEntityResponses = {
    /**
     * Successful Response
     */
    200: InactiveEntity;
};

export type GetInactiveEntityResponse = GetInactiveEntityResponses[keyof GetInactiveEntityResponses];

export type MergeEntitiesData = {
    body: MergeTwoEntities;
    path?: never;
    query?: never;
    url: '/api/v1/entities/merge';
};

export type MergeEntitiesErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type MergeEntitiesError = MergeEntitiesErrors[keyof MergeEntitiesErrors];

export type MergeEntitiesResponses = {
    /**
     * Successful Response
     */
    200: Entity;
};

export type MergeEntitiesResponse = MergeEntitiesResponses[keyof MergeEntitiesResponses];

export type DeleteEntityData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}';
};

export type DeleteEntityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteEntityError = DeleteEntityErrors[keyof DeleteEntityErrors];

export type DeleteEntityResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetEntityData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: {
        /**
         * Q
         *
         * Old style q-encoded query options.
         */
        q?: string;
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'. Default is question_id, entity_id, year DESC
         */
        sort_by?: Array<string> | null;
    };
    url: '/api/v1/entities/{entity_id}';
};

export type GetEntityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityError = GetEntityErrors[keyof GetEntityErrors];

export type GetEntityResponses = {
    /**
     * Successful Response
     */
    200: EntityWithOptionalDetails;
};

export type GetEntityResponse = GetEntityResponses[keyof GetEntityResponses];

export type PatchUpdateEntityData = {
    /**
     * Data
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}';
};

export type PatchUpdateEntityErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PatchUpdateEntityError = PatchUpdateEntityErrors[keyof PatchUpdateEntityErrors];

export type PatchUpdateEntityResponses = {
    /**
     * Successful Response
     */
    200: Entity;
};

export type PatchUpdateEntityResponse = PatchUpdateEntityResponses[keyof PatchUpdateEntityResponses];

export type PutUpdateEntityData = {
    /**
     * Data
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}';
};

export type PutUpdateEntityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type PutUpdateEntityError = PutUpdateEntityErrors[keyof PutUpdateEntityErrors];

export type PutUpdateEntityResponses = {
    /**
     * Successful Response
     */
    200: Entity;
};

export type PutUpdateEntityResponse = PutUpdateEntityResponses[keyof PutUpdateEntityResponses];

export type ListSdgOutcomesForEntitiesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/entities/sdg_outcomes';
};

export type ListSdgOutcomesForEntitiesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSdgOutcomesForEntitiesError = ListSdgOutcomesForEntitiesErrors[keyof ListSdgOutcomesForEntitiesErrors];

export type ListSdgOutcomesForEntitiesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEntitySdgContributions;
};

export type ListSdgOutcomesForEntitiesResponse = ListSdgOutcomesForEntitiesResponses[keyof ListSdgOutcomesForEntitiesResponses];

export type GetEntityDashboardDataData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: {
        /**
         * Metrics Config Id
         */
        metrics_config_id?: string | null;
    };
    url: '/api/v1/entities/{entity_id}/dashboard';
};

export type GetEntityDashboardDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityDashboardDataError = GetEntityDashboardDataErrors[keyof GetEntityDashboardDataErrors];

export type GetEntityDashboardDataResponses = {
    /**
     * Response Get Entity Dashboard Data
     *
     * Successful Response
     */
    200: Array<EntityImpactData>;
};

export type GetEntityDashboardDataResponse = GetEntityDashboardDataResponses[keyof GetEntityDashboardDataResponses];

export type ExportEntityDashboardXlsxData = {
    body: EntityDashboardExport;
    path?: never;
    query?: never;
    url: '/api/v1/entities/dashboard/export';
};

export type ExportEntityDashboardXlsxErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportEntityDashboardXlsxError = ExportEntityDashboardXlsxErrors[keyof ExportEntityDashboardXlsxErrors];

export type ExportEntityDashboardXlsxResponses = {
    /**
     * Response Export Entity Dashboard Xlsx
     *
     * Successful Response
     */
    200: Array<EntityImpactData>;
};

export type ExportEntityDashboardXlsxResponse = ExportEntityDashboardXlsxResponses[keyof ExportEntityDashboardXlsxResponses];

export type ExportEntityData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * ID of the entity to export
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}/export';
};

export type ExportEntityErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportEntityError = ExportEntityErrors[keyof ExportEntityErrors];

export type ExportEntityResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportEntityResponse = ExportEntityResponses[keyof ExportEntityResponses];

export type LookupEntitiesData = {
    body: BodyLookupEntities;
    path?: never;
    query?: {
        /**
         * Include Np Data
         */
        include_np_data?: boolean | null;
        /**
         * Include Fundamentals
         */
        include_fundamentals?: boolean | null;
        /**
         * Include Sectors
         */
        include_sectors?: boolean | null;
        /**
         * Should Ensure Public Entities
         */
        should_ensure_public_entities?: boolean | null;
        /**
         * Identifier Type
         */
        identifier_type?: string | null;
        /**
         * Identifier Col
         */
        identifier_col?: string | null;
        /**
         * Output Format
         */
        output_format?: ExportFormats | null;
    };
    url: '/api/v1/entities/lookup';
};

export type LookupEntitiesErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
    /**
     * Not Implemented
     */
    501: Message;
};

export type LookupEntitiesError = LookupEntitiesErrors[keyof LookupEntitiesErrors];

export type LookupEntitiesResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromise;
};

export type LookupEntitiesResponse = LookupEntitiesResponses[keyof LookupEntitiesResponses];

export type LookupSfdrData = {
    body: BodyLookupSfdr;
    path?: never;
    query?: never;
    url: '/api/v1/entities/sfdr_lookup';
};

export type LookupSfdrErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
    /**
     * Not Implemented
     */
    501: Message;
};

export type LookupSfdrError = LookupSfdrErrors[keyof LookupSfdrErrors];

export type LookupSfdrResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromise;
};

export type LookupSfdrResponse = LookupSfdrResponses[keyof LookupSfdrResponses];

export type GetTimeseriesFactsData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: {
        /**
         * Page
         */
        page?: number | null;
        /**
         * Limit
         */
        limit?: number | null;
        /**
         * N Years
         */
        n_years?: number | null;
        /**
         * End Year
         */
        end_year?: number | null;
        /**
         * Sort By
         */
        sort_by?: Array<string> | null;
        /**
         * Data Type
         */
        data_type?: Array<string> | null;
        /**
         * Search Term
         */
        search_term?: string | null;
        /**
         * Metrics Config Id
         */
        metrics_config_id?: string | null;
    };
    url: '/api/v1/entities/{entity_id}/timeseries';
};

export type GetTimeseriesFactsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetTimeseriesFactsError = GetTimeseriesFactsErrors[keyof GetTimeseriesFactsErrors];

export type GetTimeseriesFactsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseTimeSeriesRow;
};

export type GetTimeseriesFactsResponse = GetTimeseriesFactsResponses[keyof GetTimeseriesFactsResponses];

export type GetEntityPortfoliosData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string | null;
    };
    url: '/api/v1/entities/{entity_id}/portfolios';
};

export type GetEntityPortfoliosErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityPortfoliosError = GetEntityPortfoliosErrors[keyof GetEntityPortfoliosErrors];

export type GetEntityPortfoliosResponses = {
    /**
     * Response Get Entity Portfolios
     *
     * Successful Response
     */
    200: Array<PortfolioWithEntityDetail>;
};

export type GetEntityPortfoliosResponse = GetEntityPortfoliosResponses[keyof GetEntityPortfoliosResponses];

export type GetEntityBreakdownByFundsData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string | null;
    };
    url: '/api/v1/entities/{entity_id}/portfolios/{portfolio_id}/breakdown';
};

export type GetEntityBreakdownByFundsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityBreakdownByFundsError = GetEntityBreakdownByFundsErrors[keyof GetEntityBreakdownByFundsErrors];

export type GetEntityBreakdownByFundsResponses = {
    /**
     * Successful Response
     */
    200: EntityBreakdownByFunds;
};

export type GetEntityBreakdownByFundsResponse = GetEntityBreakdownByFundsResponses[keyof GetEntityBreakdownByFundsResponses];

export type CreateEntitiesData = {
    body: BodyCreateEntities;
    path?: never;
    query?: never;
    url: '/api/v1/entities/create_entities';
};

export type CreateEntitiesErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateEntitiesError = CreateEntitiesErrors[keyof CreateEntitiesErrors];

export type CreateEntitiesResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListQuestionEntitiesDataData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Question Id
         */
        question_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/entities/question/{question_id}';
};

export type ListQuestionEntitiesDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListQuestionEntitiesDataError = ListQuestionEntitiesDataErrors[keyof ListQuestionEntitiesDataErrors];

export type ListQuestionEntitiesDataResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseWithTotalsInsightResultsInsightTotals;
};

export type ListQuestionEntitiesDataResponse = ListQuestionEntitiesDataResponses[keyof ListQuestionEntitiesDataResponses];

export type GetEntityEstimationsSummaryData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}/estimations_summary';
};

export type GetEntityEstimationsSummaryErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntityEstimationsSummaryError = GetEntityEstimationsSummaryErrors[keyof GetEntityEstimationsSummaryErrors];

export type GetEntityEstimationsSummaryResponses = {
    /**
     * Successful Response
     */
    200: EntityEstimationSummary;
};

export type GetEntityEstimationsSummaryResponse = GetEntityEstimationsSummaryResponses[keyof GetEntityEstimationsSummaryResponses];

export type GetEstimatedDataData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Question Id
         */
        question_id: number;
        /**
         * Year
         */
        year: number;
    };
    query?: {
        /**
         * Technology Ids
         */
        technology_ids?: Array<string> | null;
    };
    url: '/api/v1/entities/{entity_id}/estimated_data/{question_id}/{year}';
};

export type GetEstimatedDataErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEstimatedDataError = GetEstimatedDataErrors[keyof GetEstimatedDataErrors];

export type GetEstimatedDataResponses = {
    /**
     * Response Get Estimated Data
     *
     * Successful Response
     */
    200: Array<EstimatedData>;
};

export type GetEstimatedDataResponse = GetEstimatedDataResponses[keyof GetEstimatedDataResponses];

export type GetLatestDataData = {
    body?: never;
    path: {
        /**
         * Entity Id
         *
         * The ID of the entity
         */
        entity_id: number;
        /**
         * Question Id
         *
         * The ID of the question
         */
        question_id: number;
    };
    query?: {
        /**
         * Cutoff Date
         *
         * Optional cutoff date for time-aware filtering
         */
        cutoff_date?: string | null;
    };
    url: '/api/v1/entities/{entity_id}/latest_data/{question_id}';
};

export type GetLatestDataErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetLatestDataError = GetLatestDataErrors[keyof GetLatestDataErrors];

export type GetLatestDataResponses = {
    /**
     * Successful Response
     */
    200: LatestData;
};

export type GetLatestDataResponse = GetLatestDataResponses[keyof GetLatestDataResponses];

export type GetEntitySdiRationaleData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/entities/{entity_id}/sdi_rationale';
};

export type GetEntitySdiRationaleErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntitySdiRationaleError = GetEntitySdiRationaleErrors[keyof GetEntitySdiRationaleErrors];

export type GetEntitySdiRationaleResponses = {
    /**
     * Response Get Entity Sdi Rationale
     *
     * Successful Response
     */
    200: string | null;
};

export type GetEntitySdiRationaleResponse = GetEntitySdiRationaleResponses[keyof GetEntitySdiRationaleResponses];

export type ListEnumsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/enums';
};

export type ListEnumsResponses = {
    /**
     * Response List Enums
     *
     * Successful Response
     */
    200: Array<string>;
};

export type ListEnumsResponse = ListEnumsResponses[keyof ListEnumsResponses];

export type GetEnumData = {
    body?: never;
    path: {
        /**
         * Enum
         */
        enum: string;
    };
    query?: never;
    url: '/api/v1/enums/{enum}';
};

export type GetEnumErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEnumError = GetEnumErrors[keyof GetEnumErrors];

export type GetEnumResponses = {
    /**
     * Response Get Enum
     *
     * Successful Response
     */
    200: Array<string>;
};

export type GetEnumResponse = GetEnumResponses[keyof GetEnumResponses];

export type GetEnumDetailsData = {
    body?: never;
    path: {
        /**
         * Enum
         */
        enum: string;
    };
    query?: never;
    url: '/api/v1/enums/{enum}/details';
};

export type GetEnumDetailsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEnumDetailsError = GetEnumDetailsErrors[keyof GetEnumDetailsErrors];

export type GetEnumDetailsResponses = {
    /**
     * Response Get Enum Details
     *
     * Successful Response
     */
    200: Array<EnumDetail>;
};

export type GetEnumDetailsResponse = GetEnumDetailsResponses[keyof GetEnumDetailsResponses];

export type ListRecentErrorsData = {
    body?: never;
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
    };
    query?: never;
    url: '/api/v1/errors/recent/{metric_id}';
};

export type ListRecentErrorsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListRecentErrorsError = ListRecentErrorsErrors[keyof ListRecentErrorsErrors];

export type ListRecentErrorsResponses = {
    /**
     * Response List Recent Errors
     *
     * Successful Response
     */
    200: Array<ErrorFeedback>;
};

export type ListRecentErrorsResponse = ListRecentErrorsResponses[keyof ListRecentErrorsResponses];

export type ListRecentErrorsForUserData = {
    body?: never;
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/errors/recent/{metric_id}/{user_id}';
};

export type ListRecentErrorsForUserErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListRecentErrorsForUserError = ListRecentErrorsForUserErrors[keyof ListRecentErrorsForUserErrors];

export type ListRecentErrorsForUserResponses = {
    /**
     * Response List Recent Errors For User
     *
     * Successful Response
     */
    200: Array<ErrorFeedback>;
};

export type ListRecentErrorsForUserResponse = ListRecentErrorsForUserResponses[keyof ListRecentErrorsForUserResponses];

export type ListEstimatedDataData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'. Default is question_id, entity_id, year DESC
         */
        sort_by?: Array<string> | null;
        /**
         * Question Id
         *
         * Question IDS to include in data set. If unset all question_ids are returned
         */
        question_id?: Array<number> | null;
        /**
         * Entity Id
         *
         * Entity IDS to include in data set. If unset all entity_ids are returned
         */
        entity_id?: Array<number> | null;
    };
    url: '/api/v1/estimations/';
};

export type ListEstimatedDataErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListEstimatedDataError = ListEstimatedDataErrors[keyof ListEstimatedDataErrors];

export type ListEstimatedDataResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEstimatedDatapoint;
};

export type ListEstimatedDataResponse = ListEstimatedDataResponses[keyof ListEstimatedDataResponses];

export type ListFactsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/facts';
};

export type ListFactsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListFactsError = ListFactsErrors[keyof ListFactsErrors];

export type ListFactsResponses = {
    /**
     * Response List Facts
     *
     * Successful Response
     */
    200: PaginatedResponseListFactWithExtras | PaginatedResponseListFact;
};

export type ListFactsResponse = ListFactsResponses[keyof ListFactsResponses];

export type CreateFactData = {
    body: InputFact;
    path?: never;
    query?: never;
    url: '/api/v1/facts';
};

export type CreateFactErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateFactError = CreateFactErrors[keyof CreateFactErrors];

export type CreateFactResponses = {
    /**
     * Successful Response
     */
    201: OutputFact;
};

export type CreateFactResponse = CreateFactResponses[keyof CreateFactResponses];

export type ListEuSfdrFactsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'
         */
        sort_by?: Array<string> | null;
        /**
         * Metric Id
         *
         * List of metric ids to include in the dataset.If unset all metric_ids are returned
         */
        metric_id?: Array<string> | null;
        /**
         * Task Id
         *
         * List of task ids to include in the dataset.If unset, task_ids are not returned
         */
        task_id?: Array<number> | null;
    };
    url: '/api/v1/facts/eu_sfdr';
};

export type ListEuSfdrFactsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListEuSfdrFactsError = ListEuSfdrFactsErrors[keyof ListEuSfdrFactsErrors];

export type ListEuSfdrFactsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseOutputSfdrFact;
};

export type ListEuSfdrFactsResponse = ListEuSfdrFactsResponses[keyof ListEuSfdrFactsResponses];

export type GetEuSfdrFactData = {
    body?: never;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: {
        /**
         * With Errors At Extraction Step
         */
        with_errors_at_extraction_step?: ExtractionSteps | null;
        /**
         * Include Self Assessed
         */
        include_self_assessed?: boolean;
    };
    url: '/api/v1/facts/eu_sfdr/{fact_id}';
};

export type GetEuSfdrFactErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEuSfdrFactError = GetEuSfdrFactErrors[keyof GetEuSfdrFactErrors];

export type GetEuSfdrFactResponses = {
    /**
     * Successful Response
     */
    200: OutputSfdrFactWithExtras;
};

export type GetEuSfdrFactResponse = GetEuSfdrFactResponses[keyof GetEuSfdrFactResponses];

export type DeleteFactData = {
    body?: never;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: never;
    url: '/api/v1/facts/{fact_id}';
};

export type DeleteFactErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteFactError = DeleteFactErrors[keyof DeleteFactErrors];

export type DeleteFactResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetFactData = {
    body?: never;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: {
        /**
         * With Errors At Extraction Step
         */
        with_errors_at_extraction_step?: ExtractionSteps | null;
        /**
         * Include Self Assessed
         */
        include_self_assessed?: boolean;
    };
    url: '/api/v1/facts/{fact_id}';
};

export type GetFactErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetFactError = GetFactErrors[keyof GetFactErrors];

export type GetFactResponses = {
    /**
     * Successful Response
     */
    200: OutputFactWithExtras;
};

export type GetFactResponse = GetFactResponses[keyof GetFactResponses];

export type UpdateFactData = {
    body: InputFactWithExtras;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: never;
    url: '/api/v1/facts/{fact_id}';
};

export type UpdateFactErrors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateFactError = UpdateFactErrors[keyof UpdateFactErrors];

export type UpdateFactResponses = {
    /**
     * Successful Response
     */
    200: OutputFactWithExtras;
};

export type UpdateFactResponse = UpdateFactResponses[keyof UpdateFactResponses];

export type GetCandidateFactData = {
    body?: never;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: never;
    url: '/api/v1/facts/{fact_id}/candidate';
};

export type GetCandidateFactErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCandidateFactError = GetCandidateFactErrors[keyof GetCandidateFactErrors];

export type GetCandidateFactResponses = {
    /**
     * Successful Response
     */
    200: OutputFact;
};

export type GetCandidateFactResponse = GetCandidateFactResponses[keyof GetCandidateFactResponses];

export type UpdateElapsedFactTimeData = {
    body: UpdateElapsedFactTime;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
    };
    query?: never;
    url: '/api/v1/facts/{fact_id}/update_elapsed';
};

export type UpdateElapsedFactTimeErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateElapsedFactTimeError = UpdateElapsedFactTimeErrors[keyof UpdateElapsedFactTimeErrors];

export type UpdateElapsedFactTimeResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateFactForExtractionStepData = {
    body: InputSfdrFactWithExtras;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
        extraction_step: ExtractionSteps;
    };
    query?: never;
    url: '/api/v1/facts/eu_sfdr/{fact_id}/{extraction_step}';
};

export type UpdateFactForExtractionStepErrors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateFactForExtractionStepError = UpdateFactForExtractionStepErrors[keyof UpdateFactForExtractionStepErrors];

export type UpdateFactForExtractionStepResponses = {
    /**
     * Successful Response
     */
    200: OutputSfdrFactWithExtras;
};

export type UpdateFactForExtractionStepResponse = UpdateFactForExtractionStepResponses[keyof UpdateFactForExtractionStepResponses];

export type UpdateFactForExtractionStep2Data = {
    body: InputFactWithExtras;
    path: {
        /**
         * Fact Id
         */
        fact_id: number;
        extraction_step: ExtractionSteps;
    };
    query?: never;
    url: '/api/v1/facts/{fact_id}/{extraction_step}';
};

export type UpdateFactForExtractionStep2Errors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateFactForExtractionStep2Error = UpdateFactForExtractionStep2Errors[keyof UpdateFactForExtractionStep2Errors];

export type UpdateFactForExtractionStep2Responses = {
    /**
     * Successful Response
     */
    200: OutputFactWithExtras;
};

export type UpdateFactForExtractionStep2Response = UpdateFactForExtractionStep2Responses[keyof UpdateFactForExtractionStep2Responses];

export type ValidateFactData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Q
         */
        q: string;
    };
    url: '/api/v1/facts/validate';
};

export type ValidateFactErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ValidateFactError = ValidateFactErrors[keyof ValidateFactErrors];

export type ValidateFactResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromise;
};

export type ValidateFactResponse = ValidateFactResponses[keyof ValidateFactResponses];

export type CreateNewFactsData = {
    body: BodyCreateNewFacts;
    path?: never;
    query?: never;
    url: '/api/v1/facts/create_new_facts';
};

export type CreateNewFactsErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateNewFactsError = CreateNewFactsErrors[keyof CreateNewFactsErrors];

export type CreateNewFactsResponses = {
    /**
     * Successful Response
     */
    201: unknown;
};

export type CreateFactsForThemeData = {
    body: CreateFactSet;
    path?: never;
    query?: never;
    url: '/api/v1/facts/factset';
};

export type CreateFactsForThemeErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateFactsForThemeError = CreateFactsForThemeErrors[keyof CreateFactsForThemeErrors];

export type CreateFactsForThemeResponses = {
    /**
     * Response Create Facts For Theme
     *
     * Successful Response
     */
    201: Array<ListFact>;
};

export type CreateFactsForThemeResponse = CreateFactsForThemeResponses[keyof CreateFactsForThemeResponses];

export type BulkAcceptFactsFromQueryData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/facts/accept';
};

export type BulkAcceptFactsFromQueryErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type BulkAcceptFactsFromQueryError = BulkAcceptFactsFromQueryErrors[keyof BulkAcceptFactsFromQueryErrors];

export type BulkAcceptFactsFromQueryResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type BulkAcceptFromCsvData = {
    body: BodyBulkAcceptFromCsv;
    path?: never;
    query?: never;
    url: '/api/v1/facts/bulk_accept';
};

export type BulkAcceptFromCsvErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type BulkAcceptFromCsvError = BulkAcceptFromCsvErrors[keyof BulkAcceptFromCsvErrors];

export type BulkAcceptFromCsvResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type BulkAcceptFromCsvResponse = BulkAcceptFromCsvResponses[keyof BulkAcceptFromCsvResponses];

export type BulkDeleteFactsData = {
    body: BodyBulkDeleteFacts;
    path?: never;
    query?: never;
    url: '/api/v1/facts/bulk_delete';
};

export type BulkDeleteFactsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type BulkDeleteFactsError = BulkDeleteFactsErrors[keyof BulkDeleteFactsErrors];

export type BulkDeleteFactsResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type SubmitFeedbackEmailData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Feedback
         */
        feedback: string;
        /**
         * Url
         */
        url: string;
        /**
         * Category
         */
        category: string;
    };
    url: '/api/v1/feedback/submit_feedback';
};

export type SubmitFeedbackEmailErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SubmitFeedbackEmailError = SubmitFeedbackEmailErrors[keyof SubmitFeedbackEmailErrors];

export type SubmitFeedbackEmailResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type SubmitReportValueData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Feedback
         */
        feedback: string;
        /**
         * Url
         */
        url: string;
        /**
         * Data Id
         */
        data_id: number | string;
        /**
         * Data Type
         */
        data_type: string;
    };
    url: '/api/v1/feedback/submit_report_value';
};

export type SubmitReportValueErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SubmitReportValueError = SubmitReportValueErrors[keyof SubmitReportValueErrors];

export type SubmitReportValueResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListHoldingsData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
        /**
         * Portfolio Id
         */
        portfolio_id?: number | null;
    };
    url: '/api/v1/holdings';
};

export type ListHoldingsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListHoldingsError = ListHoldingsErrors[keyof ListHoldingsErrors];

export type ListHoldingsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseHoldingWithCoverage;
};

export type ListHoldingsResponse = ListHoldingsResponses[keyof ListHoldingsResponses];

export type UpdateHoldingData = {
    /**
     * Update
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Holding Id
         */
        holding_id: number;
    };
    query?: never;
    url: '/api/v1/holdings/{holding_id}';
};

export type UpdateHoldingErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateHoldingError = UpdateHoldingErrors[keyof UpdateHoldingErrors];

export type UpdateHoldingResponses = {
    /**
     * Successful Response
     */
    200: Holding;
};

export type UpdateHoldingResponse = UpdateHoldingResponses[keyof UpdateHoldingResponses];

export type ExportHoldingsData = {
    body: HoldingsExportRequest;
    path?: never;
    query?: never;
    url: '/api/v1/holdings/export';
};

export type ExportHoldingsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportHoldingsError = ExportHoldingsErrors[keyof ExportHoldingsErrors];

export type ExportHoldingsResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListKeywordsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/keywords';
};

export type ListKeywordsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListKeywordsError = ListKeywordsErrors[keyof ListKeywordsErrors];

export type ListKeywordsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseKeyword;
};

export type ListKeywordsResponse = ListKeywordsResponses[keyof ListKeywordsResponses];

export type CreateKeywordData = {
    body: CreateKeyword;
    path?: never;
    query?: never;
    url: '/api/v1/keywords';
};

export type CreateKeywordErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateKeywordError = CreateKeywordErrors[keyof CreateKeywordErrors];

export type CreateKeywordResponses = {
    /**
     * Successful Response
     */
    201: Keyword;
};

export type CreateKeywordResponse = CreateKeywordResponses[keyof CreateKeywordResponses];

export type DeleteKeywordData = {
    body?: never;
    path: {
        /**
         * Keyword Id
         */
        keyword_id: number;
    };
    query?: never;
    url: '/api/v1/keywords/{keyword_id}';
};

export type DeleteKeywordErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteKeywordError = DeleteKeywordErrors[keyof DeleteKeywordErrors];

export type DeleteKeywordResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetKeywordData = {
    body?: never;
    path: {
        /**
         * Keyword Id
         */
        keyword_id: number;
    };
    query?: never;
    url: '/api/v1/keywords/{keyword_id}';
};

export type GetKeywordErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetKeywordError = GetKeywordErrors[keyof GetKeywordErrors];

export type GetKeywordResponses = {
    /**
     * Successful Response
     */
    200: Keyword;
};

export type GetKeywordResponse = GetKeywordResponses[keyof GetKeywordResponses];

export type UpdateKeywordData = {
    /**
     * Data
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Keyword Id
         */
        keyword_id: number;
    };
    query?: never;
    url: '/api/v1/keywords/{keyword_id}';
};

export type UpdateKeywordErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateKeywordError = UpdateKeywordErrors[keyof UpdateKeywordErrors];

export type UpdateKeywordResponses = {
    /**
     * Successful Response
     */
    200: Keyword;
};

export type UpdateKeywordResponse = UpdateKeywordResponses[keyof UpdateKeywordResponses];

export type ListKpiResultsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/kpi_results';
};

export type ListKpiResultsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListKpiResultsError = ListKpiResultsErrors[keyof ListKpiResultsErrors];

export type ListKpiResultsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseKpiResult;
};

export type ListKpiResultsResponse = ListKpiResultsResponses[keyof ListKpiResultsResponses];

export type StreamKpiResultsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Kpi Id
         *
         * Filter for only specific kpi_ids
         */
        kpi_id?: Array<string>;
        /**
         * Entity Id
         *
         * Filter for only specific entity_ids.
         */
        entity_id?: Array<number> | null;
        /**
         * Question Id
         *
         * Filter for specific question_ids.
         */
        question_id?: Array<number> | null;
        /**
         * Batch Size
         *
         * Control the batch_size of the stream. Can tune performance.
         */
        batch_size?: number;
    };
    url: '/api/v1/kpi_results/stream';
};

export type StreamKpiResultsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type StreamKpiResultsError = StreamKpiResultsErrors[keyof StreamKpiResultsErrors];

export type StreamKpiResultsResponses = {
    /**
     * Response Stream Kpi Results
     *
     * Successful Response
     */
    200: Array<StreamKpiResult>;
};

export type StreamKpiResultsResponse = StreamKpiResultsResponses[keyof StreamKpiResultsResponses];

export type GetKpiResultData = {
    body?: never;
    path: {
        /**
         * Kpi Result Id
         */
        kpi_result_id: string;
    };
    query?: never;
    url: '/api/v1/kpi_results/{kpi_result_id}';
};

export type GetKpiResultErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetKpiResultError = GetKpiResultErrors[keyof GetKpiResultErrors];

export type GetKpiResultResponses = {
    /**
     * Successful Response
     */
    200: KpiResultDetail;
};

export type GetKpiResultResponse = GetKpiResultResponses[keyof GetKpiResultResponses];

export type ListKpisData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/kpis';
};

export type ListKpisErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListKpisError = ListKpisErrors[keyof ListKpisErrors];

export type ListKpisResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseKpi;
};

export type ListKpisResponse = ListKpisResponses[keyof ListKpisResponses];

export type CreateKpiData = {
    body: Kpi;
    path?: never;
    query?: never;
    url: '/api/v1/kpis';
};

export type CreateKpiErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateKpiError = CreateKpiErrors[keyof CreateKpiErrors];

export type CreateKpiResponses = {
    /**
     * Successful Response
     */
    201: Kpi;
};

export type CreateKpiResponse = CreateKpiResponses[keyof CreateKpiResponses];

export type DeleteKpiData = {
    body?: never;
    path: {
        /**
         * Kpi Id
         */
        kpi_id: string;
    };
    query?: never;
    url: '/api/v1/kpis/{kpi_id}';
};

export type DeleteKpiErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteKpiError = DeleteKpiErrors[keyof DeleteKpiErrors];

export type DeleteKpiResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetKpiData = {
    body?: never;
    path: {
        /**
         * Kpi Id
         */
        kpi_id: string;
    };
    query?: never;
    url: '/api/v1/kpis/{kpi_id}';
};

export type GetKpiErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetKpiError = GetKpiErrors[keyof GetKpiErrors];

export type GetKpiResponses = {
    /**
     * Successful Response
     */
    200: Kpi;
};

export type GetKpiResponse = GetKpiResponses[keyof GetKpiResponses];

export type UpdateKpiData = {
    body: Kpi;
    path: {
        /**
         * Kpi Id
         */
        kpi_id: string;
    };
    query?: never;
    url: '/api/v1/kpis/{kpi_id}';
};

export type UpdateKpiErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateKpiError = UpdateKpiErrors[keyof UpdateKpiErrors];

export type UpdateKpiResponses = {
    /**
     * Successful Response
     */
    200: Kpi;
};

export type UpdateKpiResponse = UpdateKpiResponses[keyof UpdateKpiResponses];

export type ListThemeOptionsApiV1LabelsThemesGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/labels/themes';
};

export type ListThemeOptionsApiV1LabelsThemesGetResponses = {
    /**
     * Successful Response
     */
    200: LabelsDict;
};

export type ListThemeOptionsApiV1LabelsThemesGetResponse = ListThemeOptionsApiV1LabelsThemesGetResponses[keyof ListThemeOptionsApiV1LabelsThemesGetResponses];

export type ListSectorOptionsApiV1LabelsSectorsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/labels/sectors';
};

export type ListSectorOptionsApiV1LabelsSectorsGetResponses = {
    /**
     * Successful Response
     */
    200: LabelsDict;
};

export type ListSectorOptionsApiV1LabelsSectorsGetResponse = ListSectorOptionsApiV1LabelsSectorsGetResponses[keyof ListSectorOptionsApiV1LabelsSectorsGetResponses];

export type ListSegmentOptionsApiV1LabelsSegmentsGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/labels/segments';
};

export type ListSegmentOptionsApiV1LabelsSegmentsGetResponses = {
    /**
     * Successful Response
     */
    200: LabelsDict;
};

export type ListSegmentOptionsApiV1LabelsSegmentsGetResponse = ListSegmentOptionsApiV1LabelsSegmentsGetResponses[keyof ListSegmentOptionsApiV1LabelsSegmentsGetResponses];

export type ListMetricsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
        /**
         * Include Simple
         */
        include_simple?: boolean;
    };
    url: '/api/v1/metrics';
};

export type ListMetricsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListMetricsError = ListMetricsErrors[keyof ListMetricsErrors];

export type ListMetricsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseAnnotatedUnionMetricSimpleMetricFieldInfoAnnotationNoneTypeRequiredTrueDiscriminatorType;
};

export type ListMetricsResponse = ListMetricsResponses[keyof ListMetricsResponses];

export type CreateMetricData = {
    /**
     * Data
     */
    body: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric);
    path?: never;
    query?: never;
    url: '/api/v1/metrics';
};

export type CreateMetricErrors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateMetricError = CreateMetricErrors[keyof CreateMetricErrors];

export type CreateMetricResponses = {
    /**
     * Response Create Metric
     *
     * Successful Response
     */
    201: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric);
};

export type CreateMetricResponse = CreateMetricResponses[keyof CreateMetricResponses];

export type DeleteMetricData = {
    body?: never;
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
    };
    query?: never;
    url: '/api/v1/metrics/{metric_id}';
};

export type DeleteMetricErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteMetricError = DeleteMetricErrors[keyof DeleteMetricErrors];

export type DeleteMetricResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetMetricData = {
    body?: never;
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
    };
    query?: never;
    url: '/api/v1/metrics/{metric_id}';
};

export type GetMetricErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetMetricError = GetMetricErrors[keyof GetMetricErrors];

export type GetMetricResponses = {
    /**
     * Response Get Metric
     *
     * Successful Response
     */
    200: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric);
};

export type GetMetricResponse = GetMetricResponses[keyof GetMetricResponses];

export type UpdateMetricData = {
    /**
     * Data
     */
    body: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric);
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
    };
    query?: never;
    url: '/api/v1/metrics/{metric_id}';
};

export type UpdateMetricErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateMetricError = UpdateMetricErrors[keyof UpdateMetricErrors];

export type UpdateMetricResponses = {
    /**
     * Response Update Metric
     *
     * Successful Response
     */
    200: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric);
};

export type UpdateMetricResponse = UpdateMetricResponses[keyof UpdateMetricResponses];

export type ListPortfoliosData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios';
};

export type ListPortfoliosErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfoliosError = ListPortfoliosErrors[keyof ListPortfoliosErrors];

export type ListPortfoliosResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponsePortfolioWithCoverage;
};

export type ListPortfoliosResponse = ListPortfoliosResponses[keyof ListPortfoliosResponses];

export type ListPortfolioHoldingsData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number | null;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios/{portfolio_id}/holdings';
};

export type ListPortfolioHoldingsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfolioHoldingsError = ListPortfolioHoldingsErrors[keyof ListPortfolioHoldingsErrors];

export type ListPortfolioHoldingsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseHoldingWithCoverage;
};

export type ListPortfolioHoldingsResponse = ListPortfolioHoldingsResponses[keyof ListPortfolioHoldingsResponses];

export type ListPortfolioWithFundsHoldingsByCompanyData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number | null;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios/{portfolio_id}/holdings_by_company';
};

export type ListPortfolioWithFundsHoldingsByCompanyErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfolioWithFundsHoldingsByCompanyError = ListPortfolioWithFundsHoldingsByCompanyErrors[keyof ListPortfolioWithFundsHoldingsByCompanyErrors];

export type ListPortfolioWithFundsHoldingsByCompanyResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseHoldingWithCoverageByCompany;
};

export type ListPortfolioWithFundsHoldingsByCompanyResponse = ListPortfolioWithFundsHoldingsByCompanyResponses[keyof ListPortfolioWithFundsHoldingsByCompanyResponses];

export type ListPortfolioSourcesData = {
    body?: never;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sources';
};

export type ListPortfolioSourcesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfolioSourcesError = ListPortfolioSourcesErrors[keyof ListPortfolioSourcesErrors];

export type ListPortfolioSourcesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseSource;
};

export type ListPortfolioSourcesResponse = ListPortfolioSourcesResponses[keyof ListPortfolioSourcesResponses];

export type DeletePortfolioData = {
    body?: never;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: never;
    url: '/api/v1/portfolios/{portfolio_id}';
};

export type DeletePortfolioErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeletePortfolioError = DeletePortfolioErrors[keyof DeletePortfolioErrors];

export type DeletePortfolioResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetPortfolioWithHoldingsData = {
    body?: never;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         *
         * Optional ID for the specific snapshot you wish to fetch. Defaults to the latest.
         */
        snapshot_id?: number | null;
    };
    url: '/api/v1/portfolios/{portfolio_id}';
};

export type GetPortfolioWithHoldingsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioWithHoldingsError = GetPortfolioWithHoldingsErrors[keyof GetPortfolioWithHoldingsErrors];

export type GetPortfolioWithHoldingsResponses = {
    /**
     * Successful Response
     */
    200: PortfolioWithCoverage;
};

export type GetPortfolioWithHoldingsResponse = GetPortfolioWithHoldingsResponses[keyof GetPortfolioWithHoldingsResponses];

export type UpdatePortfolioData = {
    body: PortfolioUpdate;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
    };
    url: '/api/v1/portfolios/{portfolio_id}';
};

export type UpdatePortfolioErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdatePortfolioError = UpdatePortfolioErrors[keyof UpdatePortfolioErrors];

export type UpdatePortfolioResponses = {
    /**
     * Successful Response
     */
    200: Portfolio;
};

export type UpdatePortfolioResponse = UpdatePortfolioResponses[keyof UpdatePortfolioResponses];

export type ExportPortfolioData = {
    body: PortfolioExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/export';
};

export type ExportPortfolioErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioError = ExportPortfolioErrors[keyof ExportPortfolioErrors];

export type ExportPortfolioResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportPortfolioResponse = ExportPortfolioResponses[keyof ExportPortfolioResponses];

export type ExportPortfolioPaiData = {
    body: PortfolioPaiExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/pai/export';
};

export type ExportPortfolioPaiErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioPaiError = ExportPortfolioPaiErrors[keyof ExportPortfolioPaiErrors];

export type ExportPortfolioPaiResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportPortfolioPaiResponse = ExportPortfolioPaiResponses[keyof ExportPortfolioPaiResponses];

export type ExportPortfolioSdgData = {
    body: PortfolioSdgExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/sdg/export';
};

export type ExportPortfolioSdgErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioSdgError = ExportPortfolioSdgErrors[keyof ExportPortfolioSdgErrors];

export type ExportPortfolioSdgResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportPortfolioSdgResponse = ExportPortfolioSdgResponses[keyof ExportPortfolioSdgResponses];

export type ExportPortfolioSdgRevenueData = {
    body: PortfolioSdgRevenueExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/sdg_revenue/export';
};

export type ExportPortfolioSdgRevenueErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioSdgRevenueError = ExportPortfolioSdgRevenueErrors[keyof ExportPortfolioSdgRevenueErrors];

export type ExportPortfolioSdgRevenueResponses = {
    /**
     * Successful Response
     */
    200: DownloadableFileRequest;
};

export type ExportPortfolioSdgRevenueResponse = ExportPortfolioSdgRevenueResponses[keyof ExportPortfolioSdgRevenueResponses];

export type ExportPortfolioDashboardData = {
    body: PortfolioExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/dashboard/export';
};

export type ExportPortfolioDashboardErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioDashboardError = ExportPortfolioDashboardErrors[keyof ExportPortfolioDashboardErrors];

export type ExportPortfolioDashboardResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ExportPortfolioDataData = {
    body: PortfolioDataExport;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/data/export';
};

export type ExportPortfolioDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportPortfolioDataError = ExportPortfolioDataErrors[keyof ExportPortfolioDataErrors];

export type ExportPortfolioDataResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type CopyPortfolioData = {
    body: CopyPortfolioRequest;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: never;
    url: '/api/v1/portfolios/{portfolio_id}/copy';
};

export type CopyPortfolioErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CopyPortfolioError = CopyPortfolioErrors[keyof CopyPortfolioErrors];

export type CopyPortfolioResponses = {
    /**
     * Successful Response
     */
    200: CopyPortfolioResponse;
};

export type CopyPortfolioResponse2 = CopyPortfolioResponses[keyof CopyPortfolioResponses];

export type CopyReferencePortfolioData = {
    body: CopyPortfolioRequest;
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/copy-reference';
};

export type CopyReferencePortfolioErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CopyReferencePortfolioError = CopyReferencePortfolioErrors[keyof CopyReferencePortfolioErrors];

export type CopyReferencePortfolioResponses = {
    /**
     * Successful Response
     */
    200: CopyPortfolioResponse;
};

export type CopyReferencePortfolioResponse = CopyReferencePortfolioResponses[keyof CopyReferencePortfolioResponses];

export type GetPortfolioDashboardDataData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Metrics Config Id
         */
        metrics_config_id?: string | null;
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * Question Id
         */
        question_id?: Array<number> | null;
    };
    url: '/api/v1/portfolios/{portfolio_id}/dashboard';
};

export type GetPortfolioDashboardDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioDashboardDataError = GetPortfolioDashboardDataErrors[keyof GetPortfolioDashboardDataErrors];

export type GetPortfolioDashboardDataResponses = {
    /**
     * Response Get Portfolio Dashboard Data
     *
     * Successful Response
     */
    200: Array<PortfolioImpactData>;
};

export type GetPortfolioDashboardDataResponse = GetPortfolioDashboardDataResponses[keyof GetPortfolioDashboardDataResponses];

export type GetDisclosureDataData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Metrics Config Id
         */
        metrics_config_id?: string | null;
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
    };
    url: '/api/v1/portfolios/{portfolio_id}/disclosure';
};

export type GetDisclosureDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetDisclosureDataError = GetDisclosureDataErrors[keyof GetDisclosureDataErrors];

export type GetDisclosureDataResponses = {
    /**
     * Response Get Disclosure Data
     *
     * Successful Response
     */
    200: Array<QuestionCoverage>;
};

export type GetDisclosureDataResponse = GetDisclosureDataResponses[keyof GetDisclosureDataResponses];

export type UploadPortfolioData = {
    body: BodyUploadPortfolio;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/upload';
};

export type UploadPortfolioErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type UploadPortfolioError = UploadPortfolioErrors[keyof UploadPortfolioErrors];

export type UploadPortfolioResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromiseWithError;
};

export type UploadPortfolioResponse = UploadPortfolioResponses[keyof UploadPortfolioResponses];

export type UploadPortfolioWithFundHoldingsData = {
    body: BodyUploadPortfolioWithFundHoldings;
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/upload_with_funds';
};

export type UploadPortfolioWithFundHoldingsErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type UploadPortfolioWithFundHoldingsError = UploadPortfolioWithFundHoldingsErrors[keyof UploadPortfolioWithFundHoldingsErrors];

export type UploadPortfolioWithFundHoldingsResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromiseWithError;
};

export type UploadPortfolioWithFundHoldingsResponse = UploadPortfolioWithFundHoldingsResponses[keyof UploadPortfolioWithFundHoldingsResponses];

export type CreateWatchlistData = {
    body: CreateWatchlist;
    path?: never;
    query?: never;
    url: '/api/v1/portfolios/watchlist';
};

export type CreateWatchlistErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateWatchlistError = CreateWatchlistErrors[keyof CreateWatchlistErrors];

export type CreateWatchlistResponses = {
    /**
     * Successful Response
     */
    201: WatchlistResponse;
};

export type CreateWatchlistResponse = CreateWatchlistResponses[keyof CreateWatchlistResponses];

export type UpdatePortfolioHoldingsData = {
    /**
     * Entity Ids
     */
    body: Array<number>;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: never;
    url: '/api/v1/portfolios/watchlist/{portfolio_id}';
};

export type UpdatePortfolioHoldingsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdatePortfolioHoldingsError = UpdatePortfolioHoldingsErrors[keyof UpdatePortfolioHoldingsErrors];

export type UpdatePortfolioHoldingsResponses = {
    /**
     * Successful Response
     */
    200: WatchlistResponse;
};

export type UpdatePortfolioHoldingsResponse = UpdatePortfolioHoldingsResponses[keyof UpdatePortfolioHoldingsResponses];

export type DeleteHoldingsFromWatchlistData = {
    /**
     * Entity Ids
     */
    body: Array<number>;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: never;
    url: '/api/v1/portfolios/watchlist/{portfolio_id}/delete_holdings';
};

export type DeleteHoldingsFromWatchlistErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteHoldingsFromWatchlistError = DeleteHoldingsFromWatchlistErrors[keyof DeleteHoldingsFromWatchlistErrors];

export type DeleteHoldingsFromWatchlistResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ListPortfolioDataData = {
    body?: never;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios/{portfolio_id}/all_data';
};

export type ListPortfolioDataErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfolioDataError = ListPortfolioDataErrors[keyof ListPortfolioDataErrors];

export type ListPortfolioDataResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponsePortfolioData;
};

export type ListPortfolioDataResponse = ListPortfolioDataResponses[keyof ListPortfolioDataResponses];

export type GetPortfolioSdgOutcomesSummaryData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * Is Weighted
         */
        is_weighted?: boolean;
        /**
         * Include Estimations
         */
        include_estimations?: boolean;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/outcomes';
};

export type GetPortfolioSdgOutcomesSummaryErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioSdgOutcomesSummaryError = GetPortfolioSdgOutcomesSummaryErrors[keyof GetPortfolioSdgOutcomesSummaryErrors];

export type GetPortfolioSdgOutcomesSummaryResponses = {
    /**
     * Successful Response
     */
    200: PortfolioSdgAlignment;
};

export type GetPortfolioSdgOutcomesSummaryResponse = GetPortfolioSdgOutcomesSummaryResponses[keyof GetPortfolioSdgOutcomesSummaryResponses];

export type GetPortfolioSdgRevenueSummaryWeightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/revenue_weighted';
};

export type GetPortfolioSdgRevenueSummaryWeightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioSdgRevenueSummaryWeightedError = GetPortfolioSdgRevenueSummaryWeightedErrors[keyof GetPortfolioSdgRevenueSummaryWeightedErrors];

export type GetPortfolioSdgRevenueSummaryWeightedResponses = {
    /**
     * Response Get Portfolio Sdg Revenue Summary Weighted
     *
     * Successful Response
     */
    200: PortfolioSdgAumContribution | null;
};

export type GetPortfolioSdgRevenueSummaryWeightedResponse = GetPortfolioSdgRevenueSummaryWeightedResponses[keyof GetPortfolioSdgRevenueSummaryWeightedResponses];

export type GetPortfolioSdgRevenueSummaryUnweightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdg_summary/revenue_unweighted';
};

export type GetPortfolioSdgRevenueSummaryUnweightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioSdgRevenueSummaryUnweightedError = GetPortfolioSdgRevenueSummaryUnweightedErrors[keyof GetPortfolioSdgRevenueSummaryUnweightedErrors];

export type GetPortfolioSdgRevenueSummaryUnweightedResponses = {
    /**
     * Response Get Portfolio Sdg Revenue Summary Unweighted
     *
     * Successful Response
     */
    200: PortfolioSdgRevenueContribution | null;
};

export type GetPortfolioSdgRevenueSummaryUnweightedResponse = GetPortfolioSdgRevenueSummaryUnweightedResponses[keyof GetPortfolioSdgRevenueSummaryUnweightedResponses];

export type GetPortfolioSdiRevenueSummaryUnweightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/revenue_unweighted';
};

export type GetPortfolioSdiRevenueSummaryUnweightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioSdiRevenueSummaryUnweightedError = GetPortfolioSdiRevenueSummaryUnweightedErrors[keyof GetPortfolioSdiRevenueSummaryUnweightedErrors];

export type GetPortfolioSdiRevenueSummaryUnweightedResponses = {
    /**
     * Response Get Portfolio Sdi Revenue Summary Unweighted
     *
     * Successful Response
     */
    200: PortfolioSdiRevenueContribution | null;
};

export type GetPortfolioSdiRevenueSummaryUnweightedResponse = GetPortfolioSdiRevenueSummaryUnweightedResponses[keyof GetPortfolioSdiRevenueSummaryUnweightedResponses];

export type GetPortfolioSdiRevenueSummaryWeightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/revenue_weighted';
};

export type GetPortfolioSdiRevenueSummaryWeightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioSdiRevenueSummaryWeightedError = GetPortfolioSdiRevenueSummaryWeightedErrors[keyof GetPortfolioSdiRevenueSummaryWeightedErrors];

export type GetPortfolioSdiRevenueSummaryWeightedResponses = {
    /**
     * Response Get Portfolio Sdi Revenue Summary Weighted
     *
     * Successful Response
     */
    200: PortfolioSdiAumContribution | null;
};

export type GetPortfolioSdiRevenueSummaryWeightedResponse = GetPortfolioSdiRevenueSummaryWeightedResponses[keyof GetPortfolioSdiRevenueSummaryWeightedResponses];

export type GetPortfolioLabelsUnweightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/classification_unweighted';
};

export type GetPortfolioLabelsUnweightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioLabelsUnweightedError = GetPortfolioLabelsUnweightedErrors[keyof GetPortfolioLabelsUnweightedErrors];

export type GetPortfolioLabelsUnweightedResponses = {
    /**
     * Response Get Portfolio Labels Unweighted
     *
     * Successful Response
     */
    200: PortfolioSdiLabelsCountSummary | null;
};

export type GetPortfolioLabelsUnweightedResponse = GetPortfolioLabelsUnweightedResponses[keyof GetPortfolioLabelsUnweightedResponses];

export type GetPortfolioLabelsWeightedData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number;
    };
    query?: {
        /**
         * Snapshot Id
         */
        snapshot_id?: number | null;
        /**
         * With Bond Entities
         */
        with_bond_entities?: boolean;
    };
    url: '/api/v1/portfolios/{portfolio_id}/sdi_summary/classification_weighted';
};

export type GetPortfolioLabelsWeightedErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPortfolioLabelsWeightedError = GetPortfolioLabelsWeightedErrors[keyof GetPortfolioLabelsWeightedErrors];

export type GetPortfolioLabelsWeightedResponses = {
    /**
     * Response Get Portfolio Labels Weighted
     *
     * Successful Response
     */
    200: PortfolioSdiLabelsAumSummary | null;
};

export type GetPortfolioLabelsWeightedResponse = GetPortfolioLabelsWeightedResponses[keyof GetPortfolioLabelsWeightedResponses];

export type ListPortfolioSnapshotsData = {
    body?: never;
    path: {
        /**
         * Portfolio Id
         */
        portfolio_id: number | null;
    };
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/portfolios/{portfolio_id}/snapshots';
};

export type ListPortfolioSnapshotsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListPortfolioSnapshotsError = ListPortfolioSnapshotsErrors[keyof ListPortfolioSnapshotsErrors];

export type ListPortfolioSnapshotsResponses = {
    /**
     * Response List Portfolio Snapshots
     *
     * Successful Response
     */
    200: Array<PortfolioSnapshot>;
};

export type ListPortfolioSnapshotsResponse = ListPortfolioSnapshotsResponses[keyof ListPortfolioSnapshotsResponses];

export type GetGoalQuestionsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/questions/goals';
};

export type GetGoalQuestionsResponses = {
    /**
     * Response Get Goal Questions
     *
     * Successful Response
     */
    200: Array<ThemeGoal>;
};

export type GetGoalQuestionsResponse = GetGoalQuestionsResponses[keyof GetGoalQuestionsResponses];

export type GetQuestionNamesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/questions/names';
};

export type GetQuestionNamesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetQuestionNamesError = GetQuestionNamesErrors[keyof GetQuestionNamesErrors];

export type GetQuestionNamesResponses = {
    /**
     * Response Get Question Names
     *
     * Successful Response
     */
    200: Array<QuestionName>;
};

export type GetQuestionNamesResponse = GetQuestionNamesResponses[keyof GetQuestionNamesResponses];

export type GetQuestionData = {
    body?: never;
    path: {
        /**
         * Question Id
         */
        question_id: number;
    };
    query?: never;
    url: '/api/v1/questions/{question_id}';
};

export type GetQuestionErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetQuestionError = GetQuestionErrors[keyof GetQuestionErrors];

export type GetQuestionResponses = {
    /**
     * Response Get Question
     *
     * Successful Response
     */
    200: ({
        type: 'Metric';
    } & Metric) | ({
        type: 'Simple metric';
    } & SimpleMetric) | ({
        type: 'KPI';
    } & Kpi);
};

export type GetQuestionResponse = GetQuestionResponses[keyof GetQuestionResponses];

export type GetResultStatusData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Result Token
         */
        result_token: string;
    };
    url: '/api/v1/results';
};

export type GetResultStatusErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetResultStatusError = GetResultStatusErrors[keyof GetResultStatusErrors];

export type GetResultStatusResponses = {
    /**
     * Successful Response
     */
    200: WorkerResult;
};

export type GetResultStatusResponse = GetResultStatusResponses[keyof GetResultStatusResponses];

export type ListExportsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/results/export_history';
};

export type ListExportsResponses = {
    /**
     * Response List Exports
     *
     * Successful Response
     */
    200: Array<ExportItem>;
};

export type ListExportsResponse = ListExportsResponses[keyof ListExportsResponses];

export type GetEntitySdiRevenueContributionData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/revenue/sdi/entity/{entity_id}';
};

export type GetEntitySdiRevenueContributionErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntitySdiRevenueContributionError = GetEntitySdiRevenueContributionErrors[keyof GetEntitySdiRevenueContributionErrors];

export type GetEntitySdiRevenueContributionResponses = {
    /**
     * Successful Response
     */
    200: EntitySdiRevenueContribution;
};

export type GetEntitySdiRevenueContributionResponse = GetEntitySdiRevenueContributionResponses[keyof GetEntitySdiRevenueContributionResponses];

export type GetEntitySdiActivityExplanationData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Entity Sdi Revenue Id
         */
        entity_sdi_revenue_id: string;
    };
    query?: never;
    url: '/api/v1/revenue/sdi/entity/{entity_id}/activities/{entity_sdi_revenue_id}';
};

export type GetEntitySdiActivityExplanationErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetEntitySdiActivityExplanationError = GetEntitySdiActivityExplanationErrors[keyof GetEntitySdiActivityExplanationErrors];

export type GetEntitySdiActivityExplanationResponses = {
    /**
     * Successful Response
     */
    200: EntitySdiActivityExplanation;
};

export type GetEntitySdiActivityExplanationResponse = GetEntitySdiActivityExplanationResponses[keyof GetEntitySdiActivityExplanationResponses];

export type GetSdiDataBundleDownloadUrlData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/revenue/sdi/data_bundle';
};

export type GetSdiDataBundleDownloadUrlErrors = {
    /**
     * Not Found
     */
    404: Message;
};

export type GetSdiDataBundleDownloadUrlError = GetSdiDataBundleDownloadUrlErrors[keyof GetSdiDataBundleDownloadUrlErrors];

export type GetSdiDataBundleDownloadUrlResponses = {
    /**
     * Successful Response
     */
    200: SdiBundleDownload;
};

export type GetSdiDataBundleDownloadUrlResponse = GetSdiDataBundleDownloadUrlResponses[keyof GetSdiDataBundleDownloadUrlResponses];

export type GetSdiSubscriberPackDownloadUrlData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/revenue/sdi/subscriber_pack';
};

export type GetSdiSubscriberPackDownloadUrlErrors = {
    /**
     * Not Found
     */
    404: Message;
};

export type GetSdiSubscriberPackDownloadUrlError = GetSdiSubscriberPackDownloadUrlErrors[keyof GetSdiSubscriberPackDownloadUrlErrors];

export type GetSdiSubscriberPackDownloadUrlResponses = {
    /**
     * Successful Response
     */
    200: SdiBundleDownload;
};

export type GetSdiSubscriberPackDownloadUrlResponse = GetSdiSubscriberPackDownloadUrlResponses[keyof GetSdiSubscriberPackDownloadUrlResponses];

export type ExportEntitySdiRevenueXlsxData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/revenue/sdi/entity/{entity_id}/export';
};

export type ExportEntitySdiRevenueXlsxErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportEntitySdiRevenueXlsxError = ExportEntitySdiRevenueXlsxErrors[keyof ExportEntitySdiRevenueXlsxErrors];

export type ExportEntitySdiRevenueXlsxResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ExportAllSdiFilesXlsxData = {
    body: SdiFileExport;
    path?: never;
    query?: never;
    url: '/api/v1/revenue/sdi/export';
};

export type ExportAllSdiFilesXlsxErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ExportAllSdiFilesXlsxError = ExportAllSdiFilesXlsxErrors[keyof ExportAllSdiFilesXlsxErrors];

export type ExportAllSdiFilesXlsxResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type TriggerSdiRevenuePipelineData = {
    body: TriggerSdiRevenuePipelineRequest;
    path?: never;
    query?: never;
    url: '/api/v1/revenue/sdi/trigger_revenue_pipeline';
};

export type TriggerSdiRevenuePipelineErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type TriggerSdiRevenuePipelineError = TriggerSdiRevenuePipelineErrors[keyof TriggerSdiRevenuePipelineErrors];

export type TriggerSdiRevenuePipelineResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GlobalSearchData = {
    body?: never;
    headers?: {
        /**
         * X-Np-Feature
         */
        'x-np-feature'?: Array<string> | null;
    };
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
        /**
         * Use Ai
         */
        use_ai?: boolean;
        /**
         * Benchmark
         */
        benchmark?: boolean;
    };
    url: '/api/v1/search';
};

export type GlobalSearchErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GlobalSearchError = GlobalSearchErrors[keyof GlobalSearchErrors];

export type GlobalSearchResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseSearchResult;
};

export type GlobalSearchResponse = GlobalSearchResponses[keyof GlobalSearchResponses];

export type ListSegmentsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/segments';
};

export type ListSegmentsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSegmentsError = ListSegmentsErrors[keyof ListSegmentsErrors];

export type ListSegmentsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseSegment;
};

export type ListSegmentsResponse = ListSegmentsResponses[keyof ListSegmentsResponses];

export type CreateSegmentData = {
    body: CreateSegment;
    path?: never;
    query?: never;
    url: '/api/v1/segments';
};

export type CreateSegmentErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateSegmentError = CreateSegmentErrors[keyof CreateSegmentErrors];

export type CreateSegmentResponses = {
    /**
     * Successful Response
     */
    201: Segment;
};

export type CreateSegmentResponse = CreateSegmentResponses[keyof CreateSegmentResponses];

export type ListEuSfdrSegmentsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Page
         *
         * Which page of results do you want to fetch
         */
        page?: number;
        /**
         * Limit
         *
         * How many results per page. Limit 2000.
         */
        limit?: number;
        /**
         * Sort By
         *
         * Columns to sort by. Applied in order supplied. For descending sort prefix the column name with a '-'
         */
        sort_by?: Array<string> | null;
        /**
         * Segment Instance
         *
         * List of segment instances to include in the dataset.If unset all segment instances are returned
         */
        segment_instance?: Array<string> | null;
        /**
         * Segment Class
         *
         * List of segment classes to include in the dataset.If unset all segment classes are returned
         */
        segment_class?: Array<string> | null;
    };
    url: '/api/v1/segments/eu_sfdr';
};

export type ListEuSfdrSegmentsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListEuSfdrSegmentsError = ListEuSfdrSegmentsErrors[keyof ListEuSfdrSegmentsErrors];

export type ListEuSfdrSegmentsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseEuSfdrTaxonomy;
};

export type ListEuSfdrSegmentsResponse = ListEuSfdrSegmentsResponses[keyof ListEuSfdrSegmentsResponses];

export type DeleteSegmentData = {
    body?: never;
    path: {
        /**
         * Segment Id
         */
        segment_id: number;
    };
    query?: never;
    url: '/api/v1/segments/{segment_id}';
};

export type DeleteSegmentErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteSegmentError = DeleteSegmentErrors[keyof DeleteSegmentErrors];

export type DeleteSegmentResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSegmentData = {
    body?: never;
    path: {
        /**
         * Segment Id
         */
        segment_id: number;
    };
    query?: never;
    url: '/api/v1/segments/{segment_id}';
};

export type GetSegmentErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSegmentError = GetSegmentErrors[keyof GetSegmentErrors];

export type GetSegmentResponses = {
    /**
     * Successful Response
     */
    200: Segment;
};

export type GetSegmentResponse = GetSegmentResponses[keyof GetSegmentResponses];

export type UpdateSegmentData = {
    body: UpdateSegment;
    path: {
        /**
         * Segment Id
         */
        segment_id: number;
    };
    query?: never;
    url: '/api/v1/segments/{segment_id}';
};

export type UpdateSegmentErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSegmentError = UpdateSegmentErrors[keyof UpdateSegmentErrors];

export type UpdateSegmentResponses = {
    /**
     * Successful Response
     */
    200: Segment;
};

export type UpdateSegmentResponse = UpdateSegmentResponses[keyof UpdateSegmentResponses];

export type ListFeedbackData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Entity Id
         */
        entity_id: number;
        /**
         * Probe
         */
        probe: string;
    };
    url: '/api/v1/semantic_search/feedback';
};

export type ListFeedbackErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListFeedbackError = ListFeedbackErrors[keyof ListFeedbackErrors];

export type ListFeedbackResponses = {
    /**
     * Response List Feedback
     *
     * Successful Response
     */
    200: Array<SemanticSearchFeedbackResponse>;
};

export type ListFeedbackResponse = ListFeedbackResponses[keyof ListFeedbackResponses];

export type SendFeedbackData = {
    body: CreateSemanticSearchFeedback;
    path?: never;
    query?: never;
    url: '/api/v1/semantic_search/feedback';
};

export type SendFeedbackErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SendFeedbackError = SendFeedbackErrors[keyof SendFeedbackErrors];

export type SendFeedbackResponses = {
    /**
     * Successful Response
     */
    201: SemanticSearchFeedbackResponse;
};

export type SendFeedbackResponse = SendFeedbackResponses[keyof SendFeedbackResponses];

export type UpdateFeedbackData = {
    body: UpdateSemanticSearchFeedback;
    path: {
        /**
         * Feedback Id
         */
        feedback_id: number;
    };
    query?: never;
    url: '/api/v1/semantic_search/feedback/{feedback_id}';
};

export type UpdateFeedbackErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateFeedbackError = UpdateFeedbackErrors[keyof UpdateFeedbackErrors];

export type UpdateFeedbackResponses = {
    /**
     * Successful Response
     */
    200: SemanticSearchFeedbackResponse;
};

export type UpdateFeedbackResponse = UpdateFeedbackResponses[keyof UpdateFeedbackResponses];

export type ListSourcesData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/sources';
};

export type ListSourcesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListSourcesError = ListSourcesErrors[keyof ListSourcesErrors];

export type ListSourcesResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseSourceWithLabelPredictions;
};

export type ListSourcesResponse = ListSourcesResponses[keyof ListSourcesResponses];

export type CreateSourceData = {
    body: CreateSource;
    path?: never;
    query?: never;
    url: '/api/v1/sources';
};

export type CreateSourceErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateSourceError = CreateSourceErrors[keyof CreateSourceErrors];

export type CreateSourceResponses = {
    /**
     * Successful Response
     */
    201: Source;
};

export type CreateSourceResponse = CreateSourceResponses[keyof CreateSourceResponses];

export type UploadSourceFromUrlData = {
    body: UploadFile;
    path?: never;
    query?: never;
    url: '/api/v1/sources/upload';
};

export type UploadSourceFromUrlErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
    /**
     * Bad Gateway
     */
    502: Message;
};

export type UploadSourceFromUrlError = UploadSourceFromUrlErrors[keyof UploadSourceFromUrlErrors];

export type UploadSourceFromUrlResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type UploadSourceFromUrlResponse = UploadSourceFromUrlResponses[keyof UploadSourceFromUrlResponses];

export type UploadSourceFromFileData = {
    body: BodyUploadSourceFromFile;
    path?: never;
    query?: never;
    url: '/api/v1/sources/upload-file';
};

export type UploadSourceFromFileErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UploadSourceFromFileError = UploadSourceFromFileErrors[keyof UploadSourceFromFileErrors];

export type UploadSourceFromFileResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type UploadSourceFromFileResponse = UploadSourceFromFileResponses[keyof UploadSourceFromFileResponses];

export type DeleteSourceData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: never;
    url: '/api/v1/sources/{source_id}';
};

export type DeleteSourceErrors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Forbidden
     */
    403: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteSourceError = DeleteSourceErrors[keyof DeleteSourceErrors];

export type DeleteSourceResponses = {
    /**
     * Successful Response
     */
    204: void;
};

export type DeleteSourceResponse = DeleteSourceResponses[keyof DeleteSourceResponses];

export type GetSourceData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: never;
    url: '/api/v1/sources/{source_id}';
};

export type GetSourceErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSourceError = GetSourceErrors[keyof GetSourceErrors];

export type GetSourceResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type GetSourceResponse = GetSourceResponses[keyof GetSourceResponses];

export type DissociateSourceFromEntityData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: never;
    url: '/api/v1/sources/{source_id}';
};

export type DissociateSourceFromEntityErrors = {
    /**
     * Bad Request
     */
    400: Message;
    /**
     * Forbidden
     */
    403: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DissociateSourceFromEntityError = DissociateSourceFromEntityErrors[keyof DissociateSourceFromEntityErrors];

export type DissociateSourceFromEntityResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type DissociateSourceFromEntityResponse = DissociateSourceFromEntityResponses[keyof DissociateSourceFromEntityResponses];

export type UpdateSourceData = {
    body: CreateSource;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: never;
    url: '/api/v1/sources/{source_id}';
};

export type UpdateSourceErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSourceError = UpdateSourceErrors[keyof UpdateSourceErrors];

export type UpdateSourceResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type UpdateSourceResponse = UpdateSourceResponses[keyof UpdateSourceResponses];

export type EmbedSourcesData = {
    body: EmbedSources;
    path?: never;
    query?: never;
    url: '/api/v1/sources/embed';
};

export type EmbedSourcesErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type EmbedSourcesError = EmbedSourcesErrors[keyof EmbedSourcesErrors];

export type EmbedSourcesResponses = {
    /**
     * Successful Response
     */
    200: SourceEmbeddingRequested;
};

export type EmbedSourcesResponse = EmbedSourcesResponses[keyof EmbedSourcesResponses];

export type GetWriteUpData = {
    body?: never;
    path: {
        /**
         * Entity Id
         */
        entity_id: number;
    };
    query?: never;
    url: '/api/v1/sources/write-up/{entity_id}';
};

export type GetWriteUpErrors = {
    /**
     * Forbidden
     */
    403: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetWriteUpError = GetWriteUpErrors[keyof GetWriteUpErrors];

export type GetWriteUpResponses = {
    /**
     * Successful Response
     */
    200: Source;
    /**
     * No Content
     */
    204: void;
};

export type GetWriteUpResponse = GetWriteUpResponses[keyof GetWriteUpResponses];

export type MergeSourcesData = {
    body: MergeMultipleRecords;
    path?: never;
    query?: never;
    url: '/api/v1/sources/merge';
};

export type MergeSourcesErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type MergeSourcesError = MergeSourcesErrors[keyof MergeSourcesErrors];

export type MergeSourcesResponses = {
    /**
     * Successful Response
     */
    200: Source;
};

export type MergeSourcesResponse = MergeSourcesResponses[keyof MergeSourcesResponses];

export type GetPagePredictionsData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: {
        /**
         * Labels
         */
        labels?: Array<string> | null;
        /**
         * Number Of Pages
         */
        number_of_pages?: number | null;
    };
    url: '/api/v1/sources/{source_id}/page_predictions';
};

export type GetPagePredictionsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetPagePredictionsError = GetPagePredictionsErrors[keyof GetPagePredictionsErrors];

export type GetPagePredictionsResponses = {
    /**
     * Successful Response
     */
    200: TopPagesResponse;
};

export type GetPagePredictionsResponse = GetPagePredictionsResponses[keyof GetPagePredictionsResponses];

export type GetThemePagePredictionsData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: {
        /**
         * Themes
         */
        themes?: Array<string> | null;
        /**
         * Number Of Pages
         */
        number_of_pages?: number | null;
    };
    url: '/api/v1/sources/{source_id}/theme_page_predictions';
};

export type GetThemePagePredictionsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetThemePagePredictionsError = GetThemePagePredictionsErrors[keyof GetThemePagePredictionsErrors];

export type GetThemePagePredictionsResponses = {
    /**
     * Successful Response
     */
    200: TopPagesResponse;
};

export type GetThemePagePredictionsResponse = GetThemePagePredictionsResponses[keyof GetThemePagePredictionsResponses];

export type GetMetricPagePredictionsData = {
    body?: never;
    path: {
        /**
         * Source Id
         */
        source_id: number;
    };
    query?: {
        /**
         * Metrics
         */
        metrics?: Array<string> | null;
        /**
         * Number Of Pages
         */
        number_of_pages?: number | null;
    };
    url: '/api/v1/sources/{source_id}/metric_page_predictions';
};

export type GetMetricPagePredictionsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetMetricPagePredictionsError = GetMetricPagePredictionsErrors[keyof GetMetricPagePredictionsErrors];

export type GetMetricPagePredictionsResponses = {
    /**
     * Successful Response
     */
    200: TopPagesResponse;
};

export type GetMetricPagePredictionsResponse = GetMetricPagePredictionsResponses[keyof GetMetricPagePredictionsResponses];

export type GetReportTypesConfidenceData = {
    body?: never;
    path: {
        /**
         * Metric Id
         */
        metric_id: string;
    };
    query?: never;
    url: '/api/v1/sources/report_types_confidence/{metric_id}';
};

export type GetReportTypesConfidenceErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetReportTypesConfidenceError = GetReportTypesConfidenceErrors[keyof GetReportTypesConfidenceErrors];

export type GetReportTypesConfidenceResponses = {
    /**
     * Response Get Report Types Confidence
     *
     * Successful Response
     */
    200: {
        [key in ReportTypes]?: number;
    };
};

export type GetReportTypesConfidenceResponse = GetReportTypesConfidenceResponses[keyof GetReportTypesConfidenceResponses];

export type DeleteSnapshotData = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: number;
    };
    query?: never;
    url: '/api/v1/snapshots/{snapshot_id}';
};

export type DeleteSnapshotErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteSnapshotError = DeleteSnapshotErrors[keyof DeleteSnapshotErrors];

export type DeleteSnapshotResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSnapshotWithHoldingsData = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: number;
    };
    query?: never;
    url: '/api/v1/snapshots/{snapshot_id}';
};

export type GetSnapshotWithHoldingsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSnapshotWithHoldingsError = GetSnapshotWithHoldingsErrors[keyof GetSnapshotWithHoldingsErrors];

export type GetSnapshotWithHoldingsResponses = {
    /**
     * Successful Response
     */
    200: PortfolioWithCoverage;
};

export type GetSnapshotWithHoldingsResponse = GetSnapshotWithHoldingsResponses[keyof GetSnapshotWithHoldingsResponses];

export type GetSnapshotWithNumHoldingsData = {
    body?: never;
    path: {
        /**
         * Snapshot Id
         */
        snapshot_id: number;
    };
    query?: never;
    url: '/api/v1/snapshots/{snapshot_id}/num_holdings';
};

export type GetSnapshotWithNumHoldingsErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSnapshotWithNumHoldingsError = GetSnapshotWithNumHoldingsErrors[keyof GetSnapshotWithNumHoldingsErrors];

export type GetSnapshotWithNumHoldingsResponses = {
    /**
     * Successful Response
     */
    200: PortfolioWithNumHoldings;
};

export type GetSnapshotWithNumHoldingsResponse = GetSnapshotWithNumHoldingsResponses[keyof GetSnapshotWithNumHoldingsResponses];

export type GetReportingStandardsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/standards';
};

export type GetReportingStandardsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetReportingStandardsError = GetReportingStandardsErrors[keyof GetReportingStandardsErrors];

export type GetReportingStandardsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseUnionReportingStandardReportingStandardMajorDetails;
};

export type GetReportingStandardsResponse = GetReportingStandardsResponses[keyof GetReportingStandardsResponses];

export type GetCoverageStatsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Page
         */
        page?: number | null;
        /**
         * Limit
         */
        limit?: number | null;
        /**
         * Include Complete
         */
        include_complete?: boolean | null;
        /**
         * Sort By
         */
        sort_by?: Array<string> | null;
        /**
         * Theme
         */
        theme?: string | null;
        /**
         * Fact Count
         */
        fact_count?: number | null;
    };
    url: '/api/v1/stats/coverage';
};

export type GetCoverageStatsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetCoverageStatsError = GetCoverageStatsErrors[keyof GetCoverageStatsErrors];

export type GetCoverageStatsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseCompanyCoverage;
};

export type GetCoverageStatsResponse = GetCoverageStatsResponses[keyof GetCoverageStatsResponses];

export type GetAnalystStatsData = {
    body?: never;
    path: {
        /**
         * Worker Id
         */
        worker_id: string;
    };
    query: {
        theme: Theme;
        step: IngestionTaskStep;
    };
    url: '/api/v1/stats/analysis/{worker_id}';
};

export type GetAnalystStatsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetAnalystStatsError = GetAnalystStatsErrors[keyof GetAnalystStatsErrors];

export type GetAnalystStatsResponses = {
    /**
     * Successful Response
     */
    200: AnalystStats;
};

export type GetAnalystStatsResponse = GetAnalystStatsResponses[keyof GetAnalystStatsResponses];

export type GetOverallStatsData = {
    body?: never;
    path?: never;
    query: {
        theme: Theme;
        step: IngestionTaskStep;
    };
    url: '/api/v1/stats/analysis';
};

export type GetOverallStatsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetOverallStatsError = GetOverallStatsErrors[keyof GetOverallStatsErrors];

export type GetOverallStatsResponses = {
    /**
     * Successful Response
     */
    200: OverallStats;
};

export type GetOverallStatsResponse = GetOverallStatsResponses[keyof GetOverallStatsResponses];

export type GetNextTaskAcrossStepsData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/api/v1/tasks/next';
};

export type GetNextTaskAcrossStepsResponses = {
    /**
     * Response Get Next Task Across Steps
     *
     * Successful Response
     */
    200: HydratedSourceTask | IngestionTask;
    /**
     * No Content
     */
    204: void;
};

export type GetNextTaskAcrossStepsResponse = GetNextTaskAcrossStepsResponses[keyof GetNextTaskAcrossStepsResponses];

export type GetNextTaskData = {
    body?: never;
    path: {
        /**
         * Step
         */
        step: IngestionTaskStep | SourceTaskStep;
    };
    query?: never;
    url: '/api/v1/tasks/next/{step}';
};

export type GetNextTaskErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetNextTaskError = GetNextTaskErrors[keyof GetNextTaskErrors];

export type GetNextTaskResponses = {
    /**
     * Response Get Next Task
     *
     * Successful Response
     */
    200: HydratedSourceTask | IngestionTask;
    /**
     * No Content
     */
    204: void;
};

export type GetNextTaskResponse = GetNextTaskResponses[keyof GetNextTaskResponses];

export type GetIngestionTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: never;
    url: '/api/v1/tasks/ingestion/{task_id}';
};

export type GetIngestionTaskErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetIngestionTaskError = GetIngestionTaskErrors[keyof GetIngestionTaskErrors];

export type GetIngestionTaskResponses = {
    /**
     * Successful Response
     */
    200: IngestionTaskWithFacts;
};

export type GetIngestionTaskResponse = GetIngestionTaskResponses[keyof GetIngestionTaskResponses];

export type SubmitIngestionTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: {
        /**
         * Cannot Progress
         */
        cannot_progress?: boolean;
    };
    url: '/api/v1/tasks/ingestion/{task_id}/submit';
};

export type SubmitIngestionTaskErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type SubmitIngestionTaskError = SubmitIngestionTaskErrors[keyof SubmitIngestionTaskErrors];

export type SubmitIngestionTaskResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromise;
    /**
     * No Content
     */
    204: void;
};

export type SubmitIngestionTaskResponse = SubmitIngestionTaskResponses[keyof SubmitIngestionTaskResponses];

export type AbandonIngestionTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: never;
    url: '/api/v1/tasks/ingestion/{task_id}/abandon';
};

export type AbandonIngestionTaskErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AbandonIngestionTaskError = AbandonIngestionTaskErrors[keyof AbandonIngestionTaskErrors];

export type AbandonIngestionTaskResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AssignIngestionTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
        /**
         * User Id
         */
        user_id: string;
    };
    query?: never;
    url: '/api/v1/tasks/ingestion/{task_id}/assign/{user_id}';
};

export type AssignIngestionTaskErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type AssignIngestionTaskError = AssignIngestionTaskErrors[keyof AssignIngestionTaskErrors];

export type AssignIngestionTaskResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateIngestionTaskElapsedTimeData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
        /**
         * Elapsed
         *
         * Time in seconds to increment task by.
         */
        elapsed: number;
    };
    query?: never;
    url: '/api/v1/tasks/ingestion/{task_id}/update_elapsed/{elapsed}';
};

export type UpdateIngestionTaskElapsedTimeErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateIngestionTaskElapsedTimeError = UpdateIngestionTaskElapsedTimeErrors[keyof UpdateIngestionTaskElapsedTimeErrors];

export type UpdateIngestionTaskElapsedTimeResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type SendIngestionTaskForAutoqaData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: {
        /**
         * Self Assessed
         */
        self_assessed?: boolean;
    };
    url: '/api/v1/tasks/ingestion/{task_id}/autoqa';
};

export type SendIngestionTaskForAutoqaErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SendIngestionTaskForAutoqaError = SendIngestionTaskForAutoqaErrors[keyof SendIngestionTaskForAutoqaErrors];

export type SendIngestionTaskForAutoqaResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type ReturnIngestionTaskToQueueData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: {
        /**
         * Return To User
         */
        return_to_user?: boolean;
    };
    url: '/api/v1/tasks/ingestion/{task_id}/return_to_queue';
};

export type ReturnIngestionTaskToQueueErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type ReturnIngestionTaskToQueueError = ReturnIngestionTaskToQueueErrors[keyof ReturnIngestionTaskToQueueErrors];

export type ReturnIngestionTaskToQueueResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetSourceTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: {
        /**
         * Pdf Only
         */
        pdf_only?: boolean;
    };
    url: '/api/v1/tasks/source/{task_id}';
};

export type GetSourceTaskErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetSourceTaskError = GetSourceTaskErrors[keyof GetSourceTaskErrors];

export type GetSourceTaskResponses = {
    /**
     * Successful Response
     */
    200: HydratedSourceTask;
};

export type GetSourceTaskResponse = GetSourceTaskResponses[keyof GetSourceTaskResponses];

export type SubmitSourceTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: {
        /**
         * Reports Not Out
         */
        reports_not_out?: boolean;
    };
    url: '/api/v1/tasks/source/{task_id}/submit';
};

export type SubmitSourceTaskErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type SubmitSourceTaskError = SubmitSourceTaskErrors[keyof SubmitSourceTaskErrors];

export type SubmitSourceTaskResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type AbandonSourceTaskData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
    };
    query?: never;
    url: '/api/v1/tasks/source/{task_id}/abandon';
};

export type AbandonSourceTaskErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type AbandonSourceTaskError = AbandonSourceTaskErrors[keyof AbandonSourceTaskErrors];

export type AbandonSourceTaskResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type UpdateSourceTaskElapsedTimeData = {
    body?: never;
    path: {
        /**
         * Task Id
         */
        task_id: number;
        /**
         * Elapsed
         *
         * Time in seconds to increment task by.
         */
        elapsed: number;
    };
    query?: never;
    url: '/api/v1/tasks/source/{task_id}/update_elapsed/{elapsed}';
};

export type UpdateSourceTaskElapsedTimeErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateSourceTaskElapsedTimeError = UpdateSourceTaskElapsedTimeErrors[keyof UpdateSourceTaskElapsedTimeErrors];

export type UpdateSourceTaskElapsedTimeResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type CreateIngestionTasksData = {
    body: BodyCreateIngestionTasks;
    path?: never;
    query?: never;
    url: '/api/v1/tasks/ingestion/create_tasks';
};

export type CreateIngestionTasksErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateIngestionTasksError = CreateIngestionTasksErrors[keyof CreateIngestionTasksErrors];

export type CreateIngestionTasksResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type CreateSourceTasksData = {
    body: BodyCreateSourceTasks;
    path?: never;
    query?: {
        /**
         * Verify Only
         */
        verify_only?: boolean;
    };
    url: '/api/v1/tasks/source/create_tasks';
};

export type CreateSourceTasksErrors = {
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type CreateSourceTasksError = CreateSourceTasksErrors[keyof CreateSourceTasksErrors];

export type CreateSourceTasksResponses = {
    /**
     * Successful Response
     */
    200: AsyncResultPromise;
};

export type CreateSourceTasksResponse = CreateSourceTasksResponses[keyof CreateSourceTasksResponses];

export type ListUnitsData = {
    body?: never;
    path?: never;
    query?: {
        /**
         * Q
         */
        q?: string;
    };
    url: '/api/v1/units';
};

export type ListUnitsErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type ListUnitsError = ListUnitsErrors[keyof ListUnitsErrors];

export type ListUnitsResponses = {
    /**
     * Successful Response
     */
    200: PaginatedResponseUnit;
};

export type ListUnitsResponse = ListUnitsResponses[keyof ListUnitsResponses];

export type CreateUnitData = {
    body: CreateUnit;
    path?: never;
    query?: never;
    url: '/api/v1/units';
};

export type CreateUnitErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type CreateUnitError = CreateUnitErrors[keyof CreateUnitErrors];

export type CreateUnitResponses = {
    /**
     * Successful Response
     */
    201: Unit;
};

export type CreateUnitResponse = CreateUnitResponses[keyof CreateUnitResponses];

export type ConvertUnitData = {
    body?: never;
    path?: never;
    query: {
        /**
         * Value
         */
        value: number;
        /**
         * In Unit Id
         */
        in_unit_id?: number | null;
        /**
         * In Unit Name
         */
        in_unit_name?: string | null;
        /**
         * Out Unit Name
         */
        out_unit_name?: string | null;
        /**
         * Out Unit Id
         */
        out_unit_id?: number | null;
        /**
         * Conversion Date
         */
        conversion_date?: string | null;
    };
    url: '/api/v1/units/convert_unit';
};

export type ConvertUnitErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Unprocessable Content
     */
    422: Message;
};

export type ConvertUnitError = ConvertUnitErrors[keyof ConvertUnitErrors];

export type ConvertUnitResponses = {
    /**
     * Response Convert Unit
     *
     * Successful Response
     */
    200: CurrencyValue | Value;
};

export type ConvertUnitResponse = ConvertUnitResponses[keyof ConvertUnitResponses];

export type DeleteUnitData = {
    body?: never;
    path: {
        /**
         * Instance Id
         */
        instance_id: number;
    };
    query?: never;
    url: '/api/v1/units/{instance_id}';
};

export type DeleteUnitErrors = {
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type DeleteUnitError = DeleteUnitErrors[keyof DeleteUnitErrors];

export type DeleteUnitResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type GetUnitData = {
    body?: never;
    path: {
        /**
         * Instance Id
         */
        instance_id: number;
    };
    query?: never;
    url: '/api/v1/units/{instance_id}';
};

export type GetUnitErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type GetUnitError = GetUnitErrors[keyof GetUnitErrors];

export type GetUnitResponses = {
    /**
     * Successful Response
     */
    200: Unit;
};

export type GetUnitResponse = GetUnitResponses[keyof GetUnitResponses];

export type UpdateUnitData = {
    /**
     * Data
     */
    body: {
        [key: string]: unknown;
    };
    path: {
        /**
         * Instance Id
         */
        instance_id: number;
    };
    query?: never;
    url: '/api/v1/units/{instance_id}';
};

export type UpdateUnitErrors = {
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type UpdateUnitError = UpdateUnitErrors[keyof UpdateUnitErrors];

export type UpdateUnitResponses = {
    /**
     * Successful Response
     */
    200: Unit;
};

export type UpdateUnitResponse = UpdateUnitResponses[keyof UpdateUnitResponses];

export type MergeUnitsData = {
    body: MergeTwoRecords;
    path?: never;
    query?: never;
    url: '/api/v1/units/merge';
};

export type MergeUnitsErrors = {
    /**
     * Forbidden
     */
    403: Message;
    /**
     * Not Found
     */
    404: Message;
    /**
     * Validation Error
     */
    422: HttpValidationError;
};

export type MergeUnitsError = MergeUnitsErrors[keyof MergeUnitsErrors];

export type MergeUnitsResponses = {
    /**
     * Successful Response
     */
    200: Unit;
};

export type MergeUnitsResponse = MergeUnitsResponses[keyof MergeUnitsResponses];

export type HealthCheckHealthyGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/healthy';
};

export type HealthCheckHealthyGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};

export type DeliberateErrorKaboomGetData = {
    body?: never;
    path?: never;
    query?: never;
    url: '/kaboom';
};

export type DeliberateErrorKaboomGetResponses = {
    /**
     * Successful Response
     */
    200: unknown;
};
